/**
 * Swiper 4.3.5
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://www.idangero.us/swiper/
 *
 * Copyright 2014-2018 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: July 31, 2018
 */
! function(e, t) {
	"object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : e.Swiper = t()
}(this, function() {
	"use strict";
	var f = "undefined" == typeof document ? {
			body: {},
			addEventListener: function() {},
			removeEventListener: function() {},
			activeElement: {
				blur: function() {},
				nodeName: ""
			},
			querySelector: function() {
				return null
			},
			querySelectorAll: function() {
				return []
			},
			getElementById: function() {
				return null
			},
			createEvent: function() {
				return {
					initEvent: function() {}
				}
			},
			createElement: function() {
				return {
					children: [],
					childNodes: [],
					style: {},
					setAttribute: function() {},
					getElementsByTagName: function() {
						return []
					}
				}
			},
			location: {
				hash: ""
			}
		} : document,
		B = "undefined" == typeof window ? {
			document: f,
			navigator: {
				userAgent: ""
			},
			location: {},
			history: {},
			CustomEvent: function() {
				return this
			},
			addEventListener: function() {},
			removeEventListener: function() {},
			getComputedStyle: function() {
				return {
					getPropertyValue: function() {
						return ""
					}
				}
			},
			Image: function() {},
			Date: function() {},
			screen: {},
			setTimeout: function() {},
			clearTimeout: function() {}
		} : window,
		l = function(e) {
			for (var t = 0; t < e.length; t += 1) this[t] = e[t];
			return this.length = e.length, this
		};

	function L(e, t) {
		var a = [],
			i = 0;
		if (e && !t && e instanceof l) return e;
		if (e)
			if ("string" == typeof e) {
				var s, r, n = e.trim();
				if (0 <= n.indexOf("<") && 0 <= n.indexOf(">")) {
					var o = "div";
					for (0 === n.indexOf("<li") && (o = "ul"), 0 === n.indexOf("<tr") && (o = "tbody"), 0 !== n.indexOf("<td") && 0 !== n.indexOf("<th") || (o = "tr"), 0 === n.indexOf("<tbody") && (o = "table"), 0 === n.indexOf("<option") && (o = "select"), (r = f.createElement(o)).innerHTML = n, i = 0; i < r.childNodes.length; i += 1) a.push(r.childNodes[i])
				} else
					for (s = t || "#" !== e[0] || e.match(/[ .<>:~]/) ? (t || f).querySelectorAll(e.trim()) : [f.getElementById(e.trim().split("#")[1])], i = 0; i < s.length; i += 1) s[i] && a.push(s[i])
			} else if (e.nodeType || e === B || e === f) a.push(e);
		else if (0 < e.length && e[0].nodeType)
			for (i = 0; i < e.length; i += 1) a.push(e[i]);
		return new l(a)
	}

	function r(e) {
		for (var t = [], a = 0; a < e.length; a += 1) - 1 === t.indexOf(e[a]) && t.push(e[a]);
		return t
	}
	L.fn = l.prototype, L.Class = l, L.Dom7 = l;
	var t = {
		addClass: function(e) {
			if (void 0 === e) return this;
			for (var t = e.split(" "), a = 0; a < t.length; a += 1)
				for (var i = 0; i < this.length; i += 1) void 0 !== this[i] && void 0 !== this[i].classList && this[i].classList.add(t[a]);
			return this
		},
		removeClass: function(e) {
			for (var t = e.split(" "), a = 0; a < t.length; a += 1)
				for (var i = 0; i < this.length; i += 1) void 0 !== this[i] && void 0 !== this[i].classList && this[i].classList.remove(t[a]);
			return this
		},
		hasClass: function(e) {
			return !!this[0] && this[0].classList.contains(e)
		},
		toggleClass: function(e) {
			for (var t = e.split(" "), a = 0; a < t.length; a += 1)
				for (var i = 0; i < this.length; i += 1) void 0 !== this[i] && void 0 !== this[i].classList && this[i].classList.toggle(t[a]);
			return this
		},
		attr: function(e, t) {
			var a = arguments;
			if (1 === arguments.length && "string" == typeof e) return this[0] ? this[0].getAttribute(e) : void 0;
			for (var i = 0; i < this.length; i += 1)
				if (2 === a.length) this[i].setAttribute(e, t);
				else
					for (var s in e) this[i][s] = e[s], this[i].setAttribute(s, e[s]);
			return this
		},
		removeAttr: function(e) {
			for (var t = 0; t < this.length; t += 1) this[t].removeAttribute(e);
			return this
		},
		data: function(e, t) {
			var a;
			if (void 0 !== t) {
				for (var i = 0; i < this.length; i += 1)(a = this[i]).dom7ElementDataStorage || (a.dom7ElementDataStorage = {}), a.dom7ElementDataStorage[e] = t;
				return this
			}
			if (a = this[0]) {
				if (a.dom7ElementDataStorage && e in a.dom7ElementDataStorage) return a.dom7ElementDataStorage[e];
				var s = a.getAttribute("data-" + e);
				return s || void 0
			}
		},
		transform: function(e) {
			for (var t = 0; t < this.length; t += 1) {
				var a = this[t].style;
				a.webkitTransform = e, a.transform = e
			}
			return this
		},
		transition: function(e) {
			"string" != typeof e && (e += "ms");
			for (var t = 0; t < this.length; t += 1) {
				var a = this[t].style;
				a.webkitTransitionDuration = e, a.transitionDuration = e
			}
			return this
		},
		on: function() {
			for (var e, t = [], a = arguments.length; a--;) t[a] = arguments[a];
			var i = t[0],
				r = t[1],
				n = t[2],
				s = t[3];

			function o(e) {
				var t = e.target;
				if (t) {
					var a = e.target.dom7EventData || [];
					if (a.indexOf(e) < 0 && a.unshift(e), L(t).is(r)) n.apply(t, a);
					else
						for (var i = L(t).parents(), s = 0; s < i.length; s += 1) L(i[s]).is(r) && n.apply(i[s], a)
				}
			}

			function l(e) {
				var t = e && e.target && e.target.dom7EventData || [];
				t.indexOf(e) < 0 && t.unshift(e), n.apply(this, t)
			}
			"function" == typeof t[1] && (i = (e = t)[0], n = e[1], s = e[2], r = void 0), s || (s = !1);
			for (var d, p = i.split(" "), c = 0; c < this.length; c += 1) {
				var u = this[c];
				if (r)
					for (d = 0; d < p.length; d += 1) {
						var h = p[d];
						u.dom7LiveListeners || (u.dom7LiveListeners = {}), u.dom7LiveListeners[h] || (u.dom7LiveListeners[h] = []), u.dom7LiveListeners[h].push({
							listener: n,
							proxyListener: o
						}), u.addEventListener(h, o, s)
					} else
						for (d = 0; d < p.length; d += 1) {
							var v = p[d];
							u.dom7Listeners || (u.dom7Listeners = {}), u.dom7Listeners[v] || (u.dom7Listeners[v] = []), u.dom7Listeners[v].push({
								listener: n,
								proxyListener: l
							}), u.addEventListener(v, l, s)
						}
			}
			return this
		},
		off: function() {
			for (var e, t = [], a = arguments.length; a--;) t[a] = arguments[a];
			var i = t[0],
				s = t[1],
				r = t[2],
				n = t[3];
			"function" == typeof t[1] && (i = (e = t)[0], r = e[1], n = e[2], s = void 0), n || (n = !1);
			for (var o = i.split(" "), l = 0; l < o.length; l += 1)
				for (var d = o[l], p = 0; p < this.length; p += 1) {
					var c = this[p],
						u = void 0;
					if (!s && c.dom7Listeners ? u = c.dom7Listeners[d] : s && c.dom7LiveListeners && (u = c.dom7LiveListeners[d]), u && u.length)
						for (var h = u.length - 1; 0 <= h; h -= 1) {
							var v = u[h];
							r && v.listener === r ? (c.removeEventListener(d, v.proxyListener, n), u.splice(h, 1)) : r || (c.removeEventListener(d, v.proxyListener, n), u.splice(h, 1))
						}
				}
			return this
		},
		trigger: function() {
			for (var e = [], t = arguments.length; t--;) e[t] = arguments[t];
			for (var a = e[0].split(" "), i = e[1], s = 0; s < a.length; s += 1)
				for (var r = a[s], n = 0; n < this.length; n += 1) {
					var o = this[n],
						l = void 0;
					try {
						l = new B.CustomEvent(r, {
							detail: i,
							bubbles: !0,
							cancelable: !0
						})
					} catch (e) {
						(l = f.createEvent("Event")).initEvent(r, !0, !0), l.detail = i
					}
					o.dom7EventData = e.filter(function(e, t) {
						return 0 < t
					}), o.dispatchEvent(l), o.dom7EventData = [], delete o.dom7EventData
				}
			return this
		},
		transitionEnd: function(t) {
			var a, i = ["webkitTransitionEnd", "transitionend"],
				s = this;

			function r(e) {
				if (e.target === this)
					for (t.call(this, e), a = 0; a < i.length; a += 1) s.off(i[a], r)
			}
			if (t)
				for (a = 0; a < i.length; a += 1) s.on(i[a], r);
			return this
		},
		outerWidth: function(e) {
			if (0 < this.length) {
				if (e) {
					var t = this.styles();
					return this[0].offsetWidth + parseFloat(t.getPropertyValue("margin-right")) + parseFloat(t.getPropertyValue("margin-left"))
				}
				return this[0].offsetWidth
			}
			return null
		},
		outerHeight: function(e) {
			if (0 < this.length) {
				if (e) {
					var t = this.styles();
					return this[0].offsetHeight + parseFloat(t.getPropertyValue("margin-top")) + parseFloat(t.getPropertyValue("margin-bottom"))
				}
				return this[0].offsetHeight
			}
			return null
		},
		offset: function() {
			if (0 < this.length) {
				var e = this[0],
					t = e.getBoundingClientRect(),
					a = f.body,
					i = e.clientTop || a.clientTop || 0,
					s = e.clientLeft || a.clientLeft || 0,
					r = e === B ? B.scrollY : e.scrollTop,
					n = e === B ? B.scrollX : e.scrollLeft;
				return {
					top: t.top + r - i,
					left: t.left + n - s
				}
			}
			return null
		},
		css: function(e, t) {
			var a;
			if (1 === arguments.length) {
				if ("string" != typeof e) {
					for (a = 0; a < this.length; a += 1)
						for (var i in e) this[a].style[i] = e[i];
					return this
				}
				if (this[0]) return B.getComputedStyle(this[0], null).getPropertyValue(e)
			}
			if (2 === arguments.length && "string" == typeof e) {
				for (a = 0; a < this.length; a += 1) this[a].style[e] = t;
				return this
			}
			return this
		},
		each: function(e) {
			if (!e) return this;
			for (var t = 0; t < this.length; t += 1)
				if (!1 === e.call(this[t], t, this[t])) return this;
			return this
		},
		html: function(e) {
			if (void 0 === e) return this[0] ? this[0].innerHTML : void 0;
			for (var t = 0; t < this.length; t += 1) this[t].innerHTML = e;
			return this
		},
		text: function(e) {
			if (void 0 === e) return this[0] ? this[0].textContent.trim() : null;
			for (var t = 0; t < this.length; t += 1) this[t].textContent = e;
			return this
		},
		is: function(e) {
			var t, a, i = this[0];
			if (!i || void 0 === e) return !1;
			if ("string" == typeof e) {
				if (i.matches) return i.matches(e);
				if (i.webkitMatchesSelector) return i.webkitMatchesSelector(e);
				if (i.msMatchesSelector) return i.msMatchesSelector(e);
				for (t = L(e), a = 0; a < t.length; a += 1)
					if (t[a] === i) return !0;
				return !1
			}
			if (e === f) return i === f;
			if (e === B) return i === B;
			if (e.nodeType || e instanceof l) {
				for (t = e.nodeType ? [e] : e, a = 0; a < t.length; a += 1)
					if (t[a] === i) return !0;
				return !1
			}
			return !1
		},
		index: function() {
			var e, t = this[0];
			if (t) {
				for (e = 0; null !== (t = t.previousSibling);) 1 === t.nodeType && (e += 1);
				return e
			}
		},
		eq: function(e) {
			if (void 0 === e) return this;
			var t, a = this.length;
			return new l(a - 1 < e ? [] : e < 0 ? (t = a + e) < 0 ? [] : [this[t]] : [this[e]])
		},
		append: function() {
			for (var e, t = [], a = arguments.length; a--;) t[a] = arguments[a];
			for (var i = 0; i < t.length; i += 1) {
				e = t[i];
				for (var s = 0; s < this.length; s += 1)
					if ("string" == typeof e) {
						var r = f.createElement("div");
						for (r.innerHTML = e; r.firstChild;) this[s].appendChild(r.firstChild)
					} else if (e instanceof l)
					for (var n = 0; n < e.length; n += 1) this[s].appendChild(e[n]);
				else this[s].appendChild(e)
			}
			return this
		},
		prepend: function(e) {
			var t, a, i = this;
			for (t = 0; t < this.length; t += 1)
				if ("string" == typeof e) {
					var s = f.createElement("div");
					for (s.innerHTML = e, a = s.childNodes.length - 1; 0 <= a; a -= 1) i[t].insertBefore(s.childNodes[a], i[t].childNodes[0])
				} else if (e instanceof l)
				for (a = 0; a < e.length; a += 1) i[t].insertBefore(e[a], i[t].childNodes[0]);
			else i[t].insertBefore(e, i[t].childNodes[0]);
			return this
		},
		next: function(e) {
			return 0 < this.length ? e ? this[0].nextElementSibling && L(this[0].nextElementSibling).is(e) ? new l([this[0].nextElementSibling]) : new l([]) : this[0].nextElementSibling ? new l([this[0].nextElementSibling]) : new l([]) : new l([])
		},
		nextAll: function(e) {
			var t = [],
				a = this[0];
			if (!a) return new l([]);
			for (; a.nextElementSibling;) {
				var i = a.nextElementSibling;
				e ? L(i).is(e) && t.push(i) : t.push(i), a = i
			}
			return new l(t)
		},
		prev: function(e) {
			if (0 < this.length) {
				var t = this[0];
				return e ? t.previousElementSibling && L(t.previousElementSibling).is(e) ? new l([t.previousElementSibling]) : new l([]) : t.previousElementSibling ? new l([t.previousElementSibling]) : new l([])
			}
			return new l([])
		},
		prevAll: function(e) {
			var t = [],
				a = this[0];
			if (!a) return new l([]);
			for (; a.previousElementSibling;) {
				var i = a.previousElementSibling;
				e ? L(i).is(e) && t.push(i) : t.push(i), a = i
			}
			return new l(t)
		},
		parent: function(e) {
			for (var t = [], a = 0; a < this.length; a += 1) null !== this[a].parentNode && (e ? L(this[a].parentNode).is(e) && t.push(this[a].parentNode) : t.push(this[a].parentNode));
			return L(r(t))
		},
		parents: function(e) {
			for (var t = [], a = 0; a < this.length; a += 1)
				for (var i = this[a].parentNode; i;) e ? L(i).is(e) && t.push(i) : t.push(i), i = i.parentNode;
			return L(r(t))
		},
		closest: function(e) {
			var t = this;
			return void 0 === e ? new l([]) : (t.is(e) || (t = t.parents(e).eq(0)), t)
		},
		find: function(e) {
			for (var t = [], a = 0; a < this.length; a += 1)
				for (var i = this[a].querySelectorAll(e), s = 0; s < i.length; s += 1) t.push(i[s]);
			return new l(t)
		},
		children: function(e) {
			for (var t = [], a = 0; a < this.length; a += 1)
				for (var i = this[a].childNodes, s = 0; s < i.length; s += 1) e ? 1 === i[s].nodeType && L(i[s]).is(e) && t.push(i[s]) : 1 === i[s].nodeType && t.push(i[s]);
			return new l(r(t))
		},
		remove: function() {
			for (var e = 0; e < this.length; e += 1) this[e].parentNode && this[e].parentNode.removeChild(this[e]);
			return this
		},
		add: function() {
			for (var e = [], t = arguments.length; t--;) e[t] = arguments[t];
			var a, i;
			for (a = 0; a < e.length; a += 1) {
				var s = L(e[a]);
				for (i = 0; i < s.length; i += 1) this[this.length] = s[i], this.length += 1
			}
			return this
		},
		styles: function() {
			return this[0] ? B.getComputedStyle(this[0], null) : {}
		}
	};
	Object.keys(t).forEach(function(e) {
		L.fn[e] = t[e]
	});
	var e, a, i, X = {
			deleteProps: function(e) {
				var t = e;
				Object.keys(t).forEach(function(e) {
					try {
						t[e] = null
					} catch (e) {}
					try {
						delete t[e]
					} catch (e) {}
				})
			},
			nextTick: function(e, t) {
				return void 0 === t && (t = 0), setTimeout(e, t)
			},
			now: function() {
				return Date.now()
			},
			getTranslate: function(e, t) {
				var a, i, s;
				void 0 === t && (t = "x");
				var r = B.getComputedStyle(e, null);
				return B.WebKitCSSMatrix ? (6 < (i = r.transform || r.webkitTransform).split(",").length && (i = i.split(", ").map(function(e) {
					return e.replace(",", ".")
				}).join(", ")), s = new B.WebKitCSSMatrix("none" === i ? "" : i)) : a = (s = r.MozTransform || r.OTransform || r.MsTransform || r.msTransform || r.transform || r.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,")).toString().split(","), "x" === t && (i = B.WebKitCSSMatrix ? s.m41 : 16 === a.length ? parseFloat(a[12]) : parseFloat(a[4])), "y" === t && (i = B.WebKitCSSMatrix ? s.m42 : 16 === a.length ? parseFloat(a[13]) : parseFloat(a[5])), i || 0
			},
			parseUrlQuery: function(e) {
				var t, a, i, s, r = {},
					n = e || B.location.href;
				if ("string" == typeof n && n.length)
					for (s = (a = (n = -1 < n.indexOf("?") ? n.replace(/\S*\?/, "") : "").split("&").filter(function(e) {
							return "" !== e
						})).length, t = 0; t < s; t += 1) i = a[t].replace(/#\S+/g, "").split("="), r[decodeURIComponent(i[0])] = void 0 === i[1] ? void 0 : decodeURIComponent(i[1]) || "";
				return r
			},
			isObject: function(e) {
				return "object" == typeof e && null !== e && e.constructor && e.constructor === Object
			},
			extend: function() {
				for (var e = [], t = arguments.length; t--;) e[t] = arguments[t];
				for (var a = Object(e[0]), i = 1; i < e.length; i += 1) {
					var s = e[i];
					if (null != s)
						for (var r = Object.keys(Object(s)), n = 0, o = r.length; n < o; n += 1) {
							var l = r[n],
								d = Object.getOwnPropertyDescriptor(s, l);
							void 0 !== d && d.enumerable && (X.isObject(a[l]) && X.isObject(s[l]) ? X.extend(a[l], s[l]) : !X.isObject(a[l]) && X.isObject(s[l]) ? (a[l] = {}, X.extend(a[l], s[l])) : a[l] = s[l])
						}
				}
				return a
			}
		},
		Y = (i = f.createElement("div"), {
			touch: B.Modernizr && !0 === B.Modernizr.touch || !!("ontouchstart" in B || B.DocumentTouch && f instanceof B.DocumentTouch),
			pointerEvents: !(!B.navigator.pointerEnabled && !B.PointerEvent),
			prefixedPointerEvents: !!B.navigator.msPointerEnabled,
			transition: (a = i.style, "transition" in a || "webkitTransition" in a || "MozTransition" in a),
			transforms3d: B.Modernizr && !0 === B.Modernizr.csstransforms3d || (e = i.style, "webkitPerspective" in e || "MozPerspective" in e || "OPerspective" in e || "MsPerspective" in e || "perspective" in e),
			flexbox: function() {
				for (var e = i.style, t = "alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient".split(" "), a = 0; a < t.length; a += 1)
					if (t[a] in e) return !0;
				return !1
			}(),
			observer: "MutationObserver" in B || "WebkitMutationObserver" in B,
			passiveListener: function() {
				var e = !1;
				try {
					var t = Object.defineProperty({}, "passive", {
						get: function() {
							e = !0
						}
					});
					B.addEventListener("testPassiveListener", null, t)
				} catch (e) {}
				return e
			}(),
			gestures: "ongesturestart" in B
		}),
		s = function(e) {
			void 0 === e && (e = {});
			var t = this;
			t.params = e, t.eventsListeners = {}, t.params && t.params.on && Object.keys(t.params.on).forEach(function(e) {
				t.on(e, t.params.on[e])
			})
		},
		n = {
			components: {
				configurable: !0
			}
		};
	s.prototype.on = function(e, t, a) {
		var i = this;
		if ("function" != typeof t) return i;
		var s = a ? "unshift" : "push";
		return e.split(" ").forEach(function(e) {
			i.eventsListeners[e] || (i.eventsListeners[e] = []), i.eventsListeners[e][s](t)
		}), i
	}, s.prototype.once = function(i, s, e) {
		var r = this;
		if ("function" != typeof s) return r;
		return r.on(i, function e() {
			for (var t = [], a = arguments.length; a--;) t[a] = arguments[a];
			s.apply(r, t), r.off(i, e)
		}, e)
	}, s.prototype.off = function(e, i) {
		var s = this;
		return s.eventsListeners && e.split(" ").forEach(function(a) {
			void 0 === i ? s.eventsListeners[a] = [] : s.eventsListeners[a].forEach(function(e, t) {
				e === i && s.eventsListeners[a].splice(t, 1)
			})
		}), s
	}, s.prototype.emit = function() {
		for (var e = [], t = arguments.length; t--;) e[t] = arguments[t];
		var a, i, s, r = this;
		return r.eventsListeners && ("string" == typeof e[0] || Array.isArray(e[0]) ? (a = e[0], i = e.slice(1, e.length), s = r) : (a = e[0].events, i = e[0].data, s = e[0].context || r), (Array.isArray(a) ? a : a.split(" ")).forEach(function(e) {
			if (r.eventsListeners && r.eventsListeners[e]) {
				var t = [];
				r.eventsListeners[e].forEach(function(e) {
					t.push(e)
				}), t.forEach(function(e) {
					e.apply(s, i)
				})
			}
		})), r
	}, s.prototype.useModulesParams = function(a) {
		var i = this;
		i.modules && Object.keys(i.modules).forEach(function(e) {
			var t = i.modules[e];
			t.params && X.extend(a, t.params)
		})
	}, s.prototype.useModules = function(i) {
		void 0 === i && (i = {});
		var s = this;
		s.modules && Object.keys(s.modules).forEach(function(e) {
			var a = s.modules[e],
				t = i[e] || {};
			a.instance && Object.keys(a.instance).forEach(function(e) {
				var t = a.instance[e];
				s[e] = "function" == typeof t ? t.bind(s) : t
			}), a.on && s.on && Object.keys(a.on).forEach(function(e) {
				s.on(e, a.on[e])
			}), a.create && a.create.bind(s)(t)
		})
	}, n.components.set = function(e) {
		this.use && this.use(e)
	}, s.installModule = function(t) {
		for (var e = [], a = arguments.length - 1; 0 < a--;) e[a] = arguments[a + 1];
		var i = this;
		i.prototype.modules || (i.prototype.modules = {});
		var s = t.name || Object.keys(i.prototype.modules).length + "_" + X.now();
		return (i.prototype.modules[s] = t).proto && Object.keys(t.proto).forEach(function(e) {
			i.prototype[e] = t.proto[e]
		}), t.static && Object.keys(t.static).forEach(function(e) {
			i[e] = t.static[e]
		}), t.install && t.install.apply(i, e), i
	}, s.use = function(e) {
		for (var t = [], a = arguments.length - 1; 0 < a--;) t[a] = arguments[a + 1];
		var i = this;
		return Array.isArray(e) ? (e.forEach(function(e) {
			return i.installModule(e)
		}), i) : i.installModule.apply(i, [e].concat(t))
	}, Object.defineProperties(s, n);
	var o = {
		updateSize: function() {
			var e, t, a = this,
				i = a.$el;
			e = void 0 !== a.params.width ? a.params.width : i[0].clientWidth, t = void 0 !== a.params.height ? a.params.height : i[0].clientHeight, 0 === e && a.isHorizontal() || 0 === t && a.isVertical() || (e = e - parseInt(i.css("padding-left"), 10) - parseInt(i.css("padding-right"), 10), t = t - parseInt(i.css("padding-top"), 10) - parseInt(i.css("padding-bottom"), 10), X.extend(a, {
				width: e,
				height: t,
				size: a.isHorizontal() ? e : t
			}))
		},
		updateSlides: function() {
			var e = this,
				t = e.params,
				a = e.$wrapperEl,
				i = e.size,
				s = e.rtlTranslate,
				r = e.wrongRTL,
				n = e.virtual && t.virtual.enabled,
				o = n ? e.virtual.slides.length : e.slides.length,
				l = a.children("." + e.params.slideClass),
				d = n ? e.virtual.slides.length : l.length,
				p = [],
				c = [],
				u = [],
				h = t.slidesOffsetBefore;
			"function" == typeof h && (h = t.slidesOffsetBefore.call(e));
			var v = t.slidesOffsetAfter;
			"function" == typeof v && (v = t.slidesOffsetAfter.call(e));
			var f = e.snapGrid.length,
				m = e.snapGrid.length,
				g = t.spaceBetween,
				b = -h,
				w = 0,
				y = 0;
			if (void 0 !== i) {
				var x, E;
				"string" == typeof g && 0 <= g.indexOf("%") && (g = parseFloat(g.replace("%", "")) / 100 * i), e.virtualSize = -g, s ? l.css({
					marginLeft: "",
					marginTop: ""
				}) : l.css({
					marginRight: "",
					marginBottom: ""
				}), 1 < t.slidesPerColumn && (x = Math.floor(d / t.slidesPerColumn) === d / e.params.slidesPerColumn ? d : Math.ceil(d / t.slidesPerColumn) * t.slidesPerColumn, "auto" !== t.slidesPerView && "row" === t.slidesPerColumnFill && (x = Math.max(x, t.slidesPerView * t.slidesPerColumn)));
				for (var T, S = t.slidesPerColumn, C = x / S, M = C - (t.slidesPerColumn * C - d), z = 0; z < d; z += 1) {
					E = 0;
					var k = l.eq(z);
					if (1 < t.slidesPerColumn) {
						var P = void 0,
							$ = void 0,
							L = void 0;
						"column" === t.slidesPerColumnFill ? (L = z - ($ = Math.floor(z / S)) * S, (M < $ || $ === M && L === S - 1) && S <= (L += 1) && (L = 0, $ += 1), P = $ + L * x / S, k.css({
							"-webkit-box-ordinal-group": P,
							"-moz-box-ordinal-group": P,
							"-ms-flex-order": P,
							"-webkit-order": P,
							order: P
						})) : $ = z - (L = Math.floor(z / C)) * C, k.css("margin-" + (e.isHorizontal() ? "top" : "left"), 0 !== L && t.spaceBetween && t.spaceBetween + "px").attr("data-swiper-column", $).attr("data-swiper-row", L)
					}
					if ("none" !== k.css("display")) {
						if ("auto" === t.slidesPerView) {
							var I = B.getComputedStyle(k[0], null),
								D = k[0].style.transform,
								O = k[0].style.webkitTransform;
							D && (k[0].style.transform = "none"), O && (k[0].style.webkitTransform = "none"), E = e.isHorizontal() ? k[0].getBoundingClientRect().width + parseFloat(I.getPropertyValue("margin-left")) + parseFloat(I.getPropertyValue("margin-right")) : k[0].getBoundingClientRect().height + parseFloat(I.getPropertyValue("margin-top")) + parseFloat(I.getPropertyValue("margin-bottom")), D && (k[0].style.transform = D), O && (k[0].style.webkitTransform = O), t.roundLengths && (E = Math.floor(E))
						} else E = (i - (t.slidesPerView - 1) * g) / t.slidesPerView, t.roundLengths && (E = Math.floor(E)), l[z] && (e.isHorizontal() ? l[z].style.width = E + "px" : l[z].style.height = E + "px");
						l[z] && (l[z].swiperSlideSize = E), u.push(E), t.centeredSlides ? (b = b + E / 2 + w / 2 + g, 0 === w && 0 !== z && (b = b - i / 2 - g), 0 === z && (b = b - i / 2 - g), Math.abs(b) < .001 && (b = 0), t.roundLengths && (b = Math.floor(b)), y % t.slidesPerGroup == 0 && p.push(b), c.push(b)) : (t.roundLengths && (b = Math.floor(b)), y % t.slidesPerGroup == 0 && p.push(b), c.push(b), b = b + E + g), e.virtualSize += E + g, w = E, y += 1
					}
				}
				if (e.virtualSize = Math.max(e.virtualSize, i) + v, s && r && ("slide" === t.effect || "coverflow" === t.effect) && a.css({
						width: e.virtualSize + t.spaceBetween + "px"
					}), Y.flexbox && !t.setWrapperSize || (e.isHorizontal() ? a.css({
						width: e.virtualSize + t.spaceBetween + "px"
					}) : a.css({
						height: e.virtualSize + t.spaceBetween + "px"
					})), 1 < t.slidesPerColumn && (e.virtualSize = (E + t.spaceBetween) * x, e.virtualSize = Math.ceil(e.virtualSize / t.slidesPerColumn) - t.spaceBetween, e.isHorizontal() ? a.css({
						width: e.virtualSize + t.spaceBetween + "px"
					}) : a.css({
						height: e.virtualSize + t.spaceBetween + "px"
					}), t.centeredSlides)) {
					T = [];
					for (var A = 0; A < p.length; A += 1) {
						var H = p[A];
						t.roundLengths && (H = Math.floor(H)), p[A] < e.virtualSize + p[0] && T.push(H)
					}
					p = T
				}
				if (!t.centeredSlides) {
					T = [];
					for (var G = 0; G < p.length; G += 1) {
						var N = p[G];
						t.roundLengths && (N = Math.floor(N)), p[G] <= e.virtualSize - i && T.push(N)
					}
					p = T, 1 < Math.floor(e.virtualSize - i) - Math.floor(p[p.length - 1]) && p.push(e.virtualSize - i)
				}
				0 === p.length && (p = [0]), 0 !== t.spaceBetween && (e.isHorizontal() ? s ? l.css({
					marginLeft: g + "px"
				}) : l.css({
					marginRight: g + "px"
				}) : l.css({
					marginBottom: g + "px"
				})), X.extend(e, {
					slides: l,
					snapGrid: p,
					slidesGrid: c,
					slidesSizesGrid: u
				}), d !== o && e.emit("slidesLengthChange"), p.length !== f && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")), c.length !== m && e.emit("slidesGridLengthChange"), (t.watchSlidesProgress || t.watchSlidesVisibility) && e.updateSlidesOffset()
			}
		},
		updateAutoHeight: function(e) {
			var t, a = this,
				i = [],
				s = 0;
			if ("number" == typeof e ? a.setTransition(e) : !0 === e && a.setTransition(a.params.speed), "auto" !== a.params.slidesPerView && 1 < a.params.slidesPerView)
				for (t = 0; t < Math.ceil(a.params.slidesPerView); t += 1) {
					var r = a.activeIndex + t;
					if (r > a.slides.length) break;
					i.push(a.slides.eq(r)[0])
				} else i.push(a.slides.eq(a.activeIndex)[0]);
			for (t = 0; t < i.length; t += 1)
				if (void 0 !== i[t]) {
					var n = i[t].offsetHeight;
					s = s < n ? n : s
				} s && a.$wrapperEl.css("height", s + "px")
		},
		updateSlidesOffset: function() {
			for (var e = this.slides, t = 0; t < e.length; t += 1) e[t].swiperSlideOffset = this.isHorizontal() ? e[t].offsetLeft : e[t].offsetTop
		},
		updateSlidesProgress: function(e) {
			void 0 === e && (e = this && this.translate || 0);
			var t = this,
				a = t.params,
				i = t.slides,
				s = t.rtlTranslate;
			if (0 !== i.length) {
				void 0 === i[0].swiperSlideOffset && t.updateSlidesOffset();
				var r = -e;
				s && (r = e), i.removeClass(a.slideVisibleClass);
				for (var n = 0; n < i.length; n += 1) {
					var o = i[n],
						l = (r + (a.centeredSlides ? t.minTranslate() : 0) - o.swiperSlideOffset) / (o.swiperSlideSize + a.spaceBetween);
					if (a.watchSlidesVisibility) {
						var d = -(r - o.swiperSlideOffset),
							p = d + t.slidesSizesGrid[n];
						(0 <= d && d < t.size || 0 < p && p <= t.size || d <= 0 && p >= t.size) && i.eq(n).addClass(a.slideVisibleClass)
					}
					o.progress = s ? -l : l
				}
			}
		},
		updateProgress: function(e) {
			void 0 === e && (e = this && this.translate || 0);
			var t = this,
				a = t.params,
				i = t.maxTranslate() - t.minTranslate(),
				s = t.progress,
				r = t.isBeginning,
				n = t.isEnd,
				o = r,
				l = n;
			0 === i ? n = r = !(s = 0) : (r = (s = (e - t.minTranslate()) / i) <= 0, n = 1 <= s), X.extend(t, {
				progress: s,
				isBeginning: r,
				isEnd: n
			}), (a.watchSlidesProgress || a.watchSlidesVisibility) && t.updateSlidesProgress(e), r && !o && t.emit("reachBeginning toEdge"), n && !l && t.emit("reachEnd toEdge"), (o && !r || l && !n) && t.emit("fromEdge"), t.emit("progress", s)
		},
		updateSlidesClasses: function() {
			var e, t = this,
				a = t.slides,
				i = t.params,
				s = t.$wrapperEl,
				r = t.activeIndex,
				n = t.realIndex,
				o = t.virtual && i.virtual.enabled;
			a.removeClass(i.slideActiveClass + " " + i.slideNextClass + " " + i.slidePrevClass + " " + i.slideDuplicateActiveClass + " " + i.slideDuplicateNextClass + " " + i.slideDuplicatePrevClass), (e = o ? t.$wrapperEl.find("." + i.slideClass + '[data-swiper-slide-index="' + r + '"]') : a.eq(r)).addClass(i.slideActiveClass), i.loop && (e.hasClass(i.slideDuplicateClass) ? s.children("." + i.slideClass + ":not(." + i.slideDuplicateClass + ')[data-swiper-slide-index="' + n + '"]').addClass(i.slideDuplicateActiveClass) : s.children("." + i.slideClass + "." + i.slideDuplicateClass + '[data-swiper-slide-index="' + n + '"]').addClass(i.slideDuplicateActiveClass));
			var l = e.nextAll("." + i.slideClass).eq(0).addClass(i.slideNextClass);
			i.loop && 0 === l.length && (l = a.eq(0)).addClass(i.slideNextClass);
			var d = e.prevAll("." + i.slideClass).eq(0).addClass(i.slidePrevClass);
			i.loop && 0 === d.length && (d = a.eq(-1)).addClass(i.slidePrevClass), i.loop && (l.hasClass(i.slideDuplicateClass) ? s.children("." + i.slideClass + ":not(." + i.slideDuplicateClass + ')[data-swiper-slide-index="' + l.attr("data-swiper-slide-index") + '"]').addClass(i.slideDuplicateNextClass) : s.children("." + i.slideClass + "." + i.slideDuplicateClass + '[data-swiper-slide-index="' + l.attr("data-swiper-slide-index") + '"]').addClass(i.slideDuplicateNextClass), d.hasClass(i.slideDuplicateClass) ? s.children("." + i.slideClass + ":not(." + i.slideDuplicateClass + ')[data-swiper-slide-index="' + d.attr("data-swiper-slide-index") + '"]').addClass(i.slideDuplicatePrevClass) : s.children("." + i.slideClass + "." + i.slideDuplicateClass + '[data-swiper-slide-index="' + d.attr("data-swiper-slide-index") + '"]').addClass(i.slideDuplicatePrevClass))
		},
		updateActiveIndex: function(e) {
			var t, a = this,
				i = a.rtlTranslate ? a.translate : -a.translate,
				s = a.slidesGrid,
				r = a.snapGrid,
				n = a.params,
				o = a.activeIndex,
				l = a.realIndex,
				d = a.snapIndex,
				p = e;
			if (void 0 === p) {
				for (var c = 0; c < s.length; c += 1) void 0 !== s[c + 1] ? i >= s[c] && i < s[c + 1] - (s[c + 1] - s[c]) / 2 ? p = c : i >= s[c] && i < s[c + 1] && (p = c + 1) : i >= s[c] && (p = c);
				n.normalizeSlideIndex && (p < 0 || void 0 === p) && (p = 0)
			}
			if ((t = 0 <= r.indexOf(i) ? r.indexOf(i) : Math.floor(p / n.slidesPerGroup)) >= r.length && (t = r.length - 1), p !== o) {
				var u = parseInt(a.slides.eq(p).attr("data-swiper-slide-index") || p, 10);
				X.extend(a, {
					snapIndex: t,
					realIndex: u,
					previousIndex: o,
					activeIndex: p
				}), a.emit("activeIndexChange"), a.emit("snapIndexChange"), l !== u && a.emit("realIndexChange"), a.emit("slideChange")
			} else t !== d && (a.snapIndex = t, a.emit("snapIndexChange"))
		},
		updateClickedSlide: function(e) {
			var t = this,
				a = t.params,
				i = L(e.target).closest("." + a.slideClass)[0],
				s = !1;
			if (i)
				for (var r = 0; r < t.slides.length; r += 1) t.slides[r] === i && (s = !0);
			if (!i || !s) return t.clickedSlide = void 0, void(t.clickedIndex = void 0);
			t.clickedSlide = i, t.virtual && t.params.virtual.enabled ? t.clickedIndex = parseInt(L(i).attr("data-swiper-slide-index"), 10) : t.clickedIndex = L(i).index(), a.slideToClickedSlide && void 0 !== t.clickedIndex && t.clickedIndex !== t.activeIndex && t.slideToClickedSlide()
		}
	};
	var d = {
		getTranslate: function(e) {
			void 0 === e && (e = this.isHorizontal() ? "x" : "y");
			var t = this.params,
				a = this.rtlTranslate,
				i = this.translate,
				s = this.$wrapperEl;
			if (t.virtualTranslate) return a ? -i : i;
			var r = X.getTranslate(s[0], e);
			return a && (r = -r), r || 0
		},
		setTranslate: function(e, t) {
			var a = this,
				i = a.rtlTranslate,
				s = a.params,
				r = a.$wrapperEl,
				n = a.progress,
				o = 0,
				l = 0;
			a.isHorizontal() ? o = i ? -e : e : l = e, s.roundLengths && (o = Math.floor(o), l = Math.floor(l)), s.virtualTranslate || (Y.transforms3d ? r.transform("translate3d(" + o + "px, " + l + "px, 0px)") : r.transform("translate(" + o + "px, " + l + "px)")), a.previousTranslate = a.translate, a.translate = a.isHorizontal() ? o : l;
			var d = a.maxTranslate() - a.minTranslate();
			(0 === d ? 0 : (e - a.minTranslate()) / d) !== n && a.updateProgress(e), a.emit("setTranslate", a.translate, t)
		},
		minTranslate: function() {
			return -this.snapGrid[0]
		},
		maxTranslate: function() {
			return -this.snapGrid[this.snapGrid.length - 1]
		}
	};
	var p = {
		setTransition: function(e, t) {
			this.$wrapperEl.transition(e), this.emit("setTransition", e, t)
		},
		transitionStart: function(e, t) {
			void 0 === e && (e = !0);
			var a = this,
				i = a.activeIndex,
				s = a.params,
				r = a.previousIndex;
			s.autoHeight && a.updateAutoHeight();
			var n = t;
			if (n || (n = r < i ? "next" : i < r ? "prev" : "reset"), a.emit("transitionStart"), e && i !== r) {
				if ("reset" === n) return void a.emit("slideResetTransitionStart");
				a.emit("slideChangeTransitionStart"), "next" === n ? a.emit("slideNextTransitionStart") : a.emit("slidePrevTransitionStart")
			}
		},
		transitionEnd: function(e, t) {
			void 0 === e && (e = !0);
			var a = this,
				i = a.activeIndex,
				s = a.previousIndex;
			a.animating = !1, a.setTransition(0);
			var r = t;
			if (r || (r = s < i ? "next" : i < s ? "prev" : "reset"), a.emit("transitionEnd"), e && i !== s) {
				if ("reset" === r) return void a.emit("slideResetTransitionEnd");
				a.emit("slideChangeTransitionEnd"), "next" === r ? a.emit("slideNextTransitionEnd") : a.emit("slidePrevTransitionEnd")
			}
		}
	};
	var c = {
		slideTo: function(e, t, a, i) {
			void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === a && (a = !0);
			var s = this,
				r = e;
			r < 0 && (r = 0);
			var n = s.params,
				o = s.snapGrid,
				l = s.slidesGrid,
				d = s.previousIndex,
				p = s.activeIndex,
				c = s.rtlTranslate;
			if (s.animating && n.preventInteractionOnTransition) return !1;
			var u = Math.floor(r / n.slidesPerGroup);
			u >= o.length && (u = o.length - 1), (p || n.initialSlide || 0) === (d || 0) && a && s.emit("beforeSlideChangeStart");
			var h, v = -o[u];
			if (s.updateProgress(v), n.normalizeSlideIndex)
				for (var f = 0; f < l.length; f += 1) - Math.floor(100 * v) >= Math.floor(100 * l[f]) && (r = f);
			if (s.initialized && r !== p) {
				if (!s.allowSlideNext && v < s.translate && v < s.minTranslate()) return !1;
				if (!s.allowSlidePrev && v > s.translate && v > s.maxTranslate() && (p || 0) !== r) return !1
			}
			return h = p < r ? "next" : r < p ? "prev" : "reset", c && -v === s.translate || !c && v === s.translate ? (s.updateActiveIndex(r), n.autoHeight && s.updateAutoHeight(), s.updateSlidesClasses(), "slide" !== n.effect && s.setTranslate(v), "reset" !== h && (s.transitionStart(a, h), s.transitionEnd(a, h)), !1) : (0 !== t && Y.transition ? (s.setTransition(t), s.setTranslate(v), s.updateActiveIndex(r), s.updateSlidesClasses(), s.emit("beforeTransitionStart", t, i), s.transitionStart(a, h), s.animating || (s.animating = !0, s.onSlideToWrapperTransitionEnd || (s.onSlideToWrapperTransitionEnd = function(e) {
				s && !s.destroyed && e.target === this && (s.$wrapperEl[0].removeEventListener("transitionend", s.onSlideToWrapperTransitionEnd), s.$wrapperEl[0].removeEventListener("webkitTransitionEnd", s.onSlideToWrapperTransitionEnd), s.onSlideToWrapperTransitionEnd = null, delete s.onSlideToWrapperTransitionEnd, s.transitionEnd(a, h))
			}), s.$wrapperEl[0].addEventListener("transitionend", s.onSlideToWrapperTransitionEnd), s.$wrapperEl[0].addEventListener("webkitTransitionEnd", s.onSlideToWrapperTransitionEnd))) : (s.setTransition(0), s.setTranslate(v), s.updateActiveIndex(r), s.updateSlidesClasses(), s.emit("beforeTransitionStart", t, i), s.transitionStart(a, h), s.transitionEnd(a, h)), !0)
		},
		slideToLoop: function(e, t, a, i) {
			void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === a && (a = !0);
			var s = e;
			return this.params.loop && (s += this.loopedSlides), this.slideTo(s, t, a, i)
		},
		slideNext: function(e, t, a) {
			void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
			var i = this,
				s = i.params,
				r = i.animating;
			return s.loop ? !r && (i.loopFix(), i._clientLeft = i.$wrapperEl[0].clientLeft, i.slideTo(i.activeIndex + s.slidesPerGroup, e, t, a)) : i.slideTo(i.activeIndex + s.slidesPerGroup, e, t, a)
		},
		slidePrev: function(e, t, a) {
			void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
			var i = this,
				s = i.params,
				r = i.animating,
				n = i.snapGrid,
				o = i.slidesGrid,
				l = i.rtlTranslate;
			if (s.loop) {
				if (r) return !1;
				i.loopFix(), i._clientLeft = i.$wrapperEl[0].clientLeft
			}

			function d(e) {
				return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e)
			}
			var p, c = d(l ? i.translate : -i.translate),
				u = n.map(function(e) {
					return d(e)
				}),
				h = (o.map(function(e) {
					return d(e)
				}), n[u.indexOf(c)], n[u.indexOf(c) - 1]);
			return void 0 !== h && (p = o.indexOf(h)) < 0 && (p = i.activeIndex - 1), i.slideTo(p, e, t, a)
		},
		slideReset: function(e, t, a) {
			return void 0 === e && (e = this.params.speed), void 0 === t && (t = !0), this.slideTo(this.activeIndex, e, t, a)
		},
		slideToClosest: function(e, t, a) {
			void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
			var i = this,
				s = i.activeIndex,
				r = Math.floor(s / i.params.slidesPerGroup);
			if (r < i.snapGrid.length - 1) {
				var n = i.rtlTranslate ? i.translate : -i.translate,
					o = i.snapGrid[r];
				(i.snapGrid[r + 1] - o) / 2 < n - o && (s = i.params.slidesPerGroup)
			}
			return i.slideTo(s, e, t, a)
		},
		slideToClickedSlide: function() {
			var e, t = this,
				a = t.params,
				i = t.$wrapperEl,
				s = "auto" === a.slidesPerView ? t.slidesPerViewDynamic() : a.slidesPerView,
				r = t.clickedIndex;
			if (a.loop) {
				if (t.animating) return;
				e = parseInt(L(t.clickedSlide).attr("data-swiper-slide-index"), 10), a.centeredSlides ? r < t.loopedSlides - s / 2 || r > t.slides.length - t.loopedSlides + s / 2 ? (t.loopFix(), r = i.children("." + a.slideClass + '[data-swiper-slide-index="' + e + '"]:not(.' + a.slideDuplicateClass + ")").eq(0).index(), X.nextTick(function() {
					t.slideTo(r)
				})) : t.slideTo(r) : r > t.slides.length - s ? (t.loopFix(), r = i.children("." + a.slideClass + '[data-swiper-slide-index="' + e + '"]:not(.' + a.slideDuplicateClass + ")").eq(0).index(), X.nextTick(function() {
					t.slideTo(r)
				})) : t.slideTo(r)
			} else t.slideTo(r)
		}
	};
	var u = {
		loopCreate: function() {
			var i = this,
				e = i.params,
				t = i.$wrapperEl;
			t.children("." + e.slideClass + "." + e.slideDuplicateClass).remove();
			var s = t.children("." + e.slideClass);
			if (e.loopFillGroupWithBlank) {
				var a = e.slidesPerGroup - s.length % e.slidesPerGroup;
				if (a !== e.slidesPerGroup) {
					for (var r = 0; r < a; r += 1) {
						var n = L(f.createElement("div")).addClass(e.slideClass + " " + e.slideBlankClass);
						t.append(n)
					}
					s = t.children("." + e.slideClass)
				}
			}
			"auto" !== e.slidesPerView || e.loopedSlides || (e.loopedSlides = s.length), i.loopedSlides = parseInt(e.loopedSlides || e.slidesPerView, 10), i.loopedSlides += e.loopAdditionalSlides, i.loopedSlides > s.length && (i.loopedSlides = s.length);
			var o = [],
				l = [];
			s.each(function(e, t) {
				var a = L(t);
				e < i.loopedSlides && l.push(t), e < s.length && e >= s.length - i.loopedSlides && o.push(t), a.attr("data-swiper-slide-index", e)
			});
			for (var d = 0; d < l.length; d += 1) t.append(L(l[d].cloneNode(!0)).addClass(e.slideDuplicateClass));
			for (var p = o.length - 1; 0 <= p; p -= 1) t.prepend(L(o[p].cloneNode(!0)).addClass(e.slideDuplicateClass))
		},
		loopFix: function() {
			var e, t = this,
				a = t.params,
				i = t.activeIndex,
				s = t.slides,
				r = t.loopedSlides,
				n = t.allowSlidePrev,
				o = t.allowSlideNext,
				l = t.snapGrid,
				d = t.rtlTranslate;
			t.allowSlidePrev = !0, t.allowSlideNext = !0;
			var p = -l[i] - t.getTranslate();
			i < r ? (e = s.length - 3 * r + i, e += r, t.slideTo(e, 0, !1, !0) && 0 !== p && t.setTranslate((d ? -t.translate : t.translate) - p)) : ("auto" === a.slidesPerView && 2 * r <= i || i >= s.length - r) && (e = -s.length + i + r, e += r, t.slideTo(e, 0, !1, !0) && 0 !== p && t.setTranslate((d ? -t.translate : t.translate) - p));
			t.allowSlidePrev = n, t.allowSlideNext = o
		},
		loopDestroy: function() {
			var e = this.$wrapperEl,
				t = this.params,
				a = this.slides;
			e.children("." + t.slideClass + "." + t.slideDuplicateClass).remove(), a.removeAttr("data-swiper-slide-index")
		}
	};
	var h = {
		setGrabCursor: function(e) {
			if (!(Y.touch || !this.params.simulateTouch || this.params.watchOverflow && this.isLocked)) {
				var t = this.el;
				t.style.cursor = "move", t.style.cursor = e ? "-webkit-grabbing" : "-webkit-grab", t.style.cursor = e ? "-moz-grabbin" : "-moz-grab", t.style.cursor = e ? "grabbing" : "grab"
			}
		},
		unsetGrabCursor: function() {
			Y.touch || this.params.watchOverflow && this.isLocked || (this.el.style.cursor = "")
		}
	};
	var v = {
			appendSlide: function(e) {
				var t = this,
					a = t.$wrapperEl,
					i = t.params;
				if (i.loop && t.loopDestroy(), "object" == typeof e && "length" in e)
					for (var s = 0; s < e.length; s += 1) e[s] && a.append(e[s]);
				else a.append(e);
				i.loop && t.loopCreate(), i.observer && Y.observer || t.update()
			},
			prependSlide: function(e) {
				var t = this,
					a = t.params,
					i = t.$wrapperEl,
					s = t.activeIndex;
				a.loop && t.loopDestroy();
				var r = s + 1;
				if ("object" == typeof e && "length" in e) {
					for (var n = 0; n < e.length; n += 1) e[n] && i.prepend(e[n]);
					r = s + e.length
				} else i.prepend(e);
				a.loop && t.loopCreate(), a.observer && Y.observer || t.update(), t.slideTo(r, 0, !1)
			},
			addSlide: function(e, t) {
				var a = this,
					i = a.$wrapperEl,
					s = a.params,
					r = a.activeIndex;
				s.loop && (r -= a.loopedSlides, a.loopDestroy(), a.slides = i.children("." + s.slideClass));
				var n = a.slides.length;
				if (e <= 0) a.prependSlide(t);
				else if (n <= e) a.appendSlide(t);
				else {
					for (var o = e < r ? r + 1 : r, l = [], d = n - 1; e <= d; d -= 1) {
						var p = a.slides.eq(d);
						p.remove(), l.unshift(p)
					}
					if ("object" == typeof t && "length" in t) {
						for (var c = 0; c < t.length; c += 1) t[c] && i.append(t[c]);
						o = e < r ? r + t.length : r
					} else i.append(t);
					for (var u = 0; u < l.length; u += 1) i.append(l[u]);
					s.loop && a.loopCreate(), s.observer && Y.observer || a.update(), s.loop ? a.slideTo(o + a.loopedSlides, 0, !1) : a.slideTo(o, 0, !1)
				}
			},
			removeSlide: function(e) {
				var t = this,
					a = t.params,
					i = t.$wrapperEl,
					s = t.activeIndex;
				a.loop && (s -= t.loopedSlides, t.loopDestroy(), t.slides = i.children("." + a.slideClass));
				var r, n = s;
				if ("object" == typeof e && "length" in e) {
					for (var o = 0; o < e.length; o += 1) r = e[o], t.slides[r] && t.slides.eq(r).remove(), r < n && (n -= 1);
					n = Math.max(n, 0)
				} else r = e, t.slides[r] && t.slides.eq(r).remove(), r < n && (n -= 1), n = Math.max(n, 0);
				a.loop && t.loopCreate(), a.observer && Y.observer || t.update(), a.loop ? t.slideTo(n + t.loopedSlides, 0, !1) : t.slideTo(n, 0, !1)
			},
			removeAllSlides: function() {
				for (var e = [], t = 0; t < this.slides.length; t += 1) e.push(t);
				this.removeSlide(e)
			}
		},
		m = function() {
			var e = B.navigator.userAgent,
				t = {
					ios: !1,
					android: !1,
					androidChrome: !1,
					desktop: !1,
					windows: !1,
					iphone: !1,
					ipod: !1,
					ipad: !1,
					cordova: B.cordova || B.phonegap,
					phonegap: B.cordova || B.phonegap
				},
				a = e.match(/(Windows Phone);?[\s\/]+([\d.]+)?/),
				i = e.match(/(Android);?[\s\/]+([\d.]+)?/),
				s = e.match(/(iPad).*OS\s([\d_]+)/),
				r = e.match(/(iPod)(.*OS\s([\d_]+))?/),
				n = !s && e.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
			if (a && (t.os = "windows", t.osVersion = a[2], t.windows = !0), i && !a && (t.os = "android", t.osVersion = i[2], t.android = !0, t.androidChrome = 0 <= e.toLowerCase().indexOf("chrome")), (s || n || r) && (t.os = "ios", t.ios = !0), n && !r && (t.osVersion = n[2].replace(/_/g, "."), t.iphone = !0), s && (t.osVersion = s[2].replace(/_/g, "."), t.ipad = !0), r && (t.osVersion = r[3] ? r[3].replace(/_/g, ".") : null, t.iphone = !0), t.ios && t.osVersion && 0 <= e.indexOf("Version/") && "10" === t.osVersion.split(".")[0] && (t.osVersion = e.toLowerCase().split("version/")[1].split(" ")[0]), t.desktop = !(t.os || t.android || t.webView), t.webView = (n || s || r) && e.match(/.*AppleWebKit(?!.*Safari)/i), t.os && "ios" === t.os) {
				var o = t.osVersion.split("."),
					l = f.querySelector('meta[name="viewport"]');
				t.minimalUi = !t.webView && (r || n) && (1 * o[0] == 7 ? 1 <= 1 * o[1] : 7 < 1 * o[0]) && l && 0 <= l.getAttribute("content").indexOf("minimal-ui")
			}
			return t.pixelRatio = B.devicePixelRatio || 1, t
		}();

	function g() {
		var e = this,
			t = e.params,
			a = e.el;
		if (!a || 0 !== a.offsetWidth) {
			t.breakpoints && e.setBreakpoint();
			var i = e.allowSlideNext,
				s = e.allowSlidePrev,
				r = e.snapGrid;
			if (e.allowSlideNext = !0, e.allowSlidePrev = !0, e.updateSize(), e.updateSlides(), t.freeMode) {
				var n = Math.min(Math.max(e.translate, e.maxTranslate()), e.minTranslate());
				e.setTranslate(n), e.updateActiveIndex(), e.updateSlidesClasses(), t.autoHeight && e.updateAutoHeight()
			} else e.updateSlidesClasses(), ("auto" === t.slidesPerView || 1 < t.slidesPerView) && e.isEnd && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0);
			e.allowSlidePrev = s, e.allowSlideNext = i, e.params.watchOverflow && r !== e.snapGrid && e.checkOverflow()
		}
	}
	var b = {
		attachEvents: function() {
			var e = this,
				t = e.params,
				a = e.touchEvents,
				i = e.el,
				s = e.wrapperEl;
			e.onTouchStart = function(e) {
				var t = this,
					a = t.touchEventsData,
					i = t.params,
					s = t.touches;
				if (!t.animating || !i.preventInteractionOnTransition) {
					var r = e;
					if (r.originalEvent && (r = r.originalEvent), a.isTouchEvent = "touchstart" === r.type, (a.isTouchEvent || !("which" in r) || 3 !== r.which) && (!a.isTouched || !a.isMoved))
						if (i.noSwiping && L(r.target).closest(i.noSwipingSelector ? i.noSwipingSelector : "." + i.noSwipingClass)[0]) t.allowClick = !0;
						else if (!i.swipeHandler || L(r).closest(i.swipeHandler)[0]) {
						s.currentX = "touchstart" === r.type ? r.targetTouches[0].pageX : r.pageX, s.currentY = "touchstart" === r.type ? r.targetTouches[0].pageY : r.pageY;
						var n = s.currentX,
							o = s.currentY,
							l = i.edgeSwipeDetection || i.iOSEdgeSwipeDetection,
							d = i.edgeSwipeThreshold || i.iOSEdgeSwipeThreshold;
						if (!l || !(n <= d || n >= B.screen.width - d)) {
							if (X.extend(a, {
									isTouched: !0,
									isMoved: !1,
									allowTouchCallbacks: !0,
									isScrolling: void 0,
									startMoving: void 0
								}), s.startX = n, s.startY = o, a.touchStartTime = X.now(), t.allowClick = !0, t.updateSize(), t.swipeDirection = void 0, 0 < i.threshold && (a.allowThresholdMove = !1), "touchstart" !== r.type) {
								var p = !0;
								L(r.target).is(a.formElements) && (p = !1), f.activeElement && L(f.activeElement).is(a.formElements) && f.activeElement !== r.target && f.activeElement.blur(), p && t.allowTouchMove && r.preventDefault()
							}
							t.emit("touchStart", r)
						}
					}
				}
			}.bind(e), e.onTouchMove = function(e) {
				var t = this,
					a = t.touchEventsData,
					i = t.params,
					s = t.touches,
					r = t.rtlTranslate,
					n = e;
				if (n.originalEvent && (n = n.originalEvent), a.isTouched) {
					if (!a.isTouchEvent || "mousemove" !== n.type) {
						var o = "touchmove" === n.type ? n.targetTouches[0].pageX : n.pageX,
							l = "touchmove" === n.type ? n.targetTouches[0].pageY : n.pageY;
						if (n.preventedByNestedSwiper) return s.startX = o, void(s.startY = l);
						if (!t.allowTouchMove) return t.allowClick = !1, void(a.isTouched && (X.extend(s, {
							startX: o,
							startY: l,
							currentX: o,
							currentY: l
						}), a.touchStartTime = X.now()));
						if (a.isTouchEvent && i.touchReleaseOnEdges && !i.loop)
							if (t.isVertical()) {
								if (l < s.startY && t.translate <= t.maxTranslate() || l > s.startY && t.translate >= t.minTranslate()) return a.isTouched = !1, void(a.isMoved = !1)
							} else if (o < s.startX && t.translate <= t.maxTranslate() || o > s.startX && t.translate >= t.minTranslate()) return;
						if (a.isTouchEvent && f.activeElement && n.target === f.activeElement && L(n.target).is(a.formElements)) return a.isMoved = !0, void(t.allowClick = !1);
						if (a.allowTouchCallbacks && t.emit("touchMove", n), !(n.targetTouches && 1 < n.targetTouches.length)) {
							s.currentX = o, s.currentY = l;
							var d, p = s.currentX - s.startX,
								c = s.currentY - s.startY;
							if (!(t.params.threshold && Math.sqrt(Math.pow(p, 2) + Math.pow(c, 2)) < t.params.threshold))
								if (void 0 === a.isScrolling && (t.isHorizontal() && s.currentY === s.startY || t.isVertical() && s.currentX === s.startX ? a.isScrolling = !1 : 25 <= p * p + c * c && (d = 180 * Math.atan2(Math.abs(c), Math.abs(p)) / Math.PI, a.isScrolling = t.isHorizontal() ? d > i.touchAngle : 90 - d > i.touchAngle)), a.isScrolling && t.emit("touchMoveOpposite", n), void 0 === a.startMoving && (s.currentX === s.startX && s.currentY === s.startY || (a.startMoving = !0)), a.isScrolling) a.isTouched = !1;
								else if (a.startMoving) {
								t.allowClick = !1, n.preventDefault(), i.touchMoveStopPropagation && !i.nested && n.stopPropagation(), a.isMoved || (i.loop && t.loopFix(), a.startTranslate = t.getTranslate(), t.setTransition(0), t.animating && t.$wrapperEl.trigger("webkitTransitionEnd transitionend"), a.allowMomentumBounce = !1, !i.grabCursor || !0 !== t.allowSlideNext && !0 !== t.allowSlidePrev || t.setGrabCursor(!0), t.emit("sliderFirstMove", n)), t.emit("sliderMove", n), a.isMoved = !0;
								var u = t.isHorizontal() ? p : c;
								s.diff = u, u *= i.touchRatio, r && (u = -u), t.swipeDirection = 0 < u ? "prev" : "next", a.currentTranslate = u + a.startTranslate;
								var h = !0,
									v = i.resistanceRatio;
								if (i.touchReleaseOnEdges && (v = 0), 0 < u && a.currentTranslate > t.minTranslate() ? (h = !1, i.resistance && (a.currentTranslate = t.minTranslate() - 1 + Math.pow(-t.minTranslate() + a.startTranslate + u, v))) : u < 0 && a.currentTranslate < t.maxTranslate() && (h = !1, i.resistance && (a.currentTranslate = t.maxTranslate() + 1 - Math.pow(t.maxTranslate() - a.startTranslate - u, v))), h && (n.preventedByNestedSwiper = !0), !t.allowSlideNext && "next" === t.swipeDirection && a.currentTranslate < a.startTranslate && (a.currentTranslate = a.startTranslate), !t.allowSlidePrev && "prev" === t.swipeDirection && a.currentTranslate > a.startTranslate && (a.currentTranslate = a.startTranslate), 0 < i.threshold) {
									if (!(Math.abs(u) > i.threshold || a.allowThresholdMove)) return void(a.currentTranslate = a.startTranslate);
									if (!a.allowThresholdMove) return a.allowThresholdMove = !0, s.startX = s.currentX, s.startY = s.currentY, a.currentTranslate = a.startTranslate, void(s.diff = t.isHorizontal() ? s.currentX - s.startX : s.currentY - s.startY)
								}
								i.followFinger && ((i.freeMode || i.watchSlidesProgress || i.watchSlidesVisibility) && (t.updateActiveIndex(), t.updateSlidesClasses()), i.freeMode && (0 === a.velocities.length && a.velocities.push({
									position: s[t.isHorizontal() ? "startX" : "startY"],
									time: a.touchStartTime
								}), a.velocities.push({
									position: s[t.isHorizontal() ? "currentX" : "currentY"],
									time: X.now()
								})), t.updateProgress(a.currentTranslate), t.setTranslate(a.currentTranslate))
							}
						}
					}
				} else a.startMoving && a.isScrolling && t.emit("touchMoveOpposite", n)
			}.bind(e), e.onTouchEnd = function(e) {
				var t = this,
					a = t.touchEventsData,
					i = t.params,
					s = t.touches,
					r = t.rtlTranslate,
					n = t.$wrapperEl,
					o = t.slidesGrid,
					l = t.snapGrid,
					d = e;
				if (d.originalEvent && (d = d.originalEvent), a.allowTouchCallbacks && t.emit("touchEnd", d), a.allowTouchCallbacks = !1, !a.isTouched) return a.isMoved && i.grabCursor && t.setGrabCursor(!1), a.isMoved = !1, void(a.startMoving = !1);
				i.grabCursor && a.isMoved && a.isTouched && (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) && t.setGrabCursor(!1);
				var p, c = X.now(),
					u = c - a.touchStartTime;
				if (t.allowClick && (t.updateClickedSlide(d), t.emit("tap", d), u < 300 && 300 < c - a.lastClickTime && (a.clickTimeout && clearTimeout(a.clickTimeout), a.clickTimeout = X.nextTick(function() {
						t && !t.destroyed && t.emit("click", d)
					}, 300)), u < 300 && c - a.lastClickTime < 300 && (a.clickTimeout && clearTimeout(a.clickTimeout), t.emit("doubleTap", d))), a.lastClickTime = X.now(), X.nextTick(function() {
						t.destroyed || (t.allowClick = !0)
					}), !a.isTouched || !a.isMoved || !t.swipeDirection || 0 === s.diff || a.currentTranslate === a.startTranslate) return a.isTouched = !1, a.isMoved = !1, void(a.startMoving = !1);
				if (a.isTouched = !1, a.isMoved = !1, a.startMoving = !1, p = i.followFinger ? r ? t.translate : -t.translate : -a.currentTranslate, i.freeMode) {
					if (p < -t.minTranslate()) return void t.slideTo(t.activeIndex);
					if (p > -t.maxTranslate()) return void(t.slides.length < l.length ? t.slideTo(l.length - 1) : t.slideTo(t.slides.length - 1));
					if (i.freeModeMomentum) {
						if (1 < a.velocities.length) {
							var h = a.velocities.pop(),
								v = a.velocities.pop(),
								f = h.position - v.position,
								m = h.time - v.time;
							t.velocity = f / m, t.velocity /= 2, Math.abs(t.velocity) < i.freeModeMinimumVelocity && (t.velocity = 0), (150 < m || 300 < X.now() - h.time) && (t.velocity = 0)
						} else t.velocity = 0;
						t.velocity *= i.freeModeMomentumVelocityRatio, a.velocities.length = 0;
						var g = 1e3 * i.freeModeMomentumRatio,
							b = t.velocity * g,
							w = t.translate + b;
						r && (w = -w);
						var y, x, E = !1,
							T = 20 * Math.abs(t.velocity) * i.freeModeMomentumBounceRatio;
						if (w < t.maxTranslate()) i.freeModeMomentumBounce ? (w + t.maxTranslate() < -T && (w = t.maxTranslate() - T), y = t.maxTranslate(), E = !0, a.allowMomentumBounce = !0) : w = t.maxTranslate(), i.loop && i.centeredSlides && (x = !0);
						else if (w > t.minTranslate()) i.freeModeMomentumBounce ? (w - t.minTranslate() > T && (w = t.minTranslate() + T), y = t.minTranslate(), E = !0, a.allowMomentumBounce = !0) : w = t.minTranslate(), i.loop && i.centeredSlides && (x = !0);
						else if (i.freeModeSticky) {
							for (var S, C = 0; C < l.length; C += 1)
								if (l[C] > -w) {
									S = C;
									break
								} w = -(w = Math.abs(l[S] - w) < Math.abs(l[S - 1] - w) || "next" === t.swipeDirection ? l[S] : l[S - 1])
						}
						if (x && t.once("transitionEnd", function() {
								t.loopFix()
							}), 0 !== t.velocity) g = r ? Math.abs((-w - t.translate) / t.velocity) : Math.abs((w - t.translate) / t.velocity);
						else if (i.freeModeSticky) return void t.slideToClosest();
						i.freeModeMomentumBounce && E ? (t.updateProgress(y), t.setTransition(g), t.setTranslate(w), t.transitionStart(!0, t.swipeDirection), t.animating = !0, n.transitionEnd(function() {
							t && !t.destroyed && a.allowMomentumBounce && (t.emit("momentumBounce"), t.setTransition(i.speed), t.setTranslate(y), n.transitionEnd(function() {
								t && !t.destroyed && t.transitionEnd()
							}))
						})) : t.velocity ? (t.updateProgress(w), t.setTransition(g), t.setTranslate(w), t.transitionStart(!0, t.swipeDirection), t.animating || (t.animating = !0, n.transitionEnd(function() {
							t && !t.destroyed && t.transitionEnd()
						}))) : t.updateProgress(w), t.updateActiveIndex(), t.updateSlidesClasses()
					} else if (i.freeModeSticky) return void t.slideToClosest();
					(!i.freeModeMomentum || u >= i.longSwipesMs) && (t.updateProgress(), t.updateActiveIndex(), t.updateSlidesClasses())
				} else {
					for (var M = 0, z = t.slidesSizesGrid[0], k = 0; k < o.length; k += i.slidesPerGroup) void 0 !== o[k + i.slidesPerGroup] ? p >= o[k] && p < o[k + i.slidesPerGroup] && (z = o[(M = k) + i.slidesPerGroup] - o[k]) : p >= o[k] && (M = k, z = o[o.length - 1] - o[o.length - 2]);
					var P = (p - o[M]) / z;
					if (u > i.longSwipesMs) {
						if (!i.longSwipes) return void t.slideTo(t.activeIndex);
						"next" === t.swipeDirection && (P >= i.longSwipesRatio ? t.slideTo(M + i.slidesPerGroup) : t.slideTo(M)), "prev" === t.swipeDirection && (P > 1 - i.longSwipesRatio ? t.slideTo(M + i.slidesPerGroup) : t.slideTo(M))
					} else {
						if (!i.shortSwipes) return void t.slideTo(t.activeIndex);
						"next" === t.swipeDirection && t.slideTo(M + i.slidesPerGroup), "prev" === t.swipeDirection && t.slideTo(M)
					}
				}
			}.bind(e), e.onClick = function(e) {
				this.allowClick || (this.params.preventClicks && e.preventDefault(), this.params.preventClicksPropagation && this.animating && (e.stopPropagation(), e.stopImmediatePropagation()))
			}.bind(e);
			var r = "container" === t.touchEventsTarget ? i : s,
				n = !!t.nested;
			if (Y.touch || !Y.pointerEvents && !Y.prefixedPointerEvents) {
				if (Y.touch) {
					var o = !("touchstart" !== a.start || !Y.passiveListener || !t.passiveListeners) && {
						passive: !0,
						capture: !1
					};
					r.addEventListener(a.start, e.onTouchStart, o), r.addEventListener(a.move, e.onTouchMove, Y.passiveListener ? {
						passive: !1,
						capture: n
					} : n), r.addEventListener(a.end, e.onTouchEnd, o)
				}(t.simulateTouch && !m.ios && !m.android || t.simulateTouch && !Y.touch && m.ios) && (r.addEventListener("mousedown", e.onTouchStart, !1), f.addEventListener("mousemove", e.onTouchMove, n), f.addEventListener("mouseup", e.onTouchEnd, !1))
			} else r.addEventListener(a.start, e.onTouchStart, !1), f.addEventListener(a.move, e.onTouchMove, n), f.addEventListener(a.end, e.onTouchEnd, !1);
			(t.preventClicks || t.preventClicksPropagation) && r.addEventListener("click", e.onClick, !0), e.on(m.ios || m.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", g, !0)
		},
		detachEvents: function() {
			var e = this,
				t = e.params,
				a = e.touchEvents,
				i = e.el,
				s = e.wrapperEl,
				r = "container" === t.touchEventsTarget ? i : s,
				n = !!t.nested;
			if (Y.touch || !Y.pointerEvents && !Y.prefixedPointerEvents) {
				if (Y.touch) {
					var o = !("onTouchStart" !== a.start || !Y.passiveListener || !t.passiveListeners) && {
						passive: !0,
						capture: !1
					};
					r.removeEventListener(a.start, e.onTouchStart, o), r.removeEventListener(a.move, e.onTouchMove, n), r.removeEventListener(a.end, e.onTouchEnd, o)
				}(t.simulateTouch && !m.ios && !m.android || t.simulateTouch && !Y.touch && m.ios) && (r.removeEventListener("mousedown", e.onTouchStart, !1), f.removeEventListener("mousemove", e.onTouchMove, n), f.removeEventListener("mouseup", e.onTouchEnd, !1))
			} else r.removeEventListener(a.start, e.onTouchStart, !1), f.removeEventListener(a.move, e.onTouchMove, n), f.removeEventListener(a.end, e.onTouchEnd, !1);
			(t.preventClicks || t.preventClicksPropagation) && r.removeEventListener("click", e.onClick, !0), e.off(m.ios || m.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", g)
		}
	};
	var w, y = {
			setBreakpoint: function() {
				var e = this,
					t = e.activeIndex,
					a = e.initialized,
					i = e.loopedSlides;
				void 0 === i && (i = 0);
				var s = e.params,
					r = s.breakpoints;
				if (r && (!r || 0 !== Object.keys(r).length)) {
					var n = e.getBreakpoint(r);
					if (n && e.currentBreakpoint !== n) {
						var o = n in r ? r[n] : e.originalParams,
							l = s.loop && o.slidesPerView !== s.slidesPerView;
						X.extend(e.params, o), X.extend(e, {
							allowTouchMove: e.params.allowTouchMove,
							allowSlideNext: e.params.allowSlideNext,
							allowSlidePrev: e.params.allowSlidePrev
						}), e.currentBreakpoint = n, l && a && (e.loopDestroy(), e.loopCreate(), e.updateSlides(), e.slideTo(t - i + e.loopedSlides, 0, !1)), e.emit("breakpoint", o)
					}
				}
			},
			getBreakpoint: function(e) {
				if (e) {
					var t = !1,
						a = [];
					Object.keys(e).forEach(function(e) {
						a.push(e)
					}), a.sort(function(e, t) {
						return parseInt(e, 10) - parseInt(t, 10)
					});
					for (var i = 0; i < a.length; i += 1) {
						var s = a[i];
						s >= B.innerWidth && !t && (t = s)
					}
					return t || "max"
				}
			}
		},
		I = {
			isIE: !!B.navigator.userAgent.match(/Trident/g) || !!B.navigator.userAgent.match(/MSIE/g),
			isSafari: (w = B.navigator.userAgent.toLowerCase(), 0 <= w.indexOf("safari") && w.indexOf("chrome") < 0 && w.indexOf("android") < 0),
			isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(B.navigator.userAgent)
		};
	var x = {
			init: !0,
			direction: "horizontal",
			touchEventsTarget: "container",
			initialSlide: 0,
			speed: 300,
			preventInteractionOnTransition: !1,
			edgeSwipeDetection: !1,
			edgeSwipeThreshold: 20,
			freeMode: !1,
			freeModeMomentum: !0,
			freeModeMomentumRatio: 1,
			freeModeMomentumBounce: !0,
			freeModeMomentumBounceRatio: 1,
			freeModeMomentumVelocityRatio: 1,
			freeModeSticky: !1,
			freeModeMinimumVelocity: .02,
			autoHeight: !1,
			setWrapperSize: !1,
			virtualTranslate: !1,
			effect: "slide",
			breakpoints: void 0,
			spaceBetween: 0,
			slidesPerView: 1,
			slidesPerColumn: 1,
			slidesPerColumnFill: "column",
			slidesPerGroup: 1,
			centeredSlides: !1,
			slidesOffsetBefore: 0,
			slidesOffsetAfter: 0,
			normalizeSlideIndex: !0,
			watchOverflow: !1,
			roundLengths: !1,
			touchRatio: 1,
			touchAngle: 45,
			simulateTouch: !0,
			shortSwipes: !0,
			longSwipes: !0,
			longSwipesRatio: .5,
			longSwipesMs: 300,
			followFinger: !0,
			allowTouchMove: !0,
			threshold: 0,
			touchMoveStopPropagation: !0,
			touchReleaseOnEdges: !1,
			uniqueNavElements: !0,
			resistance: !0,
			resistanceRatio: .85,
			watchSlidesProgress: !1,
			watchSlidesVisibility: !1,
			grabCursor: !1,
			preventClicks: !0,
			preventClicksPropagation: !0,
			slideToClickedSlide: !1,
			preloadImages: !0,
			updateOnImagesReady: !0,
			loop: !1,
			loopAdditionalSlides: 0,
			loopedSlides: null,
			loopFillGroupWithBlank: !1,
			allowSlidePrev: !0,
			allowSlideNext: !0,
			swipeHandler: null,
			noSwiping: !0,
			noSwipingClass: "swiper-no-swiping",
			noSwipingSelector: null,
			passiveListeners: !0,
			containerModifierClass: "swiper-container-",
			slideClass: "swiper-slide",
			slideBlankClass: "swiper-slide-invisible-blank",
			slideActiveClass: "swiper-slide-active",
			slideDuplicateActiveClass: "swiper-slide-duplicate-active",
			slideVisibleClass: "swiper-slide-visible",
			slideDuplicateClass: "swiper-slide-duplicate",
			slideNextClass: "swiper-slide-next",
			slideDuplicateNextClass: "swiper-slide-duplicate-next",
			slidePrevClass: "swiper-slide-prev",
			slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
			wrapperClass: "swiper-wrapper",
			runCallbacksOnInit: !0
		},
		E = {
			update: o,
			translate: d,
			transition: p,
			slide: c,
			loop: u,
			grabCursor: h,
			manipulation: v,
			events: b,
			breakpoints: y,
			checkOverflow: {
				checkOverflow: function() {
					var e = this,
						t = e.isLocked;
					e.isLocked = 1 === e.snapGrid.length, e.allowSlideNext = !e.isLocked, e.allowSlidePrev = !e.isLocked, t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock"), t && t !== e.isLocked && (e.isEnd = !1, e.navigation.update())
				}
			},
			classes: {
				addClasses: function() {
					var t = this.classNames,
						a = this.params,
						e = this.rtl,
						i = this.$el,
						s = [];
					s.push(a.direction), a.freeMode && s.push("free-mode"), Y.flexbox || s.push("no-flexbox"), a.autoHeight && s.push("autoheight"), e && s.push("rtl"), 1 < a.slidesPerColumn && s.push("multirow"), m.android && s.push("android"), m.ios && s.push("ios"), I.isIE && (Y.pointerEvents || Y.prefixedPointerEvents) && s.push("wp8-" + a.direction), s.forEach(function(e) {
						t.push(a.containerModifierClass + e)
					}), i.addClass(t.join(" "))
				},
				removeClasses: function() {
					var e = this.$el,
						t = this.classNames;
					e.removeClass(t.join(" "))
				}
			},
			images: {
				loadImage: function(e, t, a, i, s, r) {
					var n;

					function o() {
						r && r()
					}
					e.complete && s ? o() : t ? ((n = new B.Image).onload = o, n.onerror = o, i && (n.sizes = i), a && (n.srcset = a), t && (n.src = t)) : o()
				},
				preloadImages: function() {
					var e = this;

					function t() {
						null != e && e && !e.destroyed && (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1), e.imagesLoaded === e.imagesToLoad.length && (e.params.updateOnImagesReady && e.update(), e.emit("imagesReady")))
					}
					e.imagesToLoad = e.$el.find("img");
					for (var a = 0; a < e.imagesToLoad.length; a += 1) {
						var i = e.imagesToLoad[a];
						e.loadImage(i, i.currentSrc || i.getAttribute("src"), i.srcset || i.getAttribute("srcset"), i.sizes || i.getAttribute("sizes"), !0, t)
					}
				}
			}
		},
		T = {},
		S = function(u) {
			function h() {
				for (var e, t, s, a = [], i = arguments.length; i--;) a[i] = arguments[i];
				1 === a.length && a[0].constructor && a[0].constructor === Object ? s = a[0] : (t = (e = a)[0], s = e[1]), s || (s = {}), s = X.extend({}, s), t && !s.el && (s.el = t), u.call(this, s), Object.keys(E).forEach(function(t) {
					Object.keys(E[t]).forEach(function(e) {
						h.prototype[e] || (h.prototype[e] = E[t][e])
					})
				});
				var r = this;
				void 0 === r.modules && (r.modules = {}), Object.keys(r.modules).forEach(function(e) {
					var t = r.modules[e];
					if (t.params) {
						var a = Object.keys(t.params)[0],
							i = t.params[a];
						if ("object" != typeof i) return;
						if (!(a in s && "enabled" in i)) return;
						!0 === s[a] && (s[a] = {
							enabled: !0
						}), "object" != typeof s[a] || "enabled" in s[a] || (s[a].enabled = !0), s[a] || (s[a] = {
							enabled: !1
						})
					}
				});
				var n = X.extend({}, x);
				r.useModulesParams(n), r.params = X.extend({}, n, T, s), r.originalParams = X.extend({}, r.params), r.passedParams = X.extend({}, s);
				var o = (r.$ = L)(r.params.el);
				if (t = o[0]) {
					if (1 < o.length) {
						var l = [];
						return o.each(function(e, t) {
							var a = X.extend({}, s, {
								el: t
							});
							l.push(new h(a))
						}), l
					}
					t.swiper = r, o.data("swiper", r);
					var d, p, c = o.children("." + r.params.wrapperClass);
					return X.extend(r, {
						$el: o,
						el: t,
						$wrapperEl: c,
						wrapperEl: c[0],
						classNames: [],
						slides: L(),
						slidesGrid: [],
						snapGrid: [],
						slidesSizesGrid: [],
						isHorizontal: function() {
							return "horizontal" === r.params.direction
						},
						isVertical: function() {
							return "vertical" === r.params.direction
						},
						rtl: "rtl" === t.dir.toLowerCase() || "rtl" === o.css("direction"),
						rtlTranslate: "horizontal" === r.params.direction && ("rtl" === t.dir.toLowerCase() || "rtl" === o.css("direction")),
						wrongRTL: "-webkit-box" === c.css("display"),
						activeIndex: 0,
						realIndex: 0,
						isBeginning: !0,
						isEnd: !1,
						translate: 0,
						previousTranslate: 0,
						progress: 0,
						velocity: 0,
						animating: !1,
						allowSlideNext: r.params.allowSlideNext,
						allowSlidePrev: r.params.allowSlidePrev,
						touchEvents: (d = ["touchstart", "touchmove", "touchend"], p = ["mousedown", "mousemove", "mouseup"], Y.pointerEvents ? p = ["pointerdown", "pointermove", "pointerup"] : Y.prefixedPointerEvents && (p = ["MSPointerDown", "MSPointerMove", "MSPointerUp"]), r.touchEventsTouch = {
							start: d[0],
							move: d[1],
							end: d[2]
						}, r.touchEventsDesktop = {
							start: p[0],
							move: p[1],
							end: p[2]
						}, Y.touch || !r.params.simulateTouch ? r.touchEventsTouch : r.touchEventsDesktop),
						touchEventsData: {
							isTouched: void 0,
							isMoved: void 0,
							allowTouchCallbacks: void 0,
							touchStartTime: void 0,
							isScrolling: void 0,
							currentTranslate: void 0,
							startTranslate: void 0,
							allowThresholdMove: void 0,
							formElements: "input, select, option, textarea, button, video",
							lastClickTime: X.now(),
							clickTimeout: void 0,
							velocities: [],
							allowMomentumBounce: void 0,
							isTouchEvent: void 0,
							startMoving: void 0
						},
						allowClick: !0,
						allowTouchMove: r.params.allowTouchMove,
						touches: {
							startX: 0,
							startY: 0,
							currentX: 0,
							currentY: 0,
							diff: 0
						},
						imagesToLoad: [],
						imagesLoaded: 0
					}), r.useModules(), r.params.init && r.init(), r
				}
			}
			u && (h.__proto__ = u);
			var e = {
				extendedDefaults: {
					configurable: !0
				},
				defaults: {
					configurable: !0
				},
				Class: {
					configurable: !0
				},
				$: {
					configurable: !0
				}
			};
			return ((h.prototype = Object.create(u && u.prototype)).constructor = h).prototype.slidesPerViewDynamic = function() {
				var e = this,
					t = e.params,
					a = e.slides,
					i = e.slidesGrid,
					s = e.size,
					r = e.activeIndex,
					n = 1;
				if (t.centeredSlides) {
					for (var o, l = a[r].swiperSlideSize, d = r + 1; d < a.length; d += 1) a[d] && !o && (n += 1, s < (l += a[d].swiperSlideSize) && (o = !0));
					for (var p = r - 1; 0 <= p; p -= 1) a[p] && !o && (n += 1, s < (l += a[p].swiperSlideSize) && (o = !0))
				} else
					for (var c = r + 1; c < a.length; c += 1) i[c] - i[r] < s && (n += 1);
				return n
			}, h.prototype.update = function() {
				var a = this;
				if (a && !a.destroyed) {
					var e = a.snapGrid,
						t = a.params;
					t.breakpoints && a.setBreakpoint(), a.updateSize(), a.updateSlides(), a.updateProgress(), a.updateSlidesClasses(), a.params.freeMode ? (i(), a.params.autoHeight && a.updateAutoHeight()) : (("auto" === a.params.slidesPerView || 1 < a.params.slidesPerView) && a.isEnd && !a.params.centeredSlides ? a.slideTo(a.slides.length - 1, 0, !1, !0) : a.slideTo(a.activeIndex, 0, !1, !0)) || i(), t.watchOverflow && e !== a.snapGrid && a.checkOverflow(), a.emit("update")
				}

				function i() {
					var e = a.rtlTranslate ? -1 * a.translate : a.translate,
						t = Math.min(Math.max(e, a.maxTranslate()), a.minTranslate());
					a.setTranslate(t), a.updateActiveIndex(), a.updateSlidesClasses()
				}
			}, h.prototype.init = function() {
				var e = this;
				e.initialized || (e.emit("beforeInit"), e.params.breakpoints && e.setBreakpoint(), e.addClasses(), e.params.loop && e.loopCreate(), e.updateSize(), e.updateSlides(), e.params.watchOverflow && e.checkOverflow(), e.params.grabCursor && e.setGrabCursor(), e.params.preloadImages && e.preloadImages(), e.params.loop ? e.slideTo(e.params.initialSlide + e.loopedSlides, 0, e.params.runCallbacksOnInit) : e.slideTo(e.params.initialSlide, 0, e.params.runCallbacksOnInit), e.attachEvents(), e.initialized = !0, e.emit("init"))
			}, h.prototype.destroy = function(e, t) {
				void 0 === e && (e = !0), void 0 === t && (t = !0);
				var a = this,
					i = a.params,
					s = a.$el,
					r = a.$wrapperEl,
					n = a.slides;
				return void 0 === a.params || a.destroyed || (a.emit("beforeDestroy"), a.initialized = !1, a.detachEvents(), i.loop && a.loopDestroy(), t && (a.removeClasses(), s.removeAttr("style"), r.removeAttr("style"), n && n.length && n.removeClass([i.slideVisibleClass, i.slideActiveClass, i.slideNextClass, i.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index").removeAttr("data-swiper-column").removeAttr("data-swiper-row")), a.emit("destroy"), Object.keys(a.eventsListeners).forEach(function(e) {
					a.off(e)
				}), !1 !== e && (a.$el[0].swiper = null, a.$el.data("swiper", null), X.deleteProps(a)), a.destroyed = !0), null
			}, h.extendDefaults = function(e) {
				X.extend(T, e)
			}, e.extendedDefaults.get = function() {
				return T
			}, e.defaults.get = function() {
				return x
			}, e.Class.get = function() {
				return u
			}, e.$.get = function() {
				return L
			}, Object.defineProperties(h, e), h
		}(s),
		C = {
			name: "device",
			proto: {
				device: m
			},
			static: {
				device: m
			}
		},
		M = {
			name: "support",
			proto: {
				support: Y
			},
			static: {
				support: Y
			}
		},
		z = {
			name: "browser",
			proto: {
				browser: I
			},
			static: {
				browser: I
			}
		},
		k = {
			name: "resize",
			create: function() {
				var e = this;
				X.extend(e, {
					resize: {
						resizeHandler: function() {
							e && !e.destroyed && e.initialized && (e.emit("beforeResize"), e.emit("resize"))
						},
						orientationChangeHandler: function() {
							e && !e.destroyed && e.initialized && e.emit("orientationchange")
						}
					}
				})
			},
			on: {
				init: function() {
					B.addEventListener("resize", this.resize.resizeHandler), B.addEventListener("orientationchange", this.resize.orientationChangeHandler)
				},
				destroy: function() {
					B.removeEventListener("resize", this.resize.resizeHandler), B.removeEventListener("orientationchange", this.resize.orientationChangeHandler)
				}
			}
		},
		P = {
			func: B.MutationObserver || B.WebkitMutationObserver,
			attach: function(e, t) {
				void 0 === t && (t = {});
				var a = this,
					i = new P.func(function(e) {
						if (1 !== e.length) {
							var t = function() {
								a.emit("observerUpdate", e[0])
							};
							B.requestAnimationFrame ? B.requestAnimationFrame(t) : B.setTimeout(t, 0)
						} else a.emit("observerUpdate", e[0])
					});
				i.observe(e, {
					attributes: void 0 === t.attributes || t.attributes,
					childList: void 0 === t.childList || t.childList,
					characterData: void 0 === t.characterData || t.characterData
				}), a.observer.observers.push(i)
			},
			init: function() {
				var e = this;
				if (Y.observer && e.params.observer) {
					if (e.params.observeParents)
						for (var t = e.$el.parents(), a = 0; a < t.length; a += 1) e.observer.attach(t[a]);
					e.observer.attach(e.$el[0], {
						childList: !1
					}), e.observer.attach(e.$wrapperEl[0], {
						attributes: !1
					})
				}
			},
			destroy: function() {
				this.observer.observers.forEach(function(e) {
					e.disconnect()
				}), this.observer.observers = []
			}
		},
		$ = {
			name: "observer",
			params: {
				observer: !1,
				observeParents: !1
			},
			create: function() {
				X.extend(this, {
					observer: {
						init: P.init.bind(this),
						attach: P.attach.bind(this),
						destroy: P.destroy.bind(this),
						observers: []
					}
				})
			},
			on: {
				init: function() {
					this.observer.init()
				},
				destroy: function() {
					this.observer.destroy()
				}
			}
		},
		D = {
			update: function(e) {
				var t = this,
					a = t.params,
					i = a.slidesPerView,
					s = a.slidesPerGroup,
					r = a.centeredSlides,
					n = t.virtual,
					o = n.from,
					l = n.to,
					d = n.slides,
					p = n.slidesGrid,
					c = n.renderSlide,
					u = n.offset;
				t.updateActiveIndex();
				var h, v, f, m = t.activeIndex || 0;
				h = t.rtlTranslate ? "right" : t.isHorizontal() ? "left" : "top", r ? (v = Math.floor(i / 2) + s, f = Math.floor(i / 2) + s) : (v = i + (s - 1), f = s);
				var g = Math.max((m || 0) - f, 0),
					b = Math.min((m || 0) + v, d.length - 1),
					w = (t.slidesGrid[g] || 0) - (t.slidesGrid[0] || 0);

				function y() {
					t.updateSlides(), t.updateProgress(), t.updateSlidesClasses(), t.lazy && t.params.lazy.enabled && t.lazy.load()
				}
				if (X.extend(t.virtual, {
						from: g,
						to: b,
						offset: w,
						slidesGrid: t.slidesGrid
					}), o === g && l === b && !e) return t.slidesGrid !== p && w !== u && t.slides.css(h, w + "px"), void t.updateProgress();
				if (t.params.virtual.renderExternal) return t.params.virtual.renderExternal.call(t, {
					offset: w,
					from: g,
					to: b,
					slides: function() {
						for (var e = [], t = g; t <= b; t += 1) e.push(d[t]);
						return e
					}()
				}), void y();
				var x = [],
					E = [];
				if (e) t.$wrapperEl.find("." + t.params.slideClass).remove();
				else
					for (var T = o; T <= l; T += 1)(T < g || b < T) && t.$wrapperEl.find("." + t.params.slideClass + '[data-swiper-slide-index="' + T + '"]').remove();
				for (var S = 0; S < d.length; S += 1) g <= S && S <= b && (void 0 === l || e ? E.push(S) : (l < S && E.push(S), S < o && x.push(S)));
				E.forEach(function(e) {
					t.$wrapperEl.append(c(d[e], e))
				}), x.sort(function(e, t) {
					return e < t
				}).forEach(function(e) {
					t.$wrapperEl.prepend(c(d[e], e))
				}), t.$wrapperEl.children(".swiper-slide").css(h, w + "px"), y()
			},
			renderSlide: function(e, t) {
				var a = this,
					i = a.params.virtual;
				if (i.cache && a.virtual.cache[t]) return a.virtual.cache[t];
				var s = i.renderSlide ? L(i.renderSlide.call(a, e, t)) : L('<div class="' + a.params.slideClass + '" data-swiper-slide-index="' + t + '">' + e + "</div>");
				return s.attr("data-swiper-slide-index") || s.attr("data-swiper-slide-index", t), i.cache && (a.virtual.cache[t] = s), s
			},
			appendSlide: function(e) {
				this.virtual.slides.push(e), this.virtual.update(!0)
			},
			prependSlide: function(e) {
				var t = this;
				if (t.virtual.slides.unshift(e), t.params.virtual.cache) {
					var a = t.virtual.cache,
						i = {};
					Object.keys(a).forEach(function(e) {
						i[e + 1] = a[e]
					}), t.virtual.cache = i
				}
				t.virtual.update(!0), t.slideNext(0)
			}
		},
		O = {
			name: "virtual",
			params: {
				virtual: {
					enabled: !1,
					slides: [],
					cache: !0,
					renderSlide: null,
					renderExternal: null
				}
			},
			create: function() {
				var e = this;
				X.extend(e, {
					virtual: {
						update: D.update.bind(e),
						appendSlide: D.appendSlide.bind(e),
						prependSlide: D.prependSlide.bind(e),
						renderSlide: D.renderSlide.bind(e),
						slides: e.params.virtual.slides,
						cache: {}
					}
				})
			},
			on: {
				beforeInit: function() {
					var e = this;
					if (e.params.virtual.enabled) {
						e.classNames.push(e.params.containerModifierClass + "virtual");
						var t = {
							watchSlidesProgress: !0
						};
						X.extend(e.params, t), X.extend(e.originalParams, t), e.virtual.update()
					}
				},
				setTranslate: function() {
					this.params.virtual.enabled && this.virtual.update()
				}
			}
		},
		A = {
			handle: function(e) {
				var t = this,
					a = t.rtlTranslate,
					i = e;
				i.originalEvent && (i = i.originalEvent);
				var s = i.keyCode || i.charCode;
				if (!t.allowSlideNext && (t.isHorizontal() && 39 === s || t.isVertical() && 40 === s)) return !1;
				if (!t.allowSlidePrev && (t.isHorizontal() && 37 === s || t.isVertical() && 38 === s)) return !1;
				if (!(i.shiftKey || i.altKey || i.ctrlKey || i.metaKey || f.activeElement && f.activeElement.nodeName && ("input" === f.activeElement.nodeName.toLowerCase() || "textarea" === f.activeElement.nodeName.toLowerCase()))) {
					if (t.params.keyboard.onlyInViewport && (37 === s || 39 === s || 38 === s || 40 === s)) {
						var r = !1;
						if (0 < t.$el.parents("." + t.params.slideClass).length && 0 === t.$el.parents("." + t.params.slideActiveClass).length) return;
						var n = B.innerWidth,
							o = B.innerHeight,
							l = t.$el.offset();
						a && (l.left -= t.$el[0].scrollLeft);
						for (var d = [
								[l.left, l.top],
								[l.left + t.width, l.top],
								[l.left, l.top + t.height],
								[l.left + t.width, l.top + t.height]
							], p = 0; p < d.length; p += 1) {
							var c = d[p];
							0 <= c[0] && c[0] <= n && 0 <= c[1] && c[1] <= o && (r = !0)
						}
						if (!r) return
					}
					t.isHorizontal() ? (37 !== s && 39 !== s || (i.preventDefault ? i.preventDefault() : i.returnValue = !1), (39 === s && !a || 37 === s && a) && t.slideNext(), (37 === s && !a || 39 === s && a) && t.slidePrev()) : (38 !== s && 40 !== s || (i.preventDefault ? i.preventDefault() : i.returnValue = !1), 40 === s && t.slideNext(), 38 === s && t.slidePrev()), t.emit("keyPress", s)
				}
			},
			enable: function() {
				this.keyboard.enabled || (L(f).on("keydown", this.keyboard.handle), this.keyboard.enabled = !0)
			},
			disable: function() {
				this.keyboard.enabled && (L(f).off("keydown", this.keyboard.handle), this.keyboard.enabled = !1)
			}
		},
		H = {
			name: "keyboard",
			params: {
				keyboard: {
					enabled: !1,
					onlyInViewport: !0
				}
			},
			create: function() {
				X.extend(this, {
					keyboard: {
						enabled: !1,
						enable: A.enable.bind(this),
						disable: A.disable.bind(this),
						handle: A.handle.bind(this)
					}
				})
			},
			on: {
				init: function() {
					this.params.keyboard.enabled && this.keyboard.enable()
				},
				destroy: function() {
					this.keyboard.enabled && this.keyboard.disable()
				}
			}
		};
	var G = {
			lastScrollTime: X.now(),
			event: -1 < B.navigator.userAgent.indexOf("firefox") ? "DOMMouseScroll" : function() {
				var e = "onwheel",
					t = e in f;
				if (!t) {
					var a = f.createElement("div");
					a.setAttribute(e, "return;"), t = "function" == typeof a[e]
				}
				return !t && f.implementation && f.implementation.hasFeature && !0 !== f.implementation.hasFeature("", "") && (t = f.implementation.hasFeature("Events.wheel", "3.0")), t
			}() ? "wheel" : "mousewheel",
			normalize: function(e) {
				var t = 0,
					a = 0,
					i = 0,
					s = 0;
				return "detail" in e && (a = e.detail), "wheelDelta" in e && (a = -e.wheelDelta / 120), "wheelDeltaY" in e && (a = -e.wheelDeltaY / 120), "wheelDeltaX" in e && (t = -e.wheelDeltaX / 120), "axis" in e && e.axis === e.HORIZONTAL_AXIS && (t = a, a = 0), i = 10 * t, s = 10 * a, "deltaY" in e && (s = e.deltaY), "deltaX" in e && (i = e.deltaX), (i || s) && e.deltaMode && (1 === e.deltaMode ? (i *= 40, s *= 40) : (i *= 800, s *= 800)), i && !t && (t = i < 1 ? -1 : 1), s && !a && (a = s < 1 ? -1 : 1), {
					spinX: t,
					spinY: a,
					pixelX: i,
					pixelY: s
				}
			},
			handleMouseEnter: function() {
				this.mouseEntered = !0
			},
			handleMouseLeave: function() {
				this.mouseEntered = !1
			},
			handle: function(e) {
				var t = e,
					a = this,
					i = a.params.mousewheel;
				if (!a.mouseEntered && !i.releaseOnEdges) return !0;
				t.originalEvent && (t = t.originalEvent);
				var s = 0,
					r = a.rtlTranslate ? -1 : 1,
					n = G.normalize(t);
				if (i.forceToAxis)
					if (a.isHorizontal()) {
						if (!(Math.abs(n.pixelX) > Math.abs(n.pixelY))) return !0;
						s = n.pixelX * r
					} else {
						if (!(Math.abs(n.pixelY) > Math.abs(n.pixelX))) return !0;
						s = n.pixelY
					}
				else s = Math.abs(n.pixelX) > Math.abs(n.pixelY) ? -n.pixelX * r : -n.pixelY;
				if (0 === s) return !0;
				if (i.invert && (s = -s), a.params.freeMode) {
					a.params.loop && a.loopFix();
					var o = a.getTranslate() + s * i.sensitivity,
						l = a.isBeginning,
						d = a.isEnd;
					if (o >= a.minTranslate() && (o = a.minTranslate()), o <= a.maxTranslate() && (o = a.maxTranslate()), a.setTransition(0), a.setTranslate(o), a.updateProgress(), a.updateActiveIndex(), a.updateSlidesClasses(), (!l && a.isBeginning || !d && a.isEnd) && a.updateSlidesClasses(), a.params.freeModeSticky && (clearTimeout(a.mousewheel.timeout), a.mousewheel.timeout = X.nextTick(function() {
							a.slideToClosest()
						}, 300)), a.emit("scroll", t), a.params.autoplay && a.params.autoplayDisableOnInteraction && a.autoplay.stop(), o === a.minTranslate() || o === a.maxTranslate()) return !0
				} else {
					if (60 < X.now() - a.mousewheel.lastScrollTime)
						if (s < 0)
							if (a.isEnd && !a.params.loop || a.animating) {
								if (i.releaseOnEdges) return !0
							} else a.slideNext(), a.emit("scroll", t);
					else if (a.isBeginning && !a.params.loop || a.animating) {
						if (i.releaseOnEdges) return !0
					} else a.slidePrev(), a.emit("scroll", t);
					a.mousewheel.lastScrollTime = (new B.Date).getTime()
				}
				return t.preventDefault ? t.preventDefault() : t.returnValue = !1, !1
			},
			enable: function() {
				var e = this;
				if (!G.event) return !1;
				if (e.mousewheel.enabled) return !1;
				var t = e.$el;
				return "container" !== e.params.mousewheel.eventsTarged && (t = L(e.params.mousewheel.eventsTarged)), t.on("mouseenter", e.mousewheel.handleMouseEnter), t.on("mouseleave", e.mousewheel.handleMouseLeave), t.on(G.event, e.mousewheel.handle), e.mousewheel.enabled = !0
			},
			disable: function() {
				var e = this;
				if (!G.event) return !1;
				if (!e.mousewheel.enabled) return !1;
				var t = e.$el;
				return "container" !== e.params.mousewheel.eventsTarged && (t = L(e.params.mousewheel.eventsTarged)), t.off(G.event, e.mousewheel.handle), !(e.mousewheel.enabled = !1)
			}
		},
		N = {
			update: function() {
				var e = this,
					t = e.params.navigation;
				if (!e.params.loop) {
					var a = e.navigation,
						i = a.$nextEl,
						s = a.$prevEl;
					s && 0 < s.length && (e.isBeginning ? s.addClass(t.disabledClass) : s.removeClass(t.disabledClass), s[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](t.lockClass)), i && 0 < i.length && (e.isEnd ? i.addClass(t.disabledClass) : i.removeClass(t.disabledClass), i[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](t.lockClass))
				}
			},
			init: function() {
				var e, t, a = this,
					i = a.params.navigation;
				(i.nextEl || i.prevEl) && (i.nextEl && (e = L(i.nextEl), a.params.uniqueNavElements && "string" == typeof i.nextEl && 1 < e.length && 1 === a.$el.find(i.nextEl).length && (e = a.$el.find(i.nextEl))), i.prevEl && (t = L(i.prevEl), a.params.uniqueNavElements && "string" == typeof i.prevEl && 1 < t.length && 1 === a.$el.find(i.prevEl).length && (t = a.$el.find(i.prevEl))), e && 0 < e.length && e.on("click", function(e) {
					e.preventDefault(), a.isEnd && !a.params.loop || a.slideNext()
				}), t && 0 < t.length && t.on("click", function(e) {
					e.preventDefault(), a.isBeginning && !a.params.loop || a.slidePrev()
				}), X.extend(a.navigation, {
					$nextEl: e,
					nextEl: e && e[0],
					$prevEl: t,
					prevEl: t && t[0]
				}))
			},
			destroy: function() {
				var e = this.navigation,
					t = e.$nextEl,
					a = e.$prevEl;
				t && t.length && (t.off("click"), t.removeClass(this.params.navigation.disabledClass)), a && a.length && (a.off("click"), a.removeClass(this.params.navigation.disabledClass))
			}
		},
		V = {
			update: function() {
				var e = this,
					t = e.rtl,
					s = e.params.pagination;
				if (s.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length) {
					var r, a = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
						i = e.pagination.$el,
						n = e.params.loop ? Math.ceil((a - 2 * e.loopedSlides) / e.params.slidesPerGroup) : e.snapGrid.length;
					if (e.params.loop ? ((r = Math.ceil((e.activeIndex - e.loopedSlides) / e.params.slidesPerGroup)) > a - 1 - 2 * e.loopedSlides && (r -= a - 2 * e.loopedSlides), n - 1 < r && (r -= n), r < 0 && "bullets" !== e.params.paginationType && (r = n + r)) : r = void 0 !== e.snapIndex ? e.snapIndex : e.activeIndex || 0, "bullets" === s.type && e.pagination.bullets && 0 < e.pagination.bullets.length) {
						var o, l, d, p = e.pagination.bullets;
						if (s.dynamicBullets && (e.pagination.bulletSize = p.eq(0)[e.isHorizontal() ? "outerWidth" : "outerHeight"](!0), i.css(e.isHorizontal() ? "width" : "height", e.pagination.bulletSize * (s.dynamicMainBullets + 4) + "px"), 1 < s.dynamicMainBullets && void 0 !== e.previousIndex && (e.pagination.dynamicBulletIndex += r - e.previousIndex, e.pagination.dynamicBulletIndex > s.dynamicMainBullets - 1 ? e.pagination.dynamicBulletIndex = s.dynamicMainBullets - 1 : e.pagination.dynamicBulletIndex < 0 && (e.pagination.dynamicBulletIndex = 0)), o = r - e.pagination.dynamicBulletIndex, d = ((l = o + (Math.min(p.length, s.dynamicMainBullets) - 1)) + o) / 2), p.removeClass(s.bulletActiveClass + " " + s.bulletActiveClass + "-next " + s.bulletActiveClass + "-next-next " + s.bulletActiveClass + "-prev " + s.bulletActiveClass + "-prev-prev " + s.bulletActiveClass + "-main"), 1 < i.length) p.each(function(e, t) {
							var a = L(t),
								i = a.index();
							i === r && a.addClass(s.bulletActiveClass), s.dynamicBullets && (o <= i && i <= l && a.addClass(s.bulletActiveClass + "-main"), i === o && a.prev().addClass(s.bulletActiveClass + "-prev").prev().addClass(s.bulletActiveClass + "-prev-prev"), i === l && a.next().addClass(s.bulletActiveClass + "-next").next().addClass(s.bulletActiveClass + "-next-next"))
						});
						else if (p.eq(r).addClass(s.bulletActiveClass), s.dynamicBullets) {
							for (var c = p.eq(o), u = p.eq(l), h = o; h <= l; h += 1) p.eq(h).addClass(s.bulletActiveClass + "-main");
							c.prev().addClass(s.bulletActiveClass + "-prev").prev().addClass(s.bulletActiveClass + "-prev-prev"), u.next().addClass(s.bulletActiveClass + "-next").next().addClass(s.bulletActiveClass + "-next-next")
						}
						if (s.dynamicBullets) {
							var v = Math.min(p.length, s.dynamicMainBullets + 4),
								f = (e.pagination.bulletSize * v - e.pagination.bulletSize) / 2 - d * e.pagination.bulletSize,
								m = t ? "right" : "left";
							p.css(e.isHorizontal() ? m : "top", f + "px")
						}
					}
					if ("fraction" === s.type && (i.find("." + s.currentClass).text(s.formatFractionCurrent(r + 1)), i.find("." + s.totalClass).text(s.formatFractionTotal(n))), "progressbar" === s.type) {
						var g;
						g = s.progressbarOpposite ? e.isHorizontal() ? "vertical" : "horizontal" : e.isHorizontal() ? "horizontal" : "vertical";
						var b = (r + 1) / n,
							w = 1,
							y = 1;
						"horizontal" === g ? w = b : y = b, i.find("." + s.progressbarFillClass).transform("translate3d(0,0,0) scaleX(" + w + ") scaleY(" + y + ")").transition(e.params.speed)
					}
					"custom" === s.type && s.renderCustom ? (i.html(s.renderCustom(e, r + 1, n)), e.emit("paginationRender", e, i[0])) : e.emit("paginationUpdate", e, i[0]), i[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](s.lockClass)
				}
			},
			render: function() {
				var e = this,
					t = e.params.pagination;
				if (t.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length) {
					var a = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
						i = e.pagination.$el,
						s = "";
					if ("bullets" === t.type) {
						for (var r = e.params.loop ? Math.ceil((a - 2 * e.loopedSlides) / e.params.slidesPerGroup) : e.snapGrid.length, n = 0; n < r; n += 1) t.renderBullet ? s += t.renderBullet.call(e, n, t.bulletClass) : s += "<" + t.bulletElement + ' class="' + t.bulletClass + '"></' + t.bulletElement + ">";
						i.html(s), e.pagination.bullets = i.find("." + t.bulletClass)
					}
					"fraction" === t.type && (s = t.renderFraction ? t.renderFraction.call(e, t.currentClass, t.totalClass) : '<span class="' + t.currentClass + '"></span> / <span class="' + t.totalClass + '"></span>', i.html(s)), "progressbar" === t.type && (s = t.renderProgressbar ? t.renderProgressbar.call(e, t.progressbarFillClass) : '<span class="' + t.progressbarFillClass + '"></span>', i.html(s)), "custom" !== t.type && e.emit("paginationRender", e.pagination.$el[0])
				}
			},
			init: function() {
				var a = this,
					e = a.params.pagination;
				if (e.el) {
					var t = L(e.el);
					0 !== t.length && (a.params.uniqueNavElements && "string" == typeof e.el && 1 < t.length && 1 === a.$el.find(e.el).length && (t = a.$el.find(e.el)), "bullets" === e.type && e.clickable && t.addClass(e.clickableClass), t.addClass(e.modifierClass + e.type), "bullets" === e.type && e.dynamicBullets && (t.addClass("" + e.modifierClass + e.type + "-dynamic"), a.pagination.dynamicBulletIndex = 0, e.dynamicMainBullets < 1 && (e.dynamicMainBullets = 1)), "progressbar" === e.type && e.progressbarOpposite && t.addClass(e.progressbarOppositeClass), e.clickable && t.on("click", "." + e.bulletClass, function(e) {
						e.preventDefault();
						var t = L(this).index() * a.params.slidesPerGroup;
						a.params.loop && (t += a.loopedSlides), a.slideTo(t)
					}), X.extend(a.pagination, {
						$el: t,
						el: t[0]
					}))
				}
			},
			destroy: function() {
				var e = this,
					t = e.params.pagination;
				if (t.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length) {
					var a = e.pagination.$el;
					a.removeClass(t.hiddenClass), a.removeClass(t.modifierClass + t.type), e.pagination.bullets && e.pagination.bullets.removeClass(t.bulletActiveClass), t.clickable && a.off("click", "." + t.bulletClass)
				}
			}
		},
		R = {
			setTranslate: function() {
				var e = this;
				if (e.params.scrollbar.el && e.scrollbar.el) {
					var t = e.scrollbar,
						a = e.rtlTranslate,
						i = e.progress,
						s = t.dragSize,
						r = t.trackSize,
						n = t.$dragEl,
						o = t.$el,
						l = e.params.scrollbar,
						d = s,
						p = (r - s) * i;
					a ? 0 < (p = -p) ? (d = s - p, p = 0) : r < -p + s && (d = r + p) : p < 0 ? (d = s + p, p = 0) : r < p + s && (d = r - p), e.isHorizontal() ? (Y.transforms3d ? n.transform("translate3d(" + p + "px, 0, 0)") : n.transform("translateX(" + p + "px)"), n[0].style.width = d + "px") : (Y.transforms3d ? n.transform("translate3d(0px, " + p + "px, 0)") : n.transform("translateY(" + p + "px)"), n[0].style.height = d + "px"), l.hide && (clearTimeout(e.scrollbar.timeout), o[0].style.opacity = 1, e.scrollbar.timeout = setTimeout(function() {
						o[0].style.opacity = 0, o.transition(400)
					}, 1e3))
				}
			},
			setTransition: function(e) {
				this.params.scrollbar.el && this.scrollbar.el && this.scrollbar.$dragEl.transition(e)
			},
			updateSize: function() {
				var e = this;
				if (e.params.scrollbar.el && e.scrollbar.el) {
					var t = e.scrollbar,
						a = t.$dragEl,
						i = t.$el;
					a[0].style.width = "", a[0].style.height = "";
					var s, r = e.isHorizontal() ? i[0].offsetWidth : i[0].offsetHeight,
						n = e.size / e.virtualSize,
						o = n * (r / e.size);
					s = "auto" === e.params.scrollbar.dragSize ? r * n : parseInt(e.params.scrollbar.dragSize, 10), e.isHorizontal() ? a[0].style.width = s + "px" : a[0].style.height = s + "px", i[0].style.display = 1 <= n ? "none" : "", e.params.scrollbarHide && (i[0].style.opacity = 0), X.extend(t, {
						trackSize: r,
						divider: n,
						moveDivider: o,
						dragSize: s
					}), t.$el[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](e.params.scrollbar.lockClass)
				}
			},
			setDragPosition: function(e) {
				var t, a = this,
					i = a.scrollbar,
					s = a.rtlTranslate,
					r = i.$el,
					n = i.dragSize,
					o = i.trackSize;
				t = ((a.isHorizontal() ? "touchstart" === e.type || "touchmove" === e.type ? e.targetTouches[0].pageX : e.pageX || e.clientX : "touchstart" === e.type || "touchmove" === e.type ? e.targetTouches[0].pageY : e.pageY || e.clientY) - r.offset()[a.isHorizontal() ? "left" : "top"] - n / 2) / (o - n), t = Math.max(Math.min(t, 1), 0), s && (t = 1 - t);
				var l = a.minTranslate() + (a.maxTranslate() - a.minTranslate()) * t;
				a.updateProgress(l), a.setTranslate(l), a.updateActiveIndex(), a.updateSlidesClasses()
			},
			onDragStart: function(e) {
				var t = this,
					a = t.params.scrollbar,
					i = t.scrollbar,
					s = t.$wrapperEl,
					r = i.$el,
					n = i.$dragEl;
				t.scrollbar.isTouched = !0, e.preventDefault(), e.stopPropagation(), s.transition(100), n.transition(100), i.setDragPosition(e), clearTimeout(t.scrollbar.dragTimeout), r.transition(0), a.hide && r.css("opacity", 1), t.emit("scrollbarDragStart", e)
			},
			onDragMove: function(e) {
				var t = this.scrollbar,
					a = this.$wrapperEl,
					i = t.$el,
					s = t.$dragEl;
				this.scrollbar.isTouched && (e.preventDefault ? e.preventDefault() : e.returnValue = !1, t.setDragPosition(e), a.transition(0), i.transition(0), s.transition(0), this.emit("scrollbarDragMove", e))
			},
			onDragEnd: function(e) {
				var t = this,
					a = t.params.scrollbar,
					i = t.scrollbar.$el;
				t.scrollbar.isTouched && (t.scrollbar.isTouched = !1, a.hide && (clearTimeout(t.scrollbar.dragTimeout), t.scrollbar.dragTimeout = X.nextTick(function() {
					i.css("opacity", 0), i.transition(400)
				}, 1e3)), t.emit("scrollbarDragEnd", e), a.snapOnRelease && t.slideToClosest())
			},
			enableDraggable: function() {
				var e = this;
				if (e.params.scrollbar.el) {
					var t = e.scrollbar,
						a = e.touchEvents,
						i = e.touchEventsDesktop,
						s = e.params,
						r = t.$el[0],
						n = !(!Y.passiveListener || !s.passiveListeners) && {
							passive: !1,
							capture: !1
						},
						o = !(!Y.passiveListener || !s.passiveListeners) && {
							passive: !0,
							capture: !1
						};
					Y.touch || !Y.pointerEvents && !Y.prefixedPointerEvents ? (Y.touch && (r.addEventListener(a.start, e.scrollbar.onDragStart, n), r.addEventListener(a.move, e.scrollbar.onDragMove, n), r.addEventListener(a.end, e.scrollbar.onDragEnd, o)), (s.simulateTouch && !m.ios && !m.android || s.simulateTouch && !Y.touch && m.ios) && (r.addEventListener("mousedown", e.scrollbar.onDragStart, n), f.addEventListener("mousemove", e.scrollbar.onDragMove, n), f.addEventListener("mouseup", e.scrollbar.onDragEnd, o))) : (r.addEventListener(i.start, e.scrollbar.onDragStart, n), f.addEventListener(i.move, e.scrollbar.onDragMove, n), f.addEventListener(i.end, e.scrollbar.onDragEnd, o))
				}
			},
			disableDraggable: function() {
				var e = this;
				if (e.params.scrollbar.el) {
					var t = e.scrollbar,
						a = e.touchEvents,
						i = e.touchEventsDesktop,
						s = e.params,
						r = t.$el[0],
						n = !(!Y.passiveListener || !s.passiveListeners) && {
							passive: !1,
							capture: !1
						},
						o = !(!Y.passiveListener || !s.passiveListeners) && {
							passive: !0,
							capture: !1
						};
					Y.touch || !Y.pointerEvents && !Y.prefixedPointerEvents ? (Y.touch && (r.removeEventListener(a.start, e.scrollbar.onDragStart, n), r.removeEventListener(a.move, e.scrollbar.onDragMove, n), r.removeEventListener(a.end, e.scrollbar.onDragEnd, o)), (s.simulateTouch && !m.ios && !m.android || s.simulateTouch && !Y.touch && m.ios) && (r.removeEventListener("mousedown", e.scrollbar.onDragStart, n), f.removeEventListener("mousemove", e.scrollbar.onDragMove, n), f.removeEventListener("mouseup", e.scrollbar.onDragEnd, o))) : (r.removeEventListener(i.start, e.scrollbar.onDragStart, n), f.removeEventListener(i.move, e.scrollbar.onDragMove, n), f.removeEventListener(i.end, e.scrollbar.onDragEnd, o))
				}
			},
			init: function() {
				var e = this;
				if (e.params.scrollbar.el) {
					var t = e.scrollbar,
						a = e.$el,
						i = e.params.scrollbar,
						s = L(i.el);
					e.params.uniqueNavElements && "string" == typeof i.el && 1 < s.length && 1 === a.find(i.el).length && (s = a.find(i.el));
					var r = s.find("." + e.params.scrollbar.dragClass);
					0 === r.length && (r = L('<div class="' + e.params.scrollbar.dragClass + '"></div>'), s.append(r)), X.extend(t, {
						$el: s,
						el: s[0],
						$dragEl: r,
						dragEl: r[0]
					}), i.draggable && t.enableDraggable()
				}
			},
			destroy: function() {
				this.scrollbar.disableDraggable()
			}
		},
		F = {
			setTransform: function(e, t) {
				var a = this.rtl,
					i = L(e),
					s = a ? -1 : 1,
					r = i.attr("data-swiper-parallax") || "0",
					n = i.attr("data-swiper-parallax-x"),
					o = i.attr("data-swiper-parallax-y"),
					l = i.attr("data-swiper-parallax-scale"),
					d = i.attr("data-swiper-parallax-opacity");
				if (n || o ? (n = n || "0", o = o || "0") : this.isHorizontal() ? (n = r, o = "0") : (o = r, n = "0"), n = 0 <= n.indexOf("%") ? parseInt(n, 10) * t * s + "%" : n * t * s + "px", o = 0 <= o.indexOf("%") ? parseInt(o, 10) * t + "%" : o * t + "px", null != d) {
					var p = d - (d - 1) * (1 - Math.abs(t));
					i[0].style.opacity = p
				}
				if (null == l) i.transform("translate3d(" + n + ", " + o + ", 0px)");
				else {
					var c = l - (l - 1) * (1 - Math.abs(t));
					i.transform("translate3d(" + n + ", " + o + ", 0px) scale(" + c + ")")
				}
			},
			setTranslate: function() {
				var i = this,
					e = i.$el,
					t = i.slides,
					s = i.progress,
					r = i.snapGrid;
				e.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function(e, t) {
					i.parallax.setTransform(t, s)
				}), t.each(function(e, t) {
					var a = t.progress;
					1 < i.params.slidesPerGroup && "auto" !== i.params.slidesPerView && (a += Math.ceil(e / 2) - s * (r.length - 1)), a = Math.min(Math.max(a, -1), 1), L(t).find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function(e, t) {
						i.parallax.setTransform(t, a)
					})
				})
			},
			setTransition: function(s) {
				void 0 === s && (s = this.params.speed);
				this.$el.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function(e, t) {
					var a = L(t),
						i = parseInt(a.attr("data-swiper-parallax-duration"), 10) || s;
					0 === s && (i = 0), a.transition(i)
				})
			}
		},
		W = {
			getDistanceBetweenTouches: function(e) {
				if (e.targetTouches.length < 2) return 1;
				var t = e.targetTouches[0].pageX,
					a = e.targetTouches[0].pageY,
					i = e.targetTouches[1].pageX,
					s = e.targetTouches[1].pageY;
				return Math.sqrt(Math.pow(i - t, 2) + Math.pow(s - a, 2))
			},
			onGestureStart: function(e) {
				var t = this,
					a = t.params.zoom,
					i = t.zoom,
					s = i.gesture;
				if (i.fakeGestureTouched = !1, i.fakeGestureMoved = !1, !Y.gestures) {
					if ("touchstart" !== e.type || "touchstart" === e.type && e.targetTouches.length < 2) return;
					i.fakeGestureTouched = !0, s.scaleStart = W.getDistanceBetweenTouches(e)
				}
				s.$slideEl && s.$slideEl.length || (s.$slideEl = L(e.target).closest(".swiper-slide"), 0 === s.$slideEl.length && (s.$slideEl = t.slides.eq(t.activeIndex)), s.$imageEl = s.$slideEl.find("img, svg, canvas"), s.$imageWrapEl = s.$imageEl.parent("." + a.containerClass), s.maxRatio = s.$imageWrapEl.attr("data-swiper-zoom") || a.maxRatio, 0 !== s.$imageWrapEl.length) ? (s.$imageEl.transition(0), t.zoom.isScaling = !0) : s.$imageEl = void 0
			},
			onGestureChange: function(e) {
				var t = this.params.zoom,
					a = this.zoom,
					i = a.gesture;
				if (!Y.gestures) {
					if ("touchmove" !== e.type || "touchmove" === e.type && e.targetTouches.length < 2) return;
					a.fakeGestureMoved = !0, i.scaleMove = W.getDistanceBetweenTouches(e)
				}
				i.$imageEl && 0 !== i.$imageEl.length && (Y.gestures ? this.zoom.scale = e.scale * a.currentScale : a.scale = i.scaleMove / i.scaleStart * a.currentScale, a.scale > i.maxRatio && (a.scale = i.maxRatio - 1 + Math.pow(a.scale - i.maxRatio + 1, .5)), a.scale < t.minRatio && (a.scale = t.minRatio + 1 - Math.pow(t.minRatio - a.scale + 1, .5)), i.$imageEl.transform("translate3d(0,0,0) scale(" + a.scale + ")"))
			},
			onGestureEnd: function(e) {
				var t = this.params.zoom,
					a = this.zoom,
					i = a.gesture;
				if (!Y.gestures) {
					if (!a.fakeGestureTouched || !a.fakeGestureMoved) return;
					if ("touchend" !== e.type || "touchend" === e.type && e.changedTouches.length < 2 && !m.android) return;
					a.fakeGestureTouched = !1, a.fakeGestureMoved = !1
				}
				i.$imageEl && 0 !== i.$imageEl.length && (a.scale = Math.max(Math.min(a.scale, i.maxRatio), t.minRatio), i.$imageEl.transition(this.params.speed).transform("translate3d(0,0,0) scale(" + a.scale + ")"), a.currentScale = a.scale, a.isScaling = !1, 1 === a.scale && (i.$slideEl = void 0))
			},
			onTouchStart: function(e) {
				var t = this.zoom,
					a = t.gesture,
					i = t.image;
				a.$imageEl && 0 !== a.$imageEl.length && (i.isTouched || (m.android && e.preventDefault(), i.isTouched = !0, i.touchesStart.x = "touchstart" === e.type ? e.targetTouches[0].pageX : e.pageX, i.touchesStart.y = "touchstart" === e.type ? e.targetTouches[0].pageY : e.pageY))
			},
			onTouchMove: function(e) {
				var t = this,
					a = t.zoom,
					i = a.gesture,
					s = a.image,
					r = a.velocity;
				if (i.$imageEl && 0 !== i.$imageEl.length && (t.allowClick = !1, s.isTouched && i.$slideEl)) {
					s.isMoved || (s.width = i.$imageEl[0].offsetWidth, s.height = i.$imageEl[0].offsetHeight, s.startX = X.getTranslate(i.$imageWrapEl[0], "x") || 0, s.startY = X.getTranslate(i.$imageWrapEl[0], "y") || 0, i.slideWidth = i.$slideEl[0].offsetWidth, i.slideHeight = i.$slideEl[0].offsetHeight, i.$imageWrapEl.transition(0), t.rtl && (s.startX = -s.startX, s.startY = -s.startY));
					var n = s.width * a.scale,
						o = s.height * a.scale;
					if (!(n < i.slideWidth && o < i.slideHeight)) {
						if (s.minX = Math.min(i.slideWidth / 2 - n / 2, 0), s.maxX = -s.minX, s.minY = Math.min(i.slideHeight / 2 - o / 2, 0), s.maxY = -s.minY, s.touchesCurrent.x = "touchmove" === e.type ? e.targetTouches[0].pageX : e.pageX, s.touchesCurrent.y = "touchmove" === e.type ? e.targetTouches[0].pageY : e.pageY, !s.isMoved && !a.isScaling) {
							if (t.isHorizontal() && (Math.floor(s.minX) === Math.floor(s.startX) && s.touchesCurrent.x < s.touchesStart.x || Math.floor(s.maxX) === Math.floor(s.startX) && s.touchesCurrent.x > s.touchesStart.x)) return void(s.isTouched = !1);
							if (!t.isHorizontal() && (Math.floor(s.minY) === Math.floor(s.startY) && s.touchesCurrent.y < s.touchesStart.y || Math.floor(s.maxY) === Math.floor(s.startY) && s.touchesCurrent.y > s.touchesStart.y)) return void(s.isTouched = !1)
						}
						e.preventDefault(), e.stopPropagation(), s.isMoved = !0, s.currentX = s.touchesCurrent.x - s.touchesStart.x + s.startX, s.currentY = s.touchesCurrent.y - s.touchesStart.y + s.startY, s.currentX < s.minX && (s.currentX = s.minX + 1 - Math.pow(s.minX - s.currentX + 1, .8)), s.currentX > s.maxX && (s.currentX = s.maxX - 1 + Math.pow(s.currentX - s.maxX + 1, .8)), s.currentY < s.minY && (s.currentY = s.minY + 1 - Math.pow(s.minY - s.currentY + 1, .8)), s.currentY > s.maxY && (s.currentY = s.maxY - 1 + Math.pow(s.currentY - s.maxY + 1, .8)), r.prevPositionX || (r.prevPositionX = s.touchesCurrent.x), r.prevPositionY || (r.prevPositionY = s.touchesCurrent.y), r.prevTime || (r.prevTime = Date.now()), r.x = (s.touchesCurrent.x - r.prevPositionX) / (Date.now() - r.prevTime) / 2, r.y = (s.touchesCurrent.y - r.prevPositionY) / (Date.now() - r.prevTime) / 2, Math.abs(s.touchesCurrent.x - r.prevPositionX) < 2 && (r.x = 0), Math.abs(s.touchesCurrent.y - r.prevPositionY) < 2 && (r.y = 0), r.prevPositionX = s.touchesCurrent.x, r.prevPositionY = s.touchesCurrent.y, r.prevTime = Date.now(), i.$imageWrapEl.transform("translate3d(" + s.currentX + "px, " + s.currentY + "px,0)")
					}
				}
			},
			onTouchEnd: function() {
				var e = this.zoom,
					t = e.gesture,
					a = e.image,
					i = e.velocity;
				if (t.$imageEl && 0 !== t.$imageEl.length) {
					if (!a.isTouched || !a.isMoved) return a.isTouched = !1, void(a.isMoved = !1);
					a.isTouched = !1, a.isMoved = !1;
					var s = 300,
						r = 300,
						n = i.x * s,
						o = a.currentX + n,
						l = i.y * r,
						d = a.currentY + l;
					0 !== i.x && (s = Math.abs((o - a.currentX) / i.x)), 0 !== i.y && (r = Math.abs((d - a.currentY) / i.y));
					var p = Math.max(s, r);
					a.currentX = o, a.currentY = d;
					var c = a.width * e.scale,
						u = a.height * e.scale;
					a.minX = Math.min(t.slideWidth / 2 - c / 2, 0), a.maxX = -a.minX, a.minY = Math.min(t.slideHeight / 2 - u / 2, 0), a.maxY = -a.minY, a.currentX = Math.max(Math.min(a.currentX, a.maxX), a.minX), a.currentY = Math.max(Math.min(a.currentY, a.maxY), a.minY), t.$imageWrapEl.transition(p).transform("translate3d(" + a.currentX + "px, " + a.currentY + "px,0)")
				}
			},
			onTransitionEnd: function() {
				var e = this.zoom,
					t = e.gesture;
				t.$slideEl && this.previousIndex !== this.activeIndex && (t.$imageEl.transform("translate3d(0,0,0) scale(1)"), t.$imageWrapEl.transform("translate3d(0,0,0)"), t.$slideEl = void 0, t.$imageEl = void 0, t.$imageWrapEl = void 0, e.scale = 1, e.currentScale = 1)
			},
			toggle: function(e) {
				var t = this.zoom;
				t.scale && 1 !== t.scale ? t.out() : t.in(e)
			},
			in: function(e) {
				var t, a, i, s, r, n, o, l, d, p, c, u, h, v, f, m, g = this,
					b = g.zoom,
					w = g.params.zoom,
					y = b.gesture,
					x = b.image;
				(y.$slideEl || (y.$slideEl = g.clickedSlide ? L(g.clickedSlide) : g.slides.eq(g.activeIndex), y.$imageEl = y.$slideEl.find("img, svg, canvas"), y.$imageWrapEl = y.$imageEl.parent("." + w.containerClass)), y.$imageEl && 0 !== y.$imageEl.length) && (y.$slideEl.addClass("" + w.zoomedSlideClass), void 0 === x.touchesStart.x && e ? (t = "touchend" === e.type ? e.changedTouches[0].pageX : e.pageX, a = "touchend" === e.type ? e.changedTouches[0].pageY : e.pageY) : (t = x.touchesStart.x, a = x.touchesStart.y), b.scale = y.$imageWrapEl.attr("data-swiper-zoom") || w.maxRatio, b.currentScale = y.$imageWrapEl.attr("data-swiper-zoom") || w.maxRatio, e ? (f = y.$slideEl[0].offsetWidth, m = y.$slideEl[0].offsetHeight, i = y.$slideEl.offset().left + f / 2 - t, s = y.$slideEl.offset().top + m / 2 - a, o = y.$imageEl[0].offsetWidth, l = y.$imageEl[0].offsetHeight, d = o * b.scale, p = l * b.scale, h = -(c = Math.min(f / 2 - d / 2, 0)), v = -(u = Math.min(m / 2 - p / 2, 0)), (r = i * b.scale) < c && (r = c), h < r && (r = h), (n = s * b.scale) < u && (n = u), v < n && (n = v)) : n = r = 0, y.$imageWrapEl.transition(300).transform("translate3d(" + r + "px, " + n + "px,0)"), y.$imageEl.transition(300).transform("translate3d(0,0,0) scale(" + b.scale + ")"))
			},
			out: function() {
				var e = this,
					t = e.zoom,
					a = e.params.zoom,
					i = t.gesture;
				i.$slideEl || (i.$slideEl = e.clickedSlide ? L(e.clickedSlide) : e.slides.eq(e.activeIndex), i.$imageEl = i.$slideEl.find("img, svg, canvas"), i.$imageWrapEl = i.$imageEl.parent("." + a.containerClass)), i.$imageEl && 0 !== i.$imageEl.length && (t.scale = 1, t.currentScale = 1, i.$imageWrapEl.transition(300).transform("translate3d(0,0,0)"), i.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)"), i.$slideEl.removeClass("" + a.zoomedSlideClass), i.$slideEl = void 0)
			},
			enable: function() {
				var e = this,
					t = e.zoom;
				if (!t.enabled) {
					t.enabled = !0;
					var a = !("touchstart" !== e.touchEvents.start || !Y.passiveListener || !e.params.passiveListeners) && {
						passive: !0,
						capture: !1
					};
					Y.gestures ? (e.$wrapperEl.on("gesturestart", ".swiper-slide", t.onGestureStart, a), e.$wrapperEl.on("gesturechange", ".swiper-slide", t.onGestureChange, a), e.$wrapperEl.on("gestureend", ".swiper-slide", t.onGestureEnd, a)) : "touchstart" === e.touchEvents.start && (e.$wrapperEl.on(e.touchEvents.start, ".swiper-slide", t.onGestureStart, a), e.$wrapperEl.on(e.touchEvents.move, ".swiper-slide", t.onGestureChange, a), e.$wrapperEl.on(e.touchEvents.end, ".swiper-slide", t.onGestureEnd, a)), e.$wrapperEl.on(e.touchEvents.move, "." + e.params.zoom.containerClass, t.onTouchMove)
				}
			},
			disable: function() {
				var e = this,
					t = e.zoom;
				if (t.enabled) {
					e.zoom.enabled = !1;
					var a = !("touchstart" !== e.touchEvents.start || !Y.passiveListener || !e.params.passiveListeners) && {
						passive: !0,
						capture: !1
					};
					Y.gestures ? (e.$wrapperEl.off("gesturestart", ".swiper-slide", t.onGestureStart, a), e.$wrapperEl.off("gesturechange", ".swiper-slide", t.onGestureChange, a), e.$wrapperEl.off("gestureend", ".swiper-slide", t.onGestureEnd, a)) : "touchstart" === e.touchEvents.start && (e.$wrapperEl.off(e.touchEvents.start, ".swiper-slide", t.onGestureStart, a), e.$wrapperEl.off(e.touchEvents.move, ".swiper-slide", t.onGestureChange, a), e.$wrapperEl.off(e.touchEvents.end, ".swiper-slide", t.onGestureEnd, a)), e.$wrapperEl.off(e.touchEvents.move, "." + e.params.zoom.containerClass, t.onTouchMove)
				}
			}
		},
		q = {
			loadInSlide: function(e, l) {
				void 0 === l && (l = !0);
				var d = this,
					p = d.params.lazy;
				if (void 0 !== e && 0 !== d.slides.length) {
					var c = d.virtual && d.params.virtual.enabled ? d.$wrapperEl.children("." + d.params.slideClass + '[data-swiper-slide-index="' + e + '"]') : d.slides.eq(e),
						t = c.find("." + p.elementClass + ":not(." + p.loadedClass + "):not(." + p.loadingClass + ")");
					!c.hasClass(p.elementClass) || c.hasClass(p.loadedClass) || c.hasClass(p.loadingClass) || (t = t.add(c[0])), 0 !== t.length && t.each(function(e, t) {
						var i = L(t);
						i.addClass(p.loadingClass);
						var s = i.attr("data-background"),
							r = i.attr("data-src"),
							n = i.attr("data-srcset"),
							o = i.attr("data-sizes");
						d.loadImage(i[0], r || s, n, o, !1, function() {
							if (null != d && d && (!d || d.params) && !d.destroyed) {
								if (s ? (i.css("background-image", 'url("' + s + '")'), i.removeAttr("data-background")) : (n && (i.attr("srcset", n), i.removeAttr("data-srcset")), o && (i.attr("sizes", o), i.removeAttr("data-sizes")), r && (i.attr("src", r), i.removeAttr("data-src"))), i.addClass(p.loadedClass).removeClass(p.loadingClass), c.find("." + p.preloaderClass).remove(), d.params.loop && l) {
									var e = c.attr("data-swiper-slide-index");
									if (c.hasClass(d.params.slideDuplicateClass)) {
										var t = d.$wrapperEl.children('[data-swiper-slide-index="' + e + '"]:not(.' + d.params.slideDuplicateClass + ")");
										d.lazy.loadInSlide(t.index(), !1)
									} else {
										var a = d.$wrapperEl.children("." + d.params.slideDuplicateClass + '[data-swiper-slide-index="' + e + '"]');
										d.lazy.loadInSlide(a.index(), !1)
									}
								}
								d.emit("lazyImageReady", c[0], i[0])
							}
						}), d.emit("lazyImageLoad", c[0], i[0])
					})
				}
			},
			load: function() {
				var i = this,
					t = i.$wrapperEl,
					a = i.params,
					s = i.slides,
					e = i.activeIndex,
					r = i.virtual && a.virtual.enabled,
					n = a.lazy,
					o = a.slidesPerView;

				function l(e) {
					if (r) {
						if (t.children("." + a.slideClass + '[data-swiper-slide-index="' + e + '"]').length) return !0
					} else if (s[e]) return !0;
					return !1
				}

				function d(e) {
					return r ? L(e).attr("data-swiper-slide-index") : L(e).index()
				}
				if ("auto" === o && (o = 0), i.lazy.initialImageLoaded || (i.lazy.initialImageLoaded = !0), i.params.watchSlidesVisibility) t.children("." + a.slideVisibleClass).each(function(e, t) {
					var a = r ? L(t).attr("data-swiper-slide-index") : L(t).index();
					i.lazy.loadInSlide(a)
				});
				else if (1 < o)
					for (var p = e; p < e + o; p += 1) l(p) && i.lazy.loadInSlide(p);
				else i.lazy.loadInSlide(e);
				if (n.loadPrevNext)
					if (1 < o || n.loadPrevNextAmount && 1 < n.loadPrevNextAmount) {
						for (var c = n.loadPrevNextAmount, u = o, h = Math.min(e + u + Math.max(c, u), s.length), v = Math.max(e - Math.max(u, c), 0), f = e + o; f < h; f += 1) l(f) && i.lazy.loadInSlide(f);
						for (var m = v; m < e; m += 1) l(m) && i.lazy.loadInSlide(m)
					} else {
						var g = t.children("." + a.slideNextClass);
						0 < g.length && i.lazy.loadInSlide(d(g));
						var b = t.children("." + a.slidePrevClass);
						0 < b.length && i.lazy.loadInSlide(d(b))
					}
			}
		},
		j = {
			LinearSpline: function(e, t) {
				var a, i, s, r, n, o = function(e, t) {
					for (i = -1, a = e.length; 1 < a - i;) e[s = a + i >> 1] <= t ? i = s : a = s;
					return a
				};
				return this.x = e, this.y = t, this.lastIndex = e.length - 1, this.interpolate = function(e) {
					return e ? (n = o(this.x, e), r = n - 1, (e - this.x[r]) * (this.y[n] - this.y[r]) / (this.x[n] - this.x[r]) + this.y[r]) : 0
				}, this
			},
			getInterpolateFunction: function(e) {
				var t = this;
				t.controller.spline || (t.controller.spline = t.params.loop ? new j.LinearSpline(t.slidesGrid, e.slidesGrid) : new j.LinearSpline(t.snapGrid, e.snapGrid))
			},
			setTranslate: function(e, t) {
				var a, i, s = this,
					r = s.controller.control;

				function n(e) {
					var t = s.rtlTranslate ? -s.translate : s.translate;
					"slide" === s.params.controller.by && (s.controller.getInterpolateFunction(e), i = -s.controller.spline.interpolate(-t)), i && "container" !== s.params.controller.by || (a = (e.maxTranslate() - e.minTranslate()) / (s.maxTranslate() - s.minTranslate()), i = (t - s.minTranslate()) * a + e.minTranslate()), s.params.controller.inverse && (i = e.maxTranslate() - i), e.updateProgress(i), e.setTranslate(i, s), e.updateActiveIndex(), e.updateSlidesClasses()
				}
				if (Array.isArray(r))
					for (var o = 0; o < r.length; o += 1) r[o] !== t && r[o] instanceof S && n(r[o]);
				else r instanceof S && t !== r && n(r)
			},
			setTransition: function(t, e) {
				var a, i = this,
					s = i.controller.control;

				function r(e) {
					e.setTransition(t, i), 0 !== t && (e.transitionStart(), e.params.autoHeight && X.nextTick(function() {
						e.updateAutoHeight()
					}), e.$wrapperEl.transitionEnd(function() {
						s && (e.params.loop && "slide" === i.params.controller.by && e.loopFix(), e.transitionEnd())
					}))
				}
				if (Array.isArray(s))
					for (a = 0; a < s.length; a += 1) s[a] !== e && s[a] instanceof S && r(s[a]);
				else s instanceof S && e !== s && r(s)
			}
		},
		K = {
			makeElFocusable: function(e) {
				return e.attr("tabIndex", "0"), e
			},
			addElRole: function(e, t) {
				return e.attr("role", t), e
			},
			addElLabel: function(e, t) {
				return e.attr("aria-label", t), e
			},
			disableEl: function(e) {
				return e.attr("aria-disabled", !0), e
			},
			enableEl: function(e) {
				return e.attr("aria-disabled", !1), e
			},
			onEnterKey: function(e) {
				var t = this,
					a = t.params.a11y;
				if (13 === e.keyCode) {
					var i = L(e.target);
					t.navigation && t.navigation.$nextEl && i.is(t.navigation.$nextEl) && (t.isEnd && !t.params.loop || t.slideNext(), t.isEnd ? t.a11y.notify(a.lastSlideMessage) : t.a11y.notify(a.nextSlideMessage)), t.navigation && t.navigation.$prevEl && i.is(t.navigation.$prevEl) && (t.isBeginning && !t.params.loop || t.slidePrev(), t.isBeginning ? t.a11y.notify(a.firstSlideMessage) : t.a11y.notify(a.prevSlideMessage)), t.pagination && i.is("." + t.params.pagination.bulletClass) && i[0].click()
				}
			},
			notify: function(e) {
				var t = this.a11y.liveRegion;
				0 !== t.length && (t.html(""), t.html(e))
			},
			updateNavigation: function() {
				var e = this;
				if (!e.params.loop) {
					var t = e.navigation,
						a = t.$nextEl,
						i = t.$prevEl;
					i && 0 < i.length && (e.isBeginning ? e.a11y.disableEl(i) : e.a11y.enableEl(i)), a && 0 < a.length && (e.isEnd ? e.a11y.disableEl(a) : e.a11y.enableEl(a))
				}
			},
			updatePagination: function() {
				var i = this,
					s = i.params.a11y;
				i.pagination && i.params.pagination.clickable && i.pagination.bullets && i.pagination.bullets.length && i.pagination.bullets.each(function(e, t) {
					var a = L(t);
					i.a11y.makeElFocusable(a), i.a11y.addElRole(a, "button"), i.a11y.addElLabel(a, s.paginationBulletMessage.replace(/{{index}}/, a.index() + 1))
				})
			},
			init: function() {
				var e = this;
				e.$el.append(e.a11y.liveRegion);
				var t, a, i = e.params.a11y;
				e.navigation && e.navigation.$nextEl && (t = e.navigation.$nextEl), e.navigation && e.navigation.$prevEl && (a = e.navigation.$prevEl), t && (e.a11y.makeElFocusable(t), e.a11y.addElRole(t, "button"), e.a11y.addElLabel(t, i.nextSlideMessage), t.on("keydown", e.a11y.onEnterKey)), a && (e.a11y.makeElFocusable(a), e.a11y.addElRole(a, "button"), e.a11y.addElLabel(a, i.prevSlideMessage), a.on("keydown", e.a11y.onEnterKey)), e.pagination && e.params.pagination.clickable && e.pagination.bullets && e.pagination.bullets.length && e.pagination.$el.on("keydown", "." + e.params.pagination.bulletClass, e.a11y.onEnterKey)
			},
			destroy: function() {
				var e, t, a = this;
				a.a11y.liveRegion && 0 < a.a11y.liveRegion.length && a.a11y.liveRegion.remove(), a.navigation && a.navigation.$nextEl && (e = a.navigation.$nextEl), a.navigation && a.navigation.$prevEl && (t = a.navigation.$prevEl), e && e.off("keydown", a.a11y.onEnterKey), t && t.off("keydown", a.a11y.onEnterKey), a.pagination && a.params.pagination.clickable && a.pagination.bullets && a.pagination.bullets.length && a.pagination.$el.off("keydown", "." + a.params.pagination.bulletClass, a.a11y.onEnterKey)
			}
		},
		U = {
			init: function() {
				var e = this;
				if (e.params.history) {
					if (!B.history || !B.history.pushState) return e.params.history.enabled = !1, void(e.params.hashNavigation.enabled = !0);
					var t = e.history;
					t.initialized = !0, t.paths = U.getPathValues(), (t.paths.key || t.paths.value) && (t.scrollToSlide(0, t.paths.value, e.params.runCallbacksOnInit), e.params.history.replaceState || B.addEventListener("popstate", e.history.setHistoryPopState))
				}
			},
			destroy: function() {
				this.params.history.replaceState || B.removeEventListener("popstate", this.history.setHistoryPopState)
			},
			setHistoryPopState: function() {
				this.history.paths = U.getPathValues(), this.history.scrollToSlide(this.params.speed, this.history.paths.value, !1)
			},
			getPathValues: function() {
				var e = B.location.pathname.slice(1).split("/").filter(function(e) {
						return "" !== e
					}),
					t = e.length;
				return {
					key: e[t - 2],
					value: e[t - 1]
				}
			},
			setHistory: function(e, t) {
				if (this.history.initialized && this.params.history.enabled) {
					var a = this.slides.eq(t),
						i = U.slugify(a.attr("data-history"));
					B.location.pathname.includes(e) || (i = e + "/" + i);
					var s = B.history.state;
					s && s.value === i || (this.params.history.replaceState ? B.history.replaceState({
						value: i
					}, null, i) : B.history.pushState({
						value: i
					}, null, i))
				}
			},
			slugify: function(e) {
				return e.toString().toLowerCase().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "")
			},
			scrollToSlide: function(e, t, a) {
				var i = this;
				if (t)
					for (var s = 0, r = i.slides.length; s < r; s += 1) {
						var n = i.slides.eq(s);
						if (U.slugify(n.attr("data-history")) === t && !n.hasClass(i.params.slideDuplicateClass)) {
							var o = n.index();
							i.slideTo(o, e, a)
						}
					} else i.slideTo(0, e, a)
			}
		},
		_ = {
			onHashCange: function() {
				var e = this,
					t = f.location.hash.replace("#", "");
				t !== e.slides.eq(e.activeIndex).attr("data-hash") && e.slideTo(e.$wrapperEl.children("." + e.params.slideClass + '[data-hash="' + t + '"]').index())
			},
			setHash: function() {
				var e = this;
				if (e.hashNavigation.initialized && e.params.hashNavigation.enabled)
					if (e.params.hashNavigation.replaceState && B.history && B.history.replaceState) B.history.replaceState(null, null, "#" + e.slides.eq(e.activeIndex).attr("data-hash") || "");
					else {
						var t = e.slides.eq(e.activeIndex),
							a = t.attr("data-hash") || t.attr("data-history");
						f.location.hash = a || ""
					}
			},
			init: function() {
				var e = this;
				if (!(!e.params.hashNavigation.enabled || e.params.history && e.params.history.enabled)) {
					e.hashNavigation.initialized = !0;
					var t = f.location.hash.replace("#", "");
					if (t)
						for (var a = 0, i = e.slides.length; a < i; a += 1) {
							var s = e.slides.eq(a);
							if ((s.attr("data-hash") || s.attr("data-history")) === t && !s.hasClass(e.params.slideDuplicateClass)) {
								var r = s.index();
								e.slideTo(r, 0, e.params.runCallbacksOnInit, !0)
							}
						}
					e.params.hashNavigation.watchState && L(B).on("hashchange", e.hashNavigation.onHashCange)
				}
			},
			destroy: function() {
				this.params.hashNavigation.watchState && L(B).off("hashchange", this.hashNavigation.onHashCange)
			}
		},
		Z = {
			run: function() {
				var e = this,
					t = e.slides.eq(e.activeIndex),
					a = e.params.autoplay.delay;
				t.attr("data-swiper-autoplay") && (a = t.attr("data-swiper-autoplay") || e.params.autoplay.delay), e.autoplay.timeout = X.nextTick(function() {
					e.params.autoplay.reverseDirection ? e.params.loop ? (e.loopFix(), e.slidePrev(e.params.speed, !0, !0), e.emit("autoplay")) : e.isBeginning ? e.params.autoplay.stopOnLastSlide ? e.autoplay.stop() : (e.slideTo(e.slides.length - 1, e.params.speed, !0, !0), e.emit("autoplay")) : (e.slidePrev(e.params.speed, !0, !0), e.emit("autoplay")) : e.params.loop ? (e.loopFix(), e.slideNext(e.params.speed, !0, !0), e.emit("autoplay")) : e.isEnd ? e.params.autoplay.stopOnLastSlide ? e.autoplay.stop() : (e.slideTo(0, e.params.speed, !0, !0), e.emit("autoplay")) : (e.slideNext(e.params.speed, !0, !0), e.emit("autoplay"))
				}, a)
			},
			start: function() {
				var e = this;
				return void 0 === e.autoplay.timeout && (!e.autoplay.running && (e.autoplay.running = !0, e.emit("autoplayStart"), e.autoplay.run(), !0))
			},
			stop: function() {
				var e = this;
				return !!e.autoplay.running && (void 0 !== e.autoplay.timeout && (e.autoplay.timeout && (clearTimeout(e.autoplay.timeout), e.autoplay.timeout = void 0), e.autoplay.running = !1, e.emit("autoplayStop"), !0))
			},
			pause: function(e) {
				var t = this;
				t.autoplay.running && (t.autoplay.paused || (t.autoplay.timeout && clearTimeout(t.autoplay.timeout), t.autoplay.paused = !0, 0 !== e && t.params.autoplay.waitForTransition ? (t.$wrapperEl[0].addEventListener("transitionend", t.autoplay.onTransitionEnd), t.$wrapperEl[0].addEventListener("webkitTransitionEnd", t.autoplay.onTransitionEnd)) : (t.autoplay.paused = !1, t.autoplay.run())))
			}
		},
		Q = {
			setTranslate: function() {
				for (var e = this, t = e.slides, a = 0; a < t.length; a += 1) {
					var i = e.slides.eq(a),
						s = -i[0].swiperSlideOffset;
					e.params.virtualTranslate || (s -= e.translate);
					var r = 0;
					e.isHorizontal() || (r = s, s = 0);
					var n = e.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(i[0].progress), 0) : 1 + Math.min(Math.max(i[0].progress, -1), 0);
					i.css({
						opacity: n
					}).transform("translate3d(" + s + "px, " + r + "px, 0px)")
				}
			},
			setTransition: function(e) {
				var a = this,
					t = a.slides,
					i = a.$wrapperEl;
				if (t.transition(e), a.params.virtualTranslate && 0 !== e) {
					var s = !1;
					t.transitionEnd(function() {
						if (!s && a && !a.destroyed) {
							s = !0, a.animating = !1;
							for (var e = ["webkitTransitionEnd", "transitionend"], t = 0; t < e.length; t += 1) i.trigger(e[t])
						}
					})
				}
			}
		},
		J = {
			setTranslate: function() {
				var e, t = this,
					a = t.$el,
					i = t.$wrapperEl,
					s = t.slides,
					r = t.width,
					n = t.height,
					o = t.rtlTranslate,
					l = t.size,
					d = t.params.cubeEffect,
					p = t.isHorizontal(),
					c = t.virtual && t.params.virtual.enabled,
					u = 0;
				d.shadow && (p ? (0 === (e = i.find(".swiper-cube-shadow")).length && (e = L('<div class="swiper-cube-shadow"></div>'), i.append(e)), e.css({
					height: r + "px"
				})) : 0 === (e = a.find(".swiper-cube-shadow")).length && (e = L('<div class="swiper-cube-shadow"></div>'), a.append(e)));
				for (var h = 0; h < s.length; h += 1) {
					var v = s.eq(h),
						f = h;
					c && (f = parseInt(v.attr("data-swiper-slide-index"), 10));
					var m = 90 * f,
						g = Math.floor(m / 360);
					o && (m = -m, g = Math.floor(-m / 360));
					var b = Math.max(Math.min(v[0].progress, 1), -1),
						w = 0,
						y = 0,
						x = 0;
					f % 4 == 0 ? (w = 4 * -g * l, x = 0) : (f - 1) % 4 == 0 ? (w = 0, x = 4 * -g * l) : (f - 2) % 4 == 0 ? (w = l + 4 * g * l, x = l) : (f - 3) % 4 == 0 && (w = -l, x = 3 * l + 4 * l * g), o && (w = -w), p || (y = w, w = 0);
					var E = "rotateX(" + (p ? 0 : -m) + "deg) rotateY(" + (p ? m : 0) + "deg) translate3d(" + w + "px, " + y + "px, " + x + "px)";
					if (b <= 1 && -1 < b && (u = 90 * f + 90 * b, o && (u = 90 * -f - 90 * b)), v.transform(E), d.slideShadows) {
						var T = p ? v.find(".swiper-slide-shadow-left") : v.find(".swiper-slide-shadow-top"),
							S = p ? v.find(".swiper-slide-shadow-right") : v.find(".swiper-slide-shadow-bottom");
						0 === T.length && (T = L('<div class="swiper-slide-shadow-' + (p ? "left" : "top") + '"></div>'), v.append(T)), 0 === S.length && (S = L('<div class="swiper-slide-shadow-' + (p ? "right" : "bottom") + '"></div>'), v.append(S)), T.length && (T[0].style.opacity = Math.max(-b, 0)), S.length && (S[0].style.opacity = Math.max(b, 0))
					}
				}
				if (i.css({
						"-webkit-transform-origin": "50% 50% -" + l / 2 + "px",
						"-moz-transform-origin": "50% 50% -" + l / 2 + "px",
						"-ms-transform-origin": "50% 50% -" + l / 2 + "px",
						"transform-origin": "50% 50% -" + l / 2 + "px"
					}), d.shadow)
					if (p) e.transform("translate3d(0px, " + (r / 2 + d.shadowOffset) + "px, " + -r / 2 + "px) rotateX(90deg) rotateZ(0deg) scale(" + d.shadowScale + ")");
					else {
						var C = Math.abs(u) - 90 * Math.floor(Math.abs(u) / 90),
							M = 1.5 - (Math.sin(2 * C * Math.PI / 360) / 2 + Math.cos(2 * C * Math.PI / 360) / 2),
							z = d.shadowScale,
							k = d.shadowScale / M,
							P = d.shadowOffset;
						e.transform("scale3d(" + z + ", 1, " + k + ") translate3d(0px, " + (n / 2 + P) + "px, " + -n / 2 / k + "px) rotateX(-90deg)")
					} var $ = I.isSafari || I.isUiWebView ? -l / 2 : 0;
				i.transform("translate3d(0px,0," + $ + "px) rotateX(" + (t.isHorizontal() ? 0 : u) + "deg) rotateY(" + (t.isHorizontal() ? -u : 0) + "deg)")
			},
			setTransition: function(e) {
				var t = this.$el;
				this.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e), this.params.cubeEffect.shadow && !this.isHorizontal() && t.find(".swiper-cube-shadow").transition(e)
			}
		},
		ee = {
			setTranslate: function() {
				for (var e = this, t = e.slides, a = e.rtlTranslate, i = 0; i < t.length; i += 1) {
					var s = t.eq(i),
						r = s[0].progress;
					e.params.flipEffect.limitRotation && (r = Math.max(Math.min(s[0].progress, 1), -1));
					var n = -180 * r,
						o = 0,
						l = -s[0].swiperSlideOffset,
						d = 0;
					if (e.isHorizontal() ? a && (n = -n) : (d = l, o = -n, n = l = 0), s[0].style.zIndex = -Math.abs(Math.round(r)) + t.length, e.params.flipEffect.slideShadows) {
						var p = e.isHorizontal() ? s.find(".swiper-slide-shadow-left") : s.find(".swiper-slide-shadow-top"),
							c = e.isHorizontal() ? s.find(".swiper-slide-shadow-right") : s.find(".swiper-slide-shadow-bottom");
						0 === p.length && (p = L('<div class="swiper-slide-shadow-' + (e.isHorizontal() ? "left" : "top") + '"></div>'), s.append(p)), 0 === c.length && (c = L('<div class="swiper-slide-shadow-' + (e.isHorizontal() ? "right" : "bottom") + '"></div>'), s.append(c)), p.length && (p[0].style.opacity = Math.max(-r, 0)), c.length && (c[0].style.opacity = Math.max(r, 0))
					}
					s.transform("translate3d(" + l + "px, " + d + "px, 0px) rotateX(" + o + "deg) rotateY(" + n + "deg)")
				}
			},
			setTransition: function(e) {
				var a = this,
					t = a.slides,
					i = a.activeIndex,
					s = a.$wrapperEl;
				if (t.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e), a.params.virtualTranslate && 0 !== e) {
					var r = !1;
					t.eq(i).transitionEnd(function() {
						if (!r && a && !a.destroyed) {
							r = !0, a.animating = !1;
							for (var e = ["webkitTransitionEnd", "transitionend"], t = 0; t < e.length; t += 1) s.trigger(e[t])
						}
					})
				}
			}
		},
		te = {
			setTranslate: function() {
				for (var e = this, t = e.width, a = e.height, i = e.slides, s = e.$wrapperEl, r = e.slidesSizesGrid, n = e.params.coverflowEffect, o = e.isHorizontal(), l = e.translate, d = o ? t / 2 - l : a / 2 - l, p = o ? n.rotate : -n.rotate, c = n.depth, u = 0, h = i.length; u < h; u += 1) {
					var v = i.eq(u),
						f = r[u],
						m = (d - v[0].swiperSlideOffset - f / 2) / f * n.modifier,
						g = o ? p * m : 0,
						b = o ? 0 : p * m,
						w = -c * Math.abs(m),
						y = o ? 0 : n.stretch * m,
						x = o ? n.stretch * m : 0;
					Math.abs(x) < .001 && (x = 0), Math.abs(y) < .001 && (y = 0), Math.abs(w) < .001 && (w = 0), Math.abs(g) < .001 && (g = 0), Math.abs(b) < .001 && (b = 0);
					var E = "translate3d(" + x + "px," + y + "px," + w + "px)  rotateX(" + b + "deg) rotateY(" + g + "deg)";
					if (v.transform(E), v[0].style.zIndex = 1 - Math.abs(Math.round(m)), n.slideShadows) {
						var T = o ? v.find(".swiper-slide-shadow-left") : v.find(".swiper-slide-shadow-top"),
							S = o ? v.find(".swiper-slide-shadow-right") : v.find(".swiper-slide-shadow-bottom");
						0 === T.length && (T = L('<div class="swiper-slide-shadow-' + (o ? "left" : "top") + '"></div>'), v.append(T)), 0 === S.length && (S = L('<div class="swiper-slide-shadow-' + (o ? "right" : "bottom") + '"></div>'), v.append(S)), T.length && (T[0].style.opacity = 0 < m ? m : 0), S.length && (S[0].style.opacity = 0 < -m ? -m : 0)
					}
				}(Y.pointerEvents || Y.prefixedPointerEvents) && (s[0].style.perspectiveOrigin = d + "px 50%")
			},
			setTransition: function(e) {
				this.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e)
			}
		},
		ae = [C, M, z, k, $, O, H, {
			name: "mousewheel",
			params: {
				mousewheel: {
					enabled: !1,
					releaseOnEdges: !1,
					invert: !1,
					forceToAxis: !1,
					sensitivity: 1,
					eventsTarged: "container"
				}
			},
			create: function() {
				var e = this;
				X.extend(e, {
					mousewheel: {
						enabled: !1,
						enable: G.enable.bind(e),
						disable: G.disable.bind(e),
						handle: G.handle.bind(e),
						handleMouseEnter: G.handleMouseEnter.bind(e),
						handleMouseLeave: G.handleMouseLeave.bind(e),
						lastScrollTime: X.now()
					}
				})
			},
			on: {
				init: function() {
					this.params.mousewheel.enabled && this.mousewheel.enable()
				},
				destroy: function() {
					this.mousewheel.enabled && this.mousewheel.disable()
				}
			}
		}, {
			name: "navigation",
			params: {
				navigation: {
					nextEl: null,
					prevEl: null,
					hideOnClick: !1,
					disabledClass: "swiper-button-disabled",
					hiddenClass: "swiper-button-hidden",
					lockClass: "swiper-button-lock"
				}
			},
			create: function() {
				X.extend(this, {
					navigation: {
						init: N.init.bind(this),
						update: N.update.bind(this),
						destroy: N.destroy.bind(this)
					}
				})
			},
			on: {
				init: function() {
					this.navigation.init(), this.navigation.update()
				},
				toEdge: function() {
					this.navigation.update()
				},
				fromEdge: function() {
					this.navigation.update()
				},
				destroy: function() {
					this.navigation.destroy()
				},
				click: function(e) {
					var t = this.navigation,
						a = t.$nextEl,
						i = t.$prevEl;
					!this.params.navigation.hideOnClick || L(e.target).is(i) || L(e.target).is(a) || (a && a.toggleClass(this.params.navigation.hiddenClass), i && i.toggleClass(this.params.navigation.hiddenClass))
				}
			}
		}, {
			name: "pagination",
			params: {
				pagination: {
					el: null,
					bulletElement: "span",
					clickable: !1,
					hideOnClick: !1,
					renderBullet: null,
					renderProgressbar: null,
					renderFraction: null,
					renderCustom: null,
					progressbarOpposite: !1,
					type: "bullets",
					dynamicBullets: !1,
					dynamicMainBullets: 1,
					formatFractionCurrent: function(e) {
						return e
					},
					formatFractionTotal: function(e) {
						return e
					},
					bulletClass: "swiper-pagination-bullet",
					bulletActiveClass: "swiper-pagination-bullet-active",
					modifierClass: "swiper-pagination-",
					currentClass: "swiper-pagination-current",
					totalClass: "swiper-pagination-total",
					hiddenClass: "swiper-pagination-hidden",
					progressbarFillClass: "swiper-pagination-progressbar-fill",
					progressbarOppositeClass: "swiper-pagination-progressbar-opposite",
					clickableClass: "swiper-pagination-clickable",
					lockClass: "swiper-pagination-lock"
				}
			},
			create: function() {
				var e = this;
				X.extend(e, {
					pagination: {
						init: V.init.bind(e),
						render: V.render.bind(e),
						update: V.update.bind(e),
						destroy: V.destroy.bind(e),
						dynamicBulletIndex: 0
					}
				})
			},
			on: {
				init: function() {
					this.pagination.init(), this.pagination.render(), this.pagination.update()
				},
				activeIndexChange: function() {
					this.params.loop ? this.pagination.update() : void 0 === this.snapIndex && this.pagination.update()
				},
				snapIndexChange: function() {
					this.params.loop || this.pagination.update()
				},
				slidesLengthChange: function() {
					this.params.loop && (this.pagination.render(), this.pagination.update())
				},
				snapGridLengthChange: function() {
					this.params.loop || (this.pagination.render(), this.pagination.update())
				},
				destroy: function() {
					this.pagination.destroy()
				},
				click: function(e) {
					var t = this;
					t.params.pagination.el && t.params.pagination.hideOnClick && 0 < t.pagination.$el.length && !L(e.target).hasClass(t.params.pagination.bulletClass) && t.pagination.$el.toggleClass(t.params.pagination.hiddenClass)
				}
			}
		}, {
			name: "scrollbar",
			params: {
				scrollbar: {
					el: null,
					dragSize: "auto",
					hide: !1,
					draggable: !1,
					snapOnRelease: !0,
					lockClass: "swiper-scrollbar-lock",
					dragClass: "swiper-scrollbar-drag"
				}
			},
			create: function() {
				var e = this;
				X.extend(e, {
					scrollbar: {
						init: R.init.bind(e),
						destroy: R.destroy.bind(e),
						updateSize: R.updateSize.bind(e),
						setTranslate: R.setTranslate.bind(e),
						setTransition: R.setTransition.bind(e),
						enableDraggable: R.enableDraggable.bind(e),
						disableDraggable: R.disableDraggable.bind(e),
						setDragPosition: R.setDragPosition.bind(e),
						onDragStart: R.onDragStart.bind(e),
						onDragMove: R.onDragMove.bind(e),
						onDragEnd: R.onDragEnd.bind(e),
						isTouched: !1,
						timeout: null,
						dragTimeout: null
					}
				})
			},
			on: {
				init: function() {
					this.scrollbar.init(), this.scrollbar.updateSize(), this.scrollbar.setTranslate()
				},
				update: function() {
					this.scrollbar.updateSize()
				},
				resize: function() {
					this.scrollbar.updateSize()
				},
				observerUpdate: function() {
					this.scrollbar.updateSize()
				},
				setTranslate: function() {
					this.scrollbar.setTranslate()
				},
				setTransition: function(e) {
					this.scrollbar.setTransition(e)
				},
				destroy: function() {
					this.scrollbar.destroy()
				}
			}
		}, {
			name: "parallax",
			params: {
				parallax: {
					enabled: !1
				}
			},
			create: function() {
				X.extend(this, {
					parallax: {
						setTransform: F.setTransform.bind(this),
						setTranslate: F.setTranslate.bind(this),
						setTransition: F.setTransition.bind(this)
					}
				})
			},
			on: {
				beforeInit: function() {
					this.params.parallax.enabled && (this.params.watchSlidesProgress = !0)
				},
				init: function() {
					this.params.parallax && this.parallax.setTranslate()
				},
				setTranslate: function() {
					this.params.parallax && this.parallax.setTranslate()
				},
				setTransition: function(e) {
					this.params.parallax && this.parallax.setTransition(e)
				}
			}
		}, {
			name: "zoom",
			params: {
				zoom: {
					enabled: !1,
					maxRatio: 3,
					minRatio: 1,
					toggle: !0,
					containerClass: "swiper-zoom-container",
					zoomedSlideClass: "swiper-slide-zoomed"
				}
			},
			create: function() {
				var t = this,
					a = {
						enabled: !1,
						scale: 1,
						currentScale: 1,
						isScaling: !1,
						gesture: {
							$slideEl: void 0,
							slideWidth: void 0,
							slideHeight: void 0,
							$imageEl: void 0,
							$imageWrapEl: void 0,
							maxRatio: 3
						},
						image: {
							isTouched: void 0,
							isMoved: void 0,
							currentX: void 0,
							currentY: void 0,
							minX: void 0,
							minY: void 0,
							maxX: void 0,
							maxY: void 0,
							width: void 0,
							height: void 0,
							startX: void 0,
							startY: void 0,
							touchesStart: {},
							touchesCurrent: {}
						},
						velocity: {
							x: void 0,
							y: void 0,
							prevPositionX: void 0,
							prevPositionY: void 0,
							prevTime: void 0
						}
					};
				"onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out".split(" ").forEach(function(e) {
					a[e] = W[e].bind(t)
				}), X.extend(t, {
					zoom: a
				})
			},
			on: {
				init: function() {
					this.params.zoom.enabled && this.zoom.enable()
				},
				destroy: function() {
					this.zoom.disable()
				},
				touchStart: function(e) {
					this.zoom.enabled && this.zoom.onTouchStart(e)
				},
				touchEnd: function(e) {
					this.zoom.enabled && this.zoom.onTouchEnd(e)
				},
				doubleTap: function(e) {
					this.params.zoom.enabled && this.zoom.enabled && this.params.zoom.toggle && this.zoom.toggle(e)
				},
				transitionEnd: function() {
					this.zoom.enabled && this.params.zoom.enabled && this.zoom.onTransitionEnd()
				}
			}
		}, {
			name: "lazy",
			params: {
				lazy: {
					enabled: !1,
					loadPrevNext: !1,
					loadPrevNextAmount: 1,
					loadOnTransitionStart: !1,
					elementClass: "swiper-lazy",
					loadingClass: "swiper-lazy-loading",
					loadedClass: "swiper-lazy-loaded",
					preloaderClass: "swiper-lazy-preloader"
				}
			},
			create: function() {
				X.extend(this, {
					lazy: {
						initialImageLoaded: !1,
						load: q.load.bind(this),
						loadInSlide: q.loadInSlide.bind(this)
					}
				})
			},
			on: {
				beforeInit: function() {
					this.params.lazy.enabled && this.params.preloadImages && (this.params.preloadImages = !1)
				},
				init: function() {
					this.params.lazy.enabled && !this.params.loop && 0 === this.params.initialSlide && this.lazy.load()
				},
				scroll: function() {
					this.params.freeMode && !this.params.freeModeSticky && this.lazy.load()
				},
				resize: function() {
					this.params.lazy.enabled && this.lazy.load()
				},
				scrollbarDragMove: function() {
					this.params.lazy.enabled && this.lazy.load()
				},
				transitionStart: function() {
					var e = this;
					e.params.lazy.enabled && (e.params.lazy.loadOnTransitionStart || !e.params.lazy.loadOnTransitionStart && !e.lazy.initialImageLoaded) && e.lazy.load()
				},
				transitionEnd: function() {
					this.params.lazy.enabled && !this.params.lazy.loadOnTransitionStart && this.lazy.load()
				}
			}
		}, {
			name: "controller",
			params: {
				controller: {
					control: void 0,
					inverse: !1,
					by: "slide"
				}
			},
			create: function() {
				var e = this;
				X.extend(e, {
					controller: {
						control: e.params.controller.control,
						getInterpolateFunction: j.getInterpolateFunction.bind(e),
						setTranslate: j.setTranslate.bind(e),
						setTransition: j.setTransition.bind(e)
					}
				})
			},
			on: {
				update: function() {
					this.controller.control && this.controller.spline && (this.controller.spline = void 0, delete this.controller.spline)
				},
				resize: function() {
					this.controller.control && this.controller.spline && (this.controller.spline = void 0, delete this.controller.spline)
				},
				observerUpdate: function() {
					this.controller.control && this.controller.spline && (this.controller.spline = void 0, delete this.controller.spline)
				},
				setTranslate: function(e, t) {
					this.controller.control && this.controller.setTranslate(e, t)
				},
				setTransition: function(e, t) {
					this.controller.control && this.controller.setTransition(e, t)
				}
			}
		}, {
			name: "a11y",
			params: {
				a11y: {
					enabled: !0,
					notificationClass: "swiper-notification",
					prevSlideMessage: "Previous slide",
					nextSlideMessage: "Next slide",
					firstSlideMessage: "This is the first slide",
					lastSlideMessage: "This is the last slide",
					paginationBulletMessage: "Go to slide {{index}}"
				}
			},
			create: function() {
				var t = this;
				X.extend(t, {
					a11y: {
						liveRegion: L('<span class="' + t.params.a11y.notificationClass + '" aria-live="assertive" aria-atomic="true"></span>')
					}
				}), Object.keys(K).forEach(function(e) {
					t.a11y[e] = K[e].bind(t)
				})
			},
			on: {
				init: function() {
					this.params.a11y.enabled && (this.a11y.init(), this.a11y.updateNavigation())
				},
				toEdge: function() {
					this.params.a11y.enabled && this.a11y.updateNavigation()
				},
				fromEdge: function() {
					this.params.a11y.enabled && this.a11y.updateNavigation()
				},
				paginationUpdate: function() {
					this.params.a11y.enabled && this.a11y.updatePagination()
				},
				destroy: function() {
					this.params.a11y.enabled && this.a11y.destroy()
				}
			}
		}, {
			name: "history",
			params: {
				history: {
					enabled: !1,
					replaceState: !1,
					key: "slides"
				}
			},
			create: function() {
				var e = this;
				X.extend(e, {
					history: {
						init: U.init.bind(e),
						setHistory: U.setHistory.bind(e),
						setHistoryPopState: U.setHistoryPopState.bind(e),
						scrollToSlide: U.scrollToSlide.bind(e),
						destroy: U.destroy.bind(e)
					}
				})
			},
			on: {
				init: function() {
					this.params.history.enabled && this.history.init()
				},
				destroy: function() {
					this.params.history.enabled && this.history.destroy()
				},
				transitionEnd: function() {
					this.history.initialized && this.history.setHistory(this.params.history.key, this.activeIndex)
				}
			}
		}, {
			name: "hash-navigation",
			params: {
				hashNavigation: {
					enabled: !1,
					replaceState: !1,
					watchState: !1
				}
			},
			create: function() {
				var e = this;
				X.extend(e, {
					hashNavigation: {
						initialized: !1,
						init: _.init.bind(e),
						destroy: _.destroy.bind(e),
						setHash: _.setHash.bind(e),
						onHashCange: _.onHashCange.bind(e)
					}
				})
			},
			on: {
				init: function() {
					this.params.hashNavigation.enabled && this.hashNavigation.init()
				},
				destroy: function() {
					this.params.hashNavigation.enabled && this.hashNavigation.destroy()
				},
				transitionEnd: function() {
					this.hashNavigation.initialized && this.hashNavigation.setHash()
				}
			}
		}, {
			name: "autoplay",
			params: {
				autoplay: {
					enabled: !1,
					delay: 3e3,
					waitForTransition: !0,
					disableOnInteraction: !0,
					stopOnLastSlide: !1,
					reverseDirection: !1
				}
			},
			create: function() {
				var t = this;
				X.extend(t, {
					autoplay: {
						running: !1,
						paused: !1,
						run: Z.run.bind(t),
						start: Z.start.bind(t),
						stop: Z.stop.bind(t),
						pause: Z.pause.bind(t),
						onTransitionEnd: function(e) {
							t && !t.destroyed && t.$wrapperEl && e.target === this && (t.$wrapperEl[0].removeEventListener("transitionend", t.autoplay.onTransitionEnd), t.$wrapperEl[0].removeEventListener("webkitTransitionEnd", t.autoplay.onTransitionEnd), t.autoplay.paused = !1, t.autoplay.running ? t.autoplay.run() : t.autoplay.stop())
						}
					}
				})
			},
			on: {
				init: function() {
					this.params.autoplay.enabled && this.autoplay.start()
				},
				beforeTransitionStart: function(e, t) {
					this.autoplay.running && (t || !this.params.autoplay.disableOnInteraction ? this.autoplay.pause(e) : this.autoplay.stop())
				},
				sliderFirstMove: function() {
					this.autoplay.running && (this.params.autoplay.disableOnInteraction ? this.autoplay.stop() : this.autoplay.pause())
				},
				destroy: function() {
					this.autoplay.running && this.autoplay.stop()
				}
			}
		}, {
			name: "effect-fade",
			params: {
				fadeEffect: {
					crossFade: !1
				}
			},
			create: function() {
				X.extend(this, {
					fadeEffect: {
						setTranslate: Q.setTranslate.bind(this),
						setTransition: Q.setTransition.bind(this)
					}
				})
			},
			on: {
				beforeInit: function() {
					var e = this;
					if ("fade" === e.params.effect) {
						e.classNames.push(e.params.containerModifierClass + "fade");
						var t = {
							slidesPerView: 1,
							slidesPerColumn: 1,
							slidesPerGroup: 1,
							watchSlidesProgress: !0,
							spaceBetween: 0,
							virtualTranslate: !0
						};
						X.extend(e.params, t), X.extend(e.originalParams, t)
					}
				},
				setTranslate: function() {
					"fade" === this.params.effect && this.fadeEffect.setTranslate()
				},
				setTransition: function(e) {
					"fade" === this.params.effect && this.fadeEffect.setTransition(e)
				}
			}
		}, {
			name: "effect-cube",
			params: {
				cubeEffect: {
					slideShadows: !0,
					shadow: !0,
					shadowOffset: 20,
					shadowScale: .94
				}
			},
			create: function() {
				X.extend(this, {
					cubeEffect: {
						setTranslate: J.setTranslate.bind(this),
						setTransition: J.setTransition.bind(this)
					}
				})
			},
			on: {
				beforeInit: function() {
					var e = this;
					if ("cube" === e.params.effect) {
						e.classNames.push(e.params.containerModifierClass + "cube"), e.classNames.push(e.params.containerModifierClass + "3d");
						var t = {
							slidesPerView: 1,
							slidesPerColumn: 1,
							slidesPerGroup: 1,
							watchSlidesProgress: !0,
							resistanceRatio: 0,
							spaceBetween: 0,
							centeredSlides: !1,
							virtualTranslate: !0
						};
						X.extend(e.params, t), X.extend(e.originalParams, t)
					}
				},
				setTranslate: function() {
					"cube" === this.params.effect && this.cubeEffect.setTranslate()
				},
				setTransition: function(e) {
					"cube" === this.params.effect && this.cubeEffect.setTransition(e)
				}
			}
		}, {
			name: "effect-flip",
			params: {
				flipEffect: {
					slideShadows: !0,
					limitRotation: !0
				}
			},
			create: function() {
				X.extend(this, {
					flipEffect: {
						setTranslate: ee.setTranslate.bind(this),
						setTransition: ee.setTransition.bind(this)
					}
				})
			},
			on: {
				beforeInit: function() {
					var e = this;
					if ("flip" === e.params.effect) {
						e.classNames.push(e.params.containerModifierClass + "flip"), e.classNames.push(e.params.containerModifierClass + "3d");
						var t = {
							slidesPerView: 1,
							slidesPerColumn: 1,
							slidesPerGroup: 1,
							watchSlidesProgress: !0,
							spaceBetween: 0,
							virtualTranslate: !0
						};
						X.extend(e.params, t), X.extend(e.originalParams, t)
					}
				},
				setTranslate: function() {
					"flip" === this.params.effect && this.flipEffect.setTranslate()
				},
				setTransition: function(e) {
					"flip" === this.params.effect && this.flipEffect.setTransition(e)
				}
			}
		}, {
			name: "effect-coverflow",
			params: {
				coverflowEffect: {
					rotate: 50,
					stretch: 0,
					depth: 100,
					modifier: 1,
					slideShadows: !0
				}
			},
			create: function() {
				X.extend(this, {
					coverflowEffect: {
						setTranslate: te.setTranslate.bind(this),
						setTransition: te.setTransition.bind(this)
					}
				})
			},
			on: {
				beforeInit: function() {
					var e = this;
					"coverflow" === e.params.effect && (e.classNames.push(e.params.containerModifierClass + "coverflow"), e.classNames.push(e.params.containerModifierClass + "3d"), e.params.watchSlidesProgress = !0, e.originalParams.watchSlidesProgress = !0)
				},
				setTranslate: function() {
					"coverflow" === this.params.effect && this.coverflowEffect.setTranslate()
				},
				setTransition: function(e) {
					"coverflow" === this.params.effect && this.coverflowEffect.setTransition(e)
				}
			}
		}];
	return void 0 === S.use && (S.use = S.Class.use, S.installModule = S.Class.installModule), S.use(ae), S
});
//# sourceMappingURL=swiper.min.js.map

/*!
 * Bootstrap v3.3.4 (http://getbootstrap.com)
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */
if ("undefined" == typeof jQuery) throw new Error("Bootstrap's JavaScript requires jQuery"); + function(a) {
	"use strict";
	var b = a.fn.jquery.split(" ")[0].split(".");
	if (b[0] < 2 && b[1] < 9 || 1 == b[0] && 9 == b[1] && b[2] < 1) throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher")
}(jQuery), + function(a) {
	"use strict";

	function b() {
		var a = document.createElement("bootstrap"),
			b = {
				WebkitTransition: "webkitTransitionEnd",
				MozTransition: "transitionend",
				OTransition: "oTransitionEnd otransitionend",
				transition: "transitionend"
			};
		for (var c in b)
			if (void 0 !== a.style[c]) return {
				end: b[c]
			};
		return !1
	}
	a.fn.emulateTransitionEnd = function(b) {
		var c = !1,
			d = this;
		a(this).one("bsTransitionEnd", function() {
			c = !0
		});
		var e = function() {
			c || a(d).trigger(a.support.transition.end)
		};
		return setTimeout(e, b), this
	}, a(function() {
		a.support.transition = b(), a.support.transition && (a.event.special.bsTransitionEnd = {
			bindType: a.support.transition.end,
			delegateType: a.support.transition.end,
			handle: function(b) {
				return a(b.target).is(this) ? b.handleObj.handler.apply(this, arguments) : void 0
			}
		})
	})
}(jQuery), + function(a) {
	"use strict";

	function b(b) {
		return this.each(function() {
			var c = a(this),
				e = c.data("bs.alert");
			e || c.data("bs.alert", e = new d(this)), "string" == typeof b && e[b].call(c)
		})
	}
	var c = '[data-dismiss="alert"]',
		d = function(b) {
			a(b).on("click", c, this.close)
		};
	d.VERSION = "3.3.4", d.TRANSITION_DURATION = 150, d.prototype.close = function(b) {
		function c() {
			g.detach().trigger("closed.bs.alert").remove()
		}
		var e = a(this),
			f = e.attr("data-target");
		f || (f = e.attr("href"), f = f && f.replace(/.*(?=#[^\s]*$)/, ""));
		var g = a(f);
		b && b.preventDefault(), g.length || (g = e.closest(".alert")), g.trigger(b = a.Event("close.bs.alert")), b.isDefaultPrevented() || (g.removeClass("in"), a.support.transition && g.hasClass("fade") ? g.one("bsTransitionEnd", c).emulateTransitionEnd(d.TRANSITION_DURATION) : c())
	};
	var e = a.fn.alert;
	a.fn.alert = b, a.fn.alert.Constructor = d, a.fn.alert.noConflict = function() {
		return a.fn.alert = e, this
	}, a(document).on("click.bs.alert.data-api", c, d.prototype.close)
}(jQuery), + function(a) {
	"use strict";

	function b(b) {
		return this.each(function() {
			var d = a(this),
				e = d.data("bs.button"),
				f = "object" == typeof b && b;
			e || d.data("bs.button", e = new c(this, f)), "toggle" == b ? e.toggle() : b && e.setState(b)
		})
	}
	var c = function(b, d) {
		this.$element = a(b), this.options = a.extend({}, c.DEFAULTS, d), this.isLoading = !1
	};
	c.VERSION = "3.3.4", c.DEFAULTS = {
		loadingText: "loading..."
	}, c.prototype.setState = function(b) {
		var c = "disabled",
			d = this.$element,
			e = d.is("input") ? "val" : "html",
			f = d.data();
		b += "Text", null == f.resetText && d.data("resetText", d[e]()), setTimeout(a.proxy(function() {
			d[e](null == f[b] ? this.options[b] : f[b]), "loadingText" == b ? (this.isLoading = !0, d.addClass(c).attr(c, c)) : this.isLoading && (this.isLoading = !1, d.removeClass(c).removeAttr(c))
		}, this), 0)
	}, c.prototype.toggle = function() {
		var a = !0,
			b = this.$element.closest('[data-toggle="buttons"]');
		if (b.length) {
			var c = this.$element.find("input");
			"radio" == c.prop("type") && (c.prop("checked") && this.$element.hasClass("active") ? a = !1 : b.find(".active").removeClass("active")), a && c.prop("checked", !this.$element.hasClass("active")).trigger("change")
		} else this.$element.attr("aria-pressed", !this.$element.hasClass("active"));
		a && this.$element.toggleClass("active")
	};
	var d = a.fn.button;
	a.fn.button = b, a.fn.button.Constructor = c, a.fn.button.noConflict = function() {
		return a.fn.button = d, this
	}, a(document).on("click.bs.button.data-api", '[data-toggle^="button"]', function(c) {
		var d = a(c.target);
		d.hasClass("btn") || (d = d.closest(".btn")), b.call(d, "toggle"), c.preventDefault()
	}).on("focus.bs.button.data-api blur.bs.button.data-api", '[data-toggle^="button"]', function(b) {
		a(b.target).closest(".btn").toggleClass("focus", /^focus(in)?$/.test(b.type))
	})
}(jQuery), + function(a) {
	"use strict";

	function b(b) {
		return this.each(function() {
			var d = a(this),
				e = d.data("bs.carousel"),
				f = a.extend({}, c.DEFAULTS, d.data(), "object" == typeof b && b),
				g = "string" == typeof b ? b : f.slide;
			e || d.data("bs.carousel", e = new c(this, f)), "number" == typeof b ? e.to(b) : g ? e[g]() : f.interval && e.pause().cycle()
		})
	}
	var c = function(b, c) {
		this.$element = a(b), this.$indicators = this.$element.find(".carousel-indicators"), this.options = c, this.paused = null, this.sliding = null, this.interval = null, this.$active = null, this.$items = null, this.options.keyboard && this.$element.on("keydown.bs.carousel", a.proxy(this.keydown, this)), "hover" == this.options.pause && !("ontouchstart" in document.documentElement) && this.$element.on("mouseenter.bs.carousel", a.proxy(this.pause, this)).on("mouseleave.bs.carousel", a.proxy(this.cycle, this))
	};
	c.VERSION = "3.3.4", c.TRANSITION_DURATION = 600, c.DEFAULTS = {
		interval: 5e3,
		pause: "hover",
		wrap: !0,
		keyboard: !0
	}, c.prototype.keydown = function(a) {
		if (!/input|textarea/i.test(a.target.tagName)) {
			switch (a.which) {
				case 37:
					this.prev();
					break;
				case 39:
					this.next();
					break;
				default:
					return
			}
			a.preventDefault()
		}
	}, c.prototype.cycle = function(b) {
		return b || (this.paused = !1), this.interval && clearInterval(this.interval), this.options.interval && !this.paused && (this.interval = setInterval(a.proxy(this.next, this), this.options.interval)), this
	}, c.prototype.getItemIndex = function(a) {
		return this.$items = a.parent().children(".item"), this.$items.index(a || this.$active)
	}, c.prototype.getItemForDirection = function(a, b) {
		var c = this.getItemIndex(b),
			d = "prev" == a && 0 === c || "next" == a && c == this.$items.length - 1;
		if (d && !this.options.wrap) return b;
		var e = "prev" == a ? -1 : 1,
			f = (c + e) % this.$items.length;
		return this.$items.eq(f)
	}, c.prototype.to = function(a) {
		var b = this,
			c = this.getItemIndex(this.$active = this.$element.find(".item.active"));
		return a > this.$items.length - 1 || 0 > a ? void 0 : this.sliding ? this.$element.one("slid.bs.carousel", function() {
			b.to(a)
		}) : c == a ? this.pause().cycle() : this.slide(a > c ? "next" : "prev", this.$items.eq(a))
	}, c.prototype.pause = function(b) {
		return b || (this.paused = !0), this.$element.find(".next, .prev").length && a.support.transition && (this.$element.trigger(a.support.transition.end), this.cycle(!0)), this.interval = clearInterval(this.interval), this
	}, c.prototype.next = function() {
		return this.sliding ? void 0 : this.slide("next")
	}, c.prototype.prev = function() {
		return this.sliding ? void 0 : this.slide("prev")
	}, c.prototype.slide = function(b, d) {
		var e = this.$element.find(".item.active"),
			f = d || this.getItemForDirection(b, e),
			g = this.interval,
			h = "next" == b ? "left" : "right",
			i = this;
		if (f.hasClass("active")) return this.sliding = !1;
		var j = f[0],
			k = a.Event("slide.bs.carousel", {
				relatedTarget: j,
				direction: h
			});
		if (this.$element.trigger(k), !k.isDefaultPrevented()) {
			if (this.sliding = !0, g && this.pause(), this.$indicators.length) {
				this.$indicators.find(".active").removeClass("active");
				var l = a(this.$indicators.children()[this.getItemIndex(f)]);
				l && l.addClass("active")
			}
			var m = a.Event("slid.bs.carousel", {
				relatedTarget: j,
				direction: h
			});
			return a.support.transition && this.$element.hasClass("slide") ? (f.addClass(b), f[0].offsetWidth, e.addClass(h), f.addClass(h), e.one("bsTransitionEnd", function() {
				f.removeClass([b, h].join(" ")).addClass("active"), e.removeClass(["active", h].join(" ")), i.sliding = !1, setTimeout(function() {
					i.$element.trigger(m)
				}, 0)
			}).emulateTransitionEnd(c.TRANSITION_DURATION)) : (e.removeClass("active"), f.addClass("active"), this.sliding = !1, this.$element.trigger(m)), g && this.cycle(), this
		}
	};
	var d = a.fn.carousel;
	a.fn.carousel = b, a.fn.carousel.Constructor = c, a.fn.carousel.noConflict = function() {
		return a.fn.carousel = d, this
	};
	var e = function(c) {
		var d, e = a(this),
			f = a(e.attr("data-target") || (d = e.attr("href")) && d.replace(/.*(?=#[^\s]+$)/, ""));
		if (f.hasClass("carousel")) {
			var g = a.extend({}, f.data(), e.data()),
				h = e.attr("data-slide-to");
			h && (g.interval = !1), b.call(f, g), h && f.data("bs.carousel").to(h), c.preventDefault()
		}
	};
	a(document).on("click.bs.carousel.data-api", "[data-slide]", e).on("click.bs.carousel.data-api", "[data-slide-to]", e), a(window).on("load", function() {
		a('[data-ride="carousel"]').each(function() {
			var c = a(this);
			b.call(c, c.data())
		})
	})
}(jQuery), + function(a) {
	"use strict";

	function b(b) {
		var c, d = b.attr("data-target") || (c = b.attr("href")) && c.replace(/.*(?=#[^\s]+$)/, "");
		return a(d)
	}

	function c(b) {
		return this.each(function() {
			var c = a(this),
				e = c.data("bs.collapse"),
				f = a.extend({}, d.DEFAULTS, c.data(), "object" == typeof b && b);
			!e && f.toggle && /show|hide/.test(b) && (f.toggle = !1), e || c.data("bs.collapse", e = new d(this, f)), "string" == typeof b && e[b]()
		})
	}
	var d = function(b, c) {
		this.$element = a(b), this.options = a.extend({}, d.DEFAULTS, c), this.$trigger = a('[data-toggle="collapse"][href="#' + b.id + '"],[data-toggle="collapse"][data-target="#' + b.id + '"]'), this.transitioning = null, this.options.parent ? this.$parent = this.getParent() : this.addAriaAndCollapsedClass(this.$element, this.$trigger), this.options.toggle && this.toggle()
	};
	d.VERSION = "3.3.4", d.TRANSITION_DURATION = 350, d.DEFAULTS = {
		toggle: !0
	}, d.prototype.dimension = function() {
		var a = this.$element.hasClass("width");
		return a ? "width" : "height"
	}, d.prototype.show = function() {
		if (!this.transitioning && !this.$element.hasClass("in")) {
			var b, e = this.$parent && this.$parent.children(".panel").children(".in, .collapsing");
			if (!(e && e.length && (b = e.data("bs.collapse"), b && b.transitioning))) {
				var f = a.Event("show.bs.collapse");
				if (this.$element.trigger(f), !f.isDefaultPrevented()) {
					e && e.length && (c.call(e, "hide"), b || e.data("bs.collapse", null));
					var g = this.dimension();
					this.$element.removeClass("collapse").addClass("collapsing")[g](0).attr("aria-expanded", !0), this.$trigger.removeClass("collapsed").attr("aria-expanded", !0), this.transitioning = 1;
					var h = function() {
						this.$element.removeClass("collapsing").addClass("collapse in")[g](""), this.transitioning = 0, this.$element.trigger("shown.bs.collapse")
					};
					if (!a.support.transition) return h.call(this);
					var i = a.camelCase(["scroll", g].join("-"));
					this.$element.one("bsTransitionEnd", a.proxy(h, this)).emulateTransitionEnd(d.TRANSITION_DURATION)[g](this.$element[0][i])
				}
			}
		}
	}, d.prototype.hide = function() {
		if (!this.transitioning && this.$element.hasClass("in")) {
			var b = a.Event("hide.bs.collapse");
			if (this.$element.trigger(b), !b.isDefaultPrevented()) {
				var c = this.dimension();
				this.$element[c](this.$element[c]())[0].offsetHeight, this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded", !1), this.$trigger.addClass("collapsed").attr("aria-expanded", !1), this.transitioning = 1;
				var e = function() {
					this.transitioning = 0, this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse")
				};
				return a.support.transition ? void this.$element[c](0).one("bsTransitionEnd", a.proxy(e, this)).emulateTransitionEnd(d.TRANSITION_DURATION) : e.call(this)
			}
		}
	}, d.prototype.toggle = function() {
		this[this.$element.hasClass("in") ? "hide" : "show"]()
	}, d.prototype.getParent = function() {
		return a(this.options.parent).find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]').each(a.proxy(function(c, d) {
			var e = a(d);
			this.addAriaAndCollapsedClass(b(e), e)
		}, this)).end()
	}, d.prototype.addAriaAndCollapsedClass = function(a, b) {
		var c = a.hasClass("in");
		a.attr("aria-expanded", c), b.toggleClass("collapsed", !c).attr("aria-expanded", c)
	};
	var e = a.fn.collapse;
	a.fn.collapse = c, a.fn.collapse.Constructor = d, a.fn.collapse.noConflict = function() {
		return a.fn.collapse = e, this
	}, a(document).on("click.bs.collapse.data-api", '[data-toggle="collapse"]', function(d) {
		var e = a(this);
		e.attr("data-target") || d.preventDefault();
		var f = b(e),
			g = f.data("bs.collapse"),
			h = g ? "toggle" : e.data();
		c.call(f, h)
	})
}(jQuery), + function(a) {
	"use strict";

	function b(b) {
		b && 3 === b.which || (a(e).remove(), a(f).each(function() {
			var d = a(this),
				e = c(d),
				f = {
					relatedTarget: this
				};
			e.hasClass("open") && (e.trigger(b = a.Event("hide.bs.dropdown", f)), b.isDefaultPrevented() || (d.attr("aria-expanded", "false"), e.removeClass("open").trigger("hidden.bs.dropdown", f)))
		}))
	}

	function c(b) {
		var c = b.attr("data-target");
		c || (c = b.attr("href"), c = c && /#[A-Za-z]/.test(c) && c.replace(/.*(?=#[^\s]*$)/, ""));
		var d = c && a(c);
		return d && d.length ? d : b.parent()
	}

	function d(b) {
		return this.each(function() {
			var c = a(this),
				d = c.data("bs.dropdown");
			d || c.data("bs.dropdown", d = new g(this)), "string" == typeof b && d[b].call(c)
		})
	}
	var e = ".dropdown-backdrop",
		f = '[data-toggle="dropdown"]',
		g = function(b) {
			a(b).on("click.bs.dropdown", this.toggle)
		};
	g.VERSION = "3.3.4", g.prototype.toggle = function(d) {
		var e = a(this);
		if (!e.is(".disabled, :disabled")) {
			var f = c(e),
				g = f.hasClass("open");
			if (b(), !g) {
				"ontouchstart" in document.documentElement && !f.closest(".navbar-nav").length && a('<div class="dropdown-backdrop"/>').insertAfter(a(this)).on("click", b);
				var h = {
					relatedTarget: this
				};
				if (f.trigger(d = a.Event("show.bs.dropdown", h)), d.isDefaultPrevented()) return;
				e.trigger("focus").attr("aria-expanded", "true"), f.toggleClass("open").trigger("shown.bs.dropdown", h)
			}
			return !1
		}
	}, g.prototype.keydown = function(b) {
		if (/(38|40|27|32)/.test(b.which) && !/input|textarea/i.test(b.target.tagName)) {
			var d = a(this);
			if (b.preventDefault(), b.stopPropagation(), !d.is(".disabled, :disabled")) {
				var e = c(d),
					g = e.hasClass("open");
				if (!g && 27 != b.which || g && 27 == b.which) return 27 == b.which && e.find(f).trigger("focus"), d.trigger("click");
				var h = " li:not(.disabled):visible a",
					i = e.find('[role="menu"]' + h + ', [role="listbox"]' + h);
				if (i.length) {
					var j = i.index(b.target);
					38 == b.which && j > 0 && j--, 40 == b.which && j < i.length - 1 && j++, ~j || (j = 0), i.eq(j).trigger("focus")
				}
			}
		}
	};
	var h = a.fn.dropdown;
	a.fn.dropdown = d, a.fn.dropdown.Constructor = g, a.fn.dropdown.noConflict = function() {
		return a.fn.dropdown = h, this
	}, a(document).on("click.bs.dropdown.data-api", b).on("click.bs.dropdown.data-api", ".dropdown form", function(a) {
		a.stopPropagation()
	}).on("click.bs.dropdown.data-api", f, g.prototype.toggle).on("keydown.bs.dropdown.data-api", f, g.prototype.keydown).on("keydown.bs.dropdown.data-api", '[role="menu"]', g.prototype.keydown).on("keydown.bs.dropdown.data-api", '[role="listbox"]', g.prototype.keydown)
}(jQuery), + function(a) {
	"use strict";

	function b(b, d) {
		return this.each(function() {
			var e = a(this),
				f = e.data("bs.modal"),
				g = a.extend({}, c.DEFAULTS, e.data(), "object" == typeof b && b);
			f || e.data("bs.modal", f = new c(this, g)), "string" == typeof b ? f[b](d) : g.show && f.show(d)
		})
	}
	var c = function(b, c) {
		this.options = c, this.$body = a(document.body), this.$element = a(b), this.$dialog = this.$element.find(".modal-dialog"), this.$backdrop = null, this.isShown = null, this.originalBodyPad = null, this.scrollbarWidth = 0, this.ignoreBackdropClick = !1, this.options.remote && this.$element.find(".modal-content").load(this.options.remote, a.proxy(function() {
			this.$element.trigger("loaded.bs.modal")
		}, this))
	};
	c.VERSION = "3.3.4", c.TRANSITION_DURATION = 300, c.BACKDROP_TRANSITION_DURATION = 150, c.DEFAULTS = {
		backdrop: !0,
		keyboard: !0,
		show: !0
	}, c.prototype.toggle = function(a) {
		return this.isShown ? this.hide() : this.show(a)
	}, c.prototype.show = function(b) {
		var d = this,
			e = a.Event("show.bs.modal", {
				relatedTarget: b
			});
		this.$element.trigger(e), this.isShown || e.isDefaultPrevented() || (this.isShown = !0, this.checkScrollbar(), this.setScrollbar(), this.$body.addClass("modal-open"), this.escape(), this.resize(), this.$element.on("click.dismiss.bs.modal", '[data-dismiss="modal"]', a.proxy(this.hide, this)), this.$dialog.on("mousedown.dismiss.bs.modal", function() {
			d.$element.one("mouseup.dismiss.bs.modal", function(b) {
				a(b.target).is(d.$element) && (d.ignoreBackdropClick = !0)
			})
		}), this.backdrop(function() {
			var e = a.support.transition && d.$element.hasClass("fade");
			d.$element.parent().length || d.$element.appendTo(d.$body), d.$element.show().scrollTop(0), d.adjustDialog(), e && d.$element[0].offsetWidth, d.$element.addClass("in").attr("aria-hidden", !1), d.enforceFocus();
			var f = a.Event("shown.bs.modal", {
				relatedTarget: b
			});
			e ? d.$dialog.one("bsTransitionEnd", function() {
				d.$element.trigger("focus").trigger(f)
			}).emulateTransitionEnd(c.TRANSITION_DURATION) : d.$element.trigger("focus").trigger(f)
		}))
	}, c.prototype.hide = function(b) {
		b && b.preventDefault(), b = a.Event("hide.bs.modal"), this.$element.trigger(b), this.isShown && !b.isDefaultPrevented() && (this.isShown = !1, this.escape(), this.resize(), a(document).off("focusin.bs.modal"), this.$element.removeClass("in").attr("aria-hidden", !0).off("click.dismiss.bs.modal").off("mouseup.dismiss.bs.modal"), this.$dialog.off("mousedown.dismiss.bs.modal"), a.support.transition && this.$element.hasClass("fade") ? this.$element.one("bsTransitionEnd", a.proxy(this.hideModal, this)).emulateTransitionEnd(c.TRANSITION_DURATION) : this.hideModal())
	}, c.prototype.enforceFocus = function() {
		a(document).off("focusin.bs.modal").on("focusin.bs.modal", a.proxy(function(a) {
			this.$element[0] === a.target || this.$element.has(a.target).length || this.$element.trigger("focus")
		}, this))
	}, c.prototype.escape = function() {
		this.isShown && this.options.keyboard ? this.$element.on("keydown.dismiss.bs.modal", a.proxy(function(a) {
			27 == a.which && this.hide()
		}, this)) : this.isShown || this.$element.off("keydown.dismiss.bs.modal")
	}, c.prototype.resize = function() {
		this.isShown ? a(window).on("resize.bs.modal", a.proxy(this.handleUpdate, this)) : a(window).off("resize.bs.modal")
	}, c.prototype.hideModal = function() {
		var a = this;
		this.$element.hide(), this.backdrop(function() {
			a.$body.removeClass("modal-open"), a.resetAdjustments(), a.resetScrollbar(), a.$element.trigger("hidden.bs.modal")
		})
	}, c.prototype.removeBackdrop = function() {
		this.$backdrop && this.$backdrop.remove(), this.$backdrop = null
	}, c.prototype.backdrop = function(b) {
		var d = this,
			e = this.$element.hasClass("fade") ? "fade" : "";
		if (this.isShown && this.options.backdrop) {
			var f = a.support.transition && e;
			if (this.$backdrop = a('<div class="modal-backdrop ' + e + '" />').appendTo(this.$body), this.$element.on("click.dismiss.bs.modal", a.proxy(function(a) {
					return this.ignoreBackdropClick ? void(this.ignoreBackdropClick = !1) : void(a.target === a.currentTarget && ("static" == this.options.backdrop ? this.$element[0].focus() : this.hide()))
				}, this)), f && this.$backdrop[0].offsetWidth, this.$backdrop.addClass("in"), !b) return;
			f ? this.$backdrop.one("bsTransitionEnd", b).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION) : b()
		} else if (!this.isShown && this.$backdrop) {
			this.$backdrop.removeClass("in");
			var g = function() {
				d.removeBackdrop(), b && b()
			};
			a.support.transition && this.$element.hasClass("fade") ? this.$backdrop.one("bsTransitionEnd", g).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION) : g()
		} else b && b()
	}, c.prototype.handleUpdate = function() {
		this.adjustDialog()
	}, c.prototype.adjustDialog = function() {
		var a = this.$element[0].scrollHeight > document.documentElement.clientHeight;
		this.$element.css({
			paddingLeft: !this.bodyIsOverflowing && a ? this.scrollbarWidth : "",
			paddingRight: this.bodyIsOverflowing && !a ? this.scrollbarWidth : ""
		})
	}, c.prototype.resetAdjustments = function() {
		this.$element.css({
			paddingLeft: "",
			paddingRight: ""
		})
	}, c.prototype.checkScrollbar = function() {
		var a = window.innerWidth;
		if (!a) {
			var b = document.documentElement.getBoundingClientRect();
			a = b.right - Math.abs(b.left)
		}
		this.bodyIsOverflowing = document.body.clientWidth < a, this.scrollbarWidth = this.measureScrollbar()
	}, c.prototype.setScrollbar = function() {
		var a = parseInt(this.$body.css("padding-right") || 0, 10);
		this.originalBodyPad = document.body.style.paddingRight || "", this.bodyIsOverflowing && this.$body.css("padding-right", a + this.scrollbarWidth)
	}, c.prototype.resetScrollbar = function() {
		this.$body.css("padding-right", this.originalBodyPad)
	}, c.prototype.measureScrollbar = function() {
		var a = document.createElement("div");
		a.className = "modal-scrollbar-measure", this.$body.append(a);
		var b = a.offsetWidth - a.clientWidth;
		return this.$body[0].removeChild(a), b
	};
	var d = a.fn.modal;
	a.fn.modal = b, a.fn.modal.Constructor = c, a.fn.modal.noConflict = function() {
		return a.fn.modal = d, this
	}, a(document).on("click.bs.modal.data-api", '[data-toggle="modal"]', function(c) {
		var d = a(this),
			e = d.attr("href"),
			f = a(d.attr("data-target") || e && e.replace(/.*(?=#[^\s]+$)/, "")),
			g = f.data("bs.modal") ? "toggle" : a.extend({
				remote: !/#/.test(e) && e
			}, f.data(), d.data());
		d.is("a") && c.preventDefault(), f.one("show.bs.modal", function(a) {
			a.isDefaultPrevented() || f.one("hidden.bs.modal", function() {
				d.is(":visible") && d.trigger("focus")
			})
		}), b.call(f, g, this)
	})
}(jQuery), + function(a) {
	"use strict";

	function b(b) {
		return this.each(function() {
			var d = a(this),
				e = d.data("bs.tooltip"),
				f = "object" == typeof b && b;
			(e || !/destroy|hide/.test(b)) && (e || d.data("bs.tooltip", e = new c(this, f)), "string" == typeof b && e[b]())
		})
	}
	var c = function(a, b) {
		this.type = null, this.options = null, this.enabled = null, this.timeout = null, this.hoverState = null, this.$element = null, this.init("tooltip", a, b)
	};
	c.VERSION = "3.3.4", c.TRANSITION_DURATION = 150, c.DEFAULTS = {
		animation: !0,
		placement: "top",
		selector: !1,
		template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
		trigger: "hover focus",
		title: "",
		delay: 0,
		html: !1,
		container: !1,
		viewport: {
			selector: "body",
			padding: 0
		}
	}, c.prototype.init = function(b, c, d) {
		if (this.enabled = !0, this.type = b, this.$element = a(c), this.options = this.getOptions(d), this.$viewport = this.options.viewport && a(this.options.viewport.selector || this.options.viewport), this.$element[0] instanceof document.constructor && !this.options.selector) throw new Error("`selector` option must be specified when initializing " + this.type + " on the window.document object!");
		for (var e = this.options.trigger.split(" "), f = e.length; f--;) {
			var g = e[f];
			if ("click" == g) this.$element.on("click." + this.type, this.options.selector, a.proxy(this.toggle, this));
			else if ("manual" != g) {
				var h = "hover" == g ? "mouseenter" : "focusin",
					i = "hover" == g ? "mouseleave" : "focusout";
				this.$element.on(h + "." + this.type, this.options.selector, a.proxy(this.enter, this)), this.$element.on(i + "." + this.type, this.options.selector, a.proxy(this.leave, this))
			}
		}
		this.options.selector ? this._options = a.extend({}, this.options, {
			trigger: "manual",
			selector: ""
		}) : this.fixTitle()
	}, c.prototype.getDefaults = function() {
		return c.DEFAULTS
	}, c.prototype.getOptions = function(b) {
		return b = a.extend({}, this.getDefaults(), this.$element.data(), b), b.delay && "number" == typeof b.delay && (b.delay = {
			show: b.delay,
			hide: b.delay
		}), b
	}, c.prototype.getDelegateOptions = function() {
		var b = {},
			c = this.getDefaults();
		return this._options && a.each(this._options, function(a, d) {
			c[a] != d && (b[a] = d)
		}), b
	}, c.prototype.enter = function(b) {
		var c = b instanceof this.constructor ? b : a(b.currentTarget).data("bs." + this.type);
		return c && c.$tip && c.$tip.is(":visible") ? void(c.hoverState = "in") : (c || (c = new this.constructor(b.currentTarget, this.getDelegateOptions()), a(b.currentTarget).data("bs." + this.type, c)), clearTimeout(c.timeout), c.hoverState = "in", c.options.delay && c.options.delay.show ? void(c.timeout = setTimeout(function() {
			"in" == c.hoverState && c.show()
		}, c.options.delay.show)) : c.show())
	}, c.prototype.leave = function(b) {
		var c = b instanceof this.constructor ? b : a(b.currentTarget).data("bs." + this.type);
		return c || (c = new this.constructor(b.currentTarget, this.getDelegateOptions()), a(b.currentTarget).data("bs." + this.type, c)), clearTimeout(c.timeout), c.hoverState = "out", c.options.delay && c.options.delay.hide ? void(c.timeout = setTimeout(function() {
			"out" == c.hoverState && c.hide()
		}, c.options.delay.hide)) : c.hide()
	}, c.prototype.show = function() {
		var b = a.Event("show.bs." + this.type);
		if (this.hasContent() && this.enabled) {
			this.$element.trigger(b);
			var d = a.contains(this.$element[0].ownerDocument.documentElement, this.$element[0]);
			if (b.isDefaultPrevented() || !d) return;
			var e = this,
				f = this.tip(),
				g = this.getUID(this.type);
			this.setContent(), f.attr("id", g), this.$element.attr("aria-describedby", g), this.options.animation && f.addClass("fade");
			var h = "function" == typeof this.options.placement ? this.options.placement.call(this, f[0], this.$element[0]) : this.options.placement,
				i = /\s?auto?\s?/i,
				j = i.test(h);
			j && (h = h.replace(i, "") || "top"), f.detach().css({
				top: 0,
				left: 0,
				display: "block"
			}).addClass(h).data("bs." + this.type, this), this.options.container ? f.appendTo(this.options.container) : f.insertAfter(this.$element);
			var k = this.getPosition(),
				l = f[0].offsetWidth,
				m = f[0].offsetHeight;
			if (j) {
				var n = h,
					o = this.options.container ? a(this.options.container) : this.$element.parent(),
					p = this.getPosition(o);
				h = "bottom" == h && k.bottom + m > p.bottom ? "top" : "top" == h && k.top - m < p.top ? "bottom" : "right" == h && k.right + l > p.width ? "left" : "left" == h && k.left - l < p.left ? "right" : h, f.removeClass(n).addClass(h)
			}
			var q = this.getCalculatedOffset(h, k, l, m);
			this.applyPlacement(q, h);
			var r = function() {
				var a = e.hoverState;
				e.$element.trigger("shown.bs." + e.type), e.hoverState = null, "out" == a && e.leave(e)
			};
			a.support.transition && this.$tip.hasClass("fade") ? f.one("bsTransitionEnd", r).emulateTransitionEnd(c.TRANSITION_DURATION) : r()
		}
	}, c.prototype.applyPlacement = function(b, c) {
		var d = this.tip(),
			e = d[0].offsetWidth,
			f = d[0].offsetHeight,
			g = parseInt(d.css("margin-top"), 10),
			h = parseInt(d.css("margin-left"), 10);
		isNaN(g) && (g = 0), isNaN(h) && (h = 0), b.top = b.top + g, b.left = b.left + h, a.offset.setOffset(d[0], a.extend({
			using: function(a) {
				d.css({
					top: Math.round(a.top),
					left: Math.round(a.left)
				})
			}
		}, b), 0), d.addClass("in");
		var i = d[0].offsetWidth,
			j = d[0].offsetHeight;
		"top" == c && j != f && (b.top = b.top + f - j);
		var k = this.getViewportAdjustedDelta(c, b, i, j);
		k.left ? b.left += k.left : b.top += k.top;
		var l = /top|bottom/.test(c),
			m = l ? 2 * k.left - e + i : 2 * k.top - f + j,
			n = l ? "offsetWidth" : "offsetHeight";
		d.offset(b), this.replaceArrow(m, d[0][n], l)
	}, c.prototype.replaceArrow = function(a, b, c) {
		this.arrow().css(c ? "left" : "top", 50 * (1 - a / b) + "%").css(c ? "top" : "left", "")
	}, c.prototype.setContent = function() {
		var a = this.tip(),
			b = this.getTitle();
		a.find(".tooltip-inner")[this.options.html ? "html" : "text"](b), a.removeClass("fade in top bottom left right")
	}, c.prototype.hide = function(b) {
		function d() {
			"in" != e.hoverState && f.detach(), e.$element.removeAttr("aria-describedby").trigger("hidden.bs." + e.type), b && b()
		}
		var e = this,
			f = a(this.$tip),
			g = a.Event("hide.bs." + this.type);
		return this.$element.trigger(g), g.isDefaultPrevented() ? void 0 : (f.removeClass("in"), a.support.transition && f.hasClass("fade") ? f.one("bsTransitionEnd", d).emulateTransitionEnd(c.TRANSITION_DURATION) : d(), this.hoverState = null, this)
	}, c.prototype.fixTitle = function() {
		var a = this.$element;
		(a.attr("title") || "string" != typeof a.attr("data-original-title")) && a.attr("data-original-title", a.attr("title") || "").attr("title", "")
	}, c.prototype.hasContent = function() {
		return this.getTitle()
	}, c.prototype.getPosition = function(b) {
		b = b || this.$element;
		var c = b[0],
			d = "BODY" == c.tagName,
			e = c.getBoundingClientRect();
		null == e.width && (e = a.extend({}, e, {
			width: e.right - e.left,
			height: e.bottom - e.top
		}));
		var f = d ? {
				top: 0,
				left: 0
			} : b.offset(),
			g = {
				scroll: d ? document.documentElement.scrollTop || document.body.scrollTop : b.scrollTop()
			},
			h = d ? {
				width: a(window).width(),
				height: a(window).height()
			} : null;
		return a.extend({}, e, g, h, f)
	}, c.prototype.getCalculatedOffset = function(a, b, c, d) {
		return "bottom" == a ? {
			top: b.top + b.height,
			left: b.left + b.width / 2 - c / 2
		} : "top" == a ? {
			top: b.top - d,
			left: b.left + b.width / 2 - c / 2
		} : "left" == a ? {
			top: b.top + b.height / 2 - d / 2,
			left: b.left - c
		} : {
			top: b.top + b.height / 2 - d / 2,
			left: b.left + b.width
		}
	}, c.prototype.getViewportAdjustedDelta = function(a, b, c, d) {
		var e = {
			top: 0,
			left: 0
		};
		if (!this.$viewport) return e;
		var f = this.options.viewport && this.options.viewport.padding || 0,
			g = this.getPosition(this.$viewport);
		if (/right|left/.test(a)) {
			var h = b.top - f - g.scroll,
				i = b.top + f - g.scroll + d;
			h < g.top ? e.top = g.top - h : i > g.top + g.height && (e.top = g.top + g.height - i)
		} else {
			var j = b.left - f,
				k = b.left + f + c;
			j < g.left ? e.left = g.left - j : k > g.width && (e.left = g.left + g.width - k)
		}
		return e
	}, c.prototype.getTitle = function() {
		var a, b = this.$element,
			c = this.options;
		return a = b.attr("data-original-title") || ("function" == typeof c.title ? c.title.call(b[0]) : c.title)
	}, c.prototype.getUID = function(a) {
		do a += ~~(1e6 * Math.random()); while (document.getElementById(a));
		return a
	}, c.prototype.tip = function() {
		return this.$tip = this.$tip || a(this.options.template)
	}, c.prototype.arrow = function() {
		return this.$arrow = this.$arrow || this.tip().find(".tooltip-arrow")
	}, c.prototype.enable = function() {
		this.enabled = !0
	}, c.prototype.disable = function() {
		this.enabled = !1
	}, c.prototype.toggleEnabled = function() {
		this.enabled = !this.enabled
	}, c.prototype.toggle = function(b) {
		var c = this;
		b && (c = a(b.currentTarget).data("bs." + this.type), c || (c = new this.constructor(b.currentTarget, this.getDelegateOptions()), a(b.currentTarget).data("bs." + this.type, c))), c.tip().hasClass("in") ? c.leave(c) : c.enter(c)
	}, c.prototype.destroy = function() {
		var a = this;
		clearTimeout(this.timeout), this.hide(function() {
			a.$element.off("." + a.type).removeData("bs." + a.type)
		})
	};
	var d = a.fn.tooltip;
	a.fn.tooltip = b, a.fn.tooltip.Constructor = c, a.fn.tooltip.noConflict = function() {
		return a.fn.tooltip = d, this
	}
}(jQuery), + function(a) {
	"use strict";

	function b(b) {
		return this.each(function() {
			var d = a(this),
				e = d.data("bs.popover"),
				f = "object" == typeof b && b;
			(e || !/destroy|hide/.test(b)) && (e || d.data("bs.popover", e = new c(this, f)), "string" == typeof b && e[b]())
		})
	}
	var c = function(a, b) {
		this.init("popover", a, b)
	};
	if (!a.fn.tooltip) throw new Error("Popover requires tooltip.js");
	c.VERSION = "3.3.4", c.DEFAULTS = a.extend({}, a.fn.tooltip.Constructor.DEFAULTS, {
		placement: "right",
		trigger: "click",
		content: "",
		template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
	}), c.prototype = a.extend({}, a.fn.tooltip.Constructor.prototype), c.prototype.constructor = c, c.prototype.getDefaults = function() {
		return c.DEFAULTS
	}, c.prototype.setContent = function() {
		var a = this.tip(),
			b = this.getTitle(),
			c = this.getContent();
		a.find(".popover-title")[this.options.html ? "html" : "text"](b), a.find(".popover-content").children().detach().end()[this.options.html ? "string" == typeof c ? "html" : "append" : "text"](c), a.removeClass("fade top bottom left right in"), a.find(".popover-title").html() || a.find(".popover-title").hide()
	}, c.prototype.hasContent = function() {
		return this.getTitle() || this.getContent()
	}, c.prototype.getContent = function() {
		var a = this.$element,
			b = this.options;
		return a.attr("data-content") || ("function" == typeof b.content ? b.content.call(a[0]) : b.content)
	}, c.prototype.arrow = function() {
		return this.$arrow = this.$arrow || this.tip().find(".arrow")
	};
	var d = a.fn.popover;
	a.fn.popover = b, a.fn.popover.Constructor = c, a.fn.popover.noConflict = function() {
		return a.fn.popover = d, this
	}
}(jQuery), + function(a) {
	"use strict";

	function b(c, d) {
		this.$body = a(document.body), this.$scrollElement = a(a(c).is(document.body) ? window : c), this.options = a.extend({}, b.DEFAULTS, d), this.selector = (this.options.target || "") + " .nav li > a", this.offsets = [], this.targets = [], this.activeTarget = null, this.scrollHeight = 0, this.$scrollElement.on("scroll.bs.scrollspy", a.proxy(this.process, this)), this.refresh(), this.process()
	}

	function c(c) {
		return this.each(function() {
			var d = a(this),
				e = d.data("bs.scrollspy"),
				f = "object" == typeof c && c;
			e || d.data("bs.scrollspy", e = new b(this, f)), "string" == typeof c && e[c]()
		})
	}
	b.VERSION = "3.3.4", b.DEFAULTS = {
		offset: 10
	}, b.prototype.getScrollHeight = function() {
		return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
	}, b.prototype.refresh = function() {
		var b = this,
			c = "offset",
			d = 0;
		this.offsets = [], this.targets = [], this.scrollHeight = this.getScrollHeight(), a.isWindow(this.$scrollElement[0]) || (c = "position", d = this.$scrollElement.scrollTop()), this.$body.find(this.selector).map(function() {
			var b = a(this),
				e = b.data("target") || b.attr("href"),
				f = /^#./.test(e) && a(e);
			return f && f.length && f.is(":visible") && [
				[f[c]().top + d, e]
			] || null
		}).sort(function(a, b) {
			return a[0] - b[0]
		}).each(function() {
			b.offsets.push(this[0]), b.targets.push(this[1])
		})
	}, b.prototype.process = function() {
		var a, b = this.$scrollElement.scrollTop() + this.options.offset,
			c = this.getScrollHeight(),
			d = this.options.offset + c - this.$scrollElement.height(),
			e = this.offsets,
			f = this.targets,
			g = this.activeTarget;
		if (this.scrollHeight != c && this.refresh(), b >= d) return g != (a = f[f.length - 1]) && this.activate(a);
		if (g && b < e[0]) return this.activeTarget = null, this.clear();
		for (a = e.length; a--;) g != f[a] && b >= e[a] && (void 0 === e[a + 1] || b < e[a + 1]) && this.activate(f[a])
	}, b.prototype.activate = function(b) {
		this.activeTarget = b, this.clear();
		var c = this.selector + '[data-target="' + b + '"],' + this.selector + '[href="' + b + '"]',
			d = a(c).parents("li").addClass("active");
		d.parent(".dropdown-menu").length && (d = d.closest("li.dropdown").addClass("active")), d.trigger("activate.bs.scrollspy")
	}, b.prototype.clear = function() {
		a(this.selector).parentsUntil(this.options.target, ".active").removeClass("active")
	};
	var d = a.fn.scrollspy;
	a.fn.scrollspy = c, a.fn.scrollspy.Constructor = b, a.fn.scrollspy.noConflict = function() {
		return a.fn.scrollspy = d, this
	}, a(window).on("load.bs.scrollspy.data-api", function() {
		a('[data-spy="scroll"]').each(function() {
			var b = a(this);
			c.call(b, b.data())
		})
	})
}(jQuery), + function(a) {
	"use strict";

	function b(b) {
		return this.each(function() {
			var d = a(this),
				e = d.data("bs.tab");
			e || d.data("bs.tab", e = new c(this)), "string" == typeof b && e[b]()
		})
	}
	var c = function(b) {
		this.element = a(b)
	};
	c.VERSION = "3.3.4", c.TRANSITION_DURATION = 150, c.prototype.show = function() {
		var b = this.element,
			c = b.closest("ul:not(.dropdown-menu)"),
			d = b.data("target");
		if (d || (d = b.attr("href"), d = d && d.replace(/.*(?=#[^\s]*$)/, "")), !b.parent("li").hasClass("active")) {
			var e = c.find(".active:last a"),
				f = a.Event("hide.bs.tab", {
					relatedTarget: b[0]
				}),
				g = a.Event("show.bs.tab", {
					relatedTarget: e[0]
				});
			if (e.trigger(f), b.trigger(g), !g.isDefaultPrevented() && !f.isDefaultPrevented()) {
				var h = a(d);
				this.activate(b.closest("li"), c), this.activate(h, h.parent(), function() {
					e.trigger({
						type: "hidden.bs.tab",
						relatedTarget: b[0]
					}), b.trigger({
						type: "shown.bs.tab",
						relatedTarget: e[0]
					})
				})
			}
		}
	}, c.prototype.activate = function(b, d, e) {
		function f() {
			g.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded", !1), b.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded", !0), h ? (b[0].offsetWidth, b.addClass("in")) : b.removeClass("fade"), b.parent(".dropdown-menu").length && b.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded", !0), e && e()
		}
		var g = d.find("> .active"),
			h = e && a.support.transition && (g.length && g.hasClass("fade") || !!d.find("> .fade").length);
		g.length && h ? g.one("bsTransitionEnd", f).emulateTransitionEnd(c.TRANSITION_DURATION) : f(), g.removeClass("in")
	};
	var d = a.fn.tab;
	a.fn.tab = b, a.fn.tab.Constructor = c, a.fn.tab.noConflict = function() {
		return a.fn.tab = d, this
	};
	var e = function(c) {
		c.preventDefault(), b.call(a(this), "show")
	};
	a(document).on("click.bs.tab.data-api", '[data-toggle="tab"]', e).on("click.bs.tab.data-api", '[data-toggle="pill"]', e)
}(jQuery), + function(a) {
	"use strict";

	function b(b) {
		return this.each(function() {
			var d = a(this),
				e = d.data("bs.affix"),
				f = "object" == typeof b && b;
			e || d.data("bs.affix", e = new c(this, f)), "string" == typeof b && e[b]()
		})
	}
	var c = function(b, d) {
		this.options = a.extend({}, c.DEFAULTS, d), this.$target = a(this.options.target).on("scroll.bs.affix.data-api", a.proxy(this.checkPosition, this)).on("click.bs.affix.data-api", a.proxy(this.checkPositionWithEventLoop, this)), this.$element = a(b), this.affixed = null, this.unpin = null, this.pinnedOffset = null, this.checkPosition()
	};
	c.VERSION = "3.3.4", c.RESET = "affix affix-top affix-bottom", c.DEFAULTS = {
		offset: 0,
		target: window
	}, c.prototype.getState = function(a, b, c, d) {
		var e = this.$target.scrollTop(),
			f = this.$element.offset(),
			g = this.$target.height();
		if (null != c && "top" == this.affixed) return c > e ? "top" : !1;
		if ("bottom" == this.affixed) return null != c ? e + this.unpin <= f.top ? !1 : "bottom" : a - d >= e + g ? !1 : "bottom";
		var h = null == this.affixed,
			i = h ? e : f.top,
			j = h ? g : b;
		return null != c && c >= e ? "top" : null != d && i + j >= a - d ? "bottom" : !1
	}, c.prototype.getPinnedOffset = function() {
		if (this.pinnedOffset) return this.pinnedOffset;
		this.$element.removeClass(c.RESET).addClass("affix");
		var a = this.$target.scrollTop(),
			b = this.$element.offset();
		return this.pinnedOffset = b.top - a
	}, c.prototype.checkPositionWithEventLoop = function() {
		setTimeout(a.proxy(this.checkPosition, this), 1)
	}, c.prototype.checkPosition = function() {
		if (this.$element.is(":visible")) {
			var b = this.$element.height(),
				d = this.options.offset,
				e = d.top,
				f = d.bottom,
				g = a(document.body).height();
			"object" != typeof d && (f = e = d), "function" == typeof e && (e = d.top(this.$element)), "function" == typeof f && (f = d.bottom(this.$element));
			var h = this.getState(g, b, e, f);
			if (this.affixed != h) {
				null != this.unpin && this.$element.css("top", "");
				var i = "affix" + (h ? "-" + h : ""),
					j = a.Event(i + ".bs.affix");
				if (this.$element.trigger(j), j.isDefaultPrevented()) return;
				this.affixed = h, this.unpin = "bottom" == h ? this.getPinnedOffset() : null, this.$element.removeClass(c.RESET).addClass(i).trigger(i.replace("affix", "affixed") + ".bs.affix")
			}
			"bottom" == h && this.$element.offset({
				top: g - b - f
			})
		}
	};
	var d = a.fn.affix;
	a.fn.affix = b, a.fn.affix.Constructor = c, a.fn.affix.noConflict = function() {
		return a.fn.affix = d, this
	}, a(window).on("load", function() {
		a('[data-spy="affix"]').each(function() {
			var c = a(this),
				d = c.data();
			d.offset = d.offset || {}, null != d.offsetBottom && (d.offset.bottom = d.offsetBottom), null != d.offsetTop && (d.offset.top = d.offsetTop), b.call(c, d)
		})
	})
}(jQuery);

/*!
 * jQuery Countdown plugin v1.0
 * http://www.littlewebthings.com/projects/countdown/
 *
 * Copyright 2010, Vassilis Dourdounis
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */
(function(n) {
	n.fn.countDown = function(e) {
		config = {};
		n.extend(config, e);
		diffSecs = this.setCountDown(config);
		if (config.onComplete) {
			n.data(n(this)[0], "callback", config.onComplete)
		}
		if (config.omitWeeks) {
			n.data(n(this)[0], "omitWeeks", config.omitWeeks)
		}
		n("#" + n(this).attr("id") + " .digit").html('<div class="top"></div><div class="bottom"></div>');
		n(this).doCountDown(n(this).attr("id"), diffSecs, 500);
		return this
	};
	n.fn.stopCountDown = function() {
		clearTimeout(n.data(this[0], "timer"))
	};
	n.fn.startCountDown = function() {
		this.doCountDown(n(this).attr("id"), n.data(this[0], "diffSecs"), 500)
	};
	n.fn.setCountDown = function(e) {
		var t = new Date;
		if (e.targetDate) {
			t = new Date(e.targetDate.month + "/" + e.targetDate.day + "/" + e.targetDate.year + " " + e.targetDate.hour + ":" + e.targetDate.min + ":" + e.targetDate.sec + (e.targetDate.utc ? " UTC" : ""))
		} else if (e.targetOffset) {
			t.setFullYear(e.targetOffset.year + t.getFullYear());
			t.setMonth(e.targetOffset.month + t.getMonth());
			t.setDate(e.targetOffset.day + t.getDate());
			t.setHours(e.targetOffset.hour + t.getHours());
			t.setMinutes(e.targetOffset.min + t.getMinutes());
			t.setSeconds(e.targetOffset.sec + t.getSeconds())
		}
		var r = new Date;
		diffSecs = Math.floor((t.valueOf() - r.valueOf()) / 1e3);
		n.data(this[0], "diffSecs", diffSecs);
		return diffSecs
	};
	n.fn.doCountDown = function(r, i, s) {
		$this = n("#" + r);
		if (i <= 0) {
			i = 0;
			if (n.data($this[0], "timer")) {
				clearTimeout(n.data($this[0], "timer"))
			}
		}
		secs = i % 60;
		mins = Math.floor(i / 60) % 60;
		hours = Math.floor(i / 60 / 60) % 24;
		if (n.data($this[0], "omitWeeks") == true) {
			days = Math.floor(i / 60 / 60 / 24);
			weeks = Math.floor(i / 60 / 60 / 24 / 7)
		} else {
			days = Math.floor(i / 60 / 60 / 24) % 7;
			weeks = Math.floor(i / 60 / 60 / 24 / 7)
		}
		$this.dashChangeTo(r, "seconds_dash", secs, s ? s : 800);
		$this.dashChangeTo(r, "minutes_dash", mins, s ? s : 1200);
		$this.dashChangeTo(r, "hours_dash", hours, s ? s : 1200);
		$this.dashChangeTo(r, "days_dash", days, s ? s : 1200);
		$this.dashChangeTo(r, "weeks_dash", weeks, s ? s : 1200);
		n.data($this[0], "diffSecs", i);
		if (i > 0) {
			e = $this;
			t = setTimeout(function() {
				e.doCountDown(r, i - 1)
			}, 1e3);
			n.data(e[0], "timer", t)
		} else if (cb = n.data($this[0], "callback")) {
			n.data($this[0], "callback")()
		}
	};
	n.fn.dashChangeTo = function(e, t, r, i) {
		$this = n("#" + e);
		for (var s = $this.find("." + t + " .digit").length - 1; s >= 0; s--) {
			var o = r % 10;
			r = (r - o) / 10;
			$this.digitChangeTo("#" + $this.attr("id") + " ." + t + " .digit:eq(" + s + ")", o, i)
		}
	};
	n.fn.digitChangeTo = function(e, t, r) {
		if (!r) {
			r = 800
		}
		if (n(e + " div.top").html() != t + "") {
			n(e + " div.top").css({
				display: "none"
			});
			n(e + " div.top").html(t ? t : "0").slideDown(r);
			n(e + " div.bottom").animate({
				height: ""
			}, r, function() {
				n(e + " div.bottom").html(n(e + " div.top").html());
				n(e + " div.bottom").css({
					display: "block",
					height: ""
				});
				n(e + " div.top").hide().slideUp(10)
			})
		}
	}
})(jQuery)

/*
 * jQuery Easing v1.3 - http://gsgd.co.uk/sandbox/jquery/easing/
 *
 * Uses the built in easing capabilities added In jQuery 1.1
 * to offer multiple easing options
 *
 * TERMS OF USE - jQuery Easing
 *
 */
jQuery.easing.jswing = jQuery.easing.swing, jQuery.extend(jQuery.easing, {
	def: "easeOutQuad",
	swing: function(n, e, t, u, a) {
		return jQuery.easing[jQuery.easing.def](n, e, t, u, a)
	},
	easeInQuad: function(n, e, t, u, a) {
		return u * (e /= a) * e + t
	},
	easeOutQuad: function(n, e, t, u, a) {
		return -u * (e /= a) * (e - 2) + t
	},
	easeInOutQuad: function(n, e, t, u, a) {
		return (e /= a / 2) < 1 ? u / 2 * e * e + t : -u / 2 * (--e * (e - 2) - 1) + t
	},
	easeInCubic: function(n, e, t, u, a) {
		return u * (e /= a) * e * e + t
	},
	easeOutCubic: function(n, e, t, u, a) {
		return u * ((e = e / a - 1) * e * e + 1) + t
	},
	easeInOutCubic: function(n, e, t, u, a) {
		return (e /= a / 2) < 1 ? u / 2 * e * e * e + t : u / 2 * ((e -= 2) * e * e + 2) + t
	},
	easeInQuart: function(n, e, t, u, a) {
		return u * (e /= a) * e * e * e + t
	},
	easeOutQuart: function(n, e, t, u, a) {
		return -u * ((e = e / a - 1) * e * e * e - 1) + t
	},
	easeInOutQuart: function(n, e, t, u, a) {
		return (e /= a / 2) < 1 ? u / 2 * e * e * e * e + t : -u / 2 * ((e -= 2) * e * e * e - 2) + t
	},
	easeInQuint: function(n, e, t, u, a) {
		return u * (e /= a) * e * e * e * e + t
	},
	easeOutQuint: function(n, e, t, u, a) {
		return u * ((e = e / a - 1) * e * e * e * e + 1) + t
	},
	easeInOutQuint: function(n, e, t, u, a) {
		return (e /= a / 2) < 1 ? u / 2 * e * e * e * e * e + t : u / 2 * ((e -= 2) * e * e * e * e + 2) + t
	},
	easeInSine: function(n, e, t, u, a) {
		return -u * Math.cos(e / a * (Math.PI / 2)) + u + t
	},
	easeOutSine: function(n, e, t, u, a) {
		return u * Math.sin(e / a * (Math.PI / 2)) + t
	},
	easeInOutSine: function(n, e, t, u, a) {
		return -u / 2 * (Math.cos(Math.PI * e / a) - 1) + t
	},
	easeInExpo: function(n, e, t, u, a) {
		return 0 == e ? t : u * Math.pow(2, 10 * (e / a - 1)) + t
	},
	easeOutExpo: function(n, e, t, u, a) {
		return e == a ? t + u : u * (-Math.pow(2, -10 * e / a) + 1) + t
	},
	easeInOutExpo: function(n, e, t, u, a) {
		return 0 == e ? t : e == a ? t + u : (e /= a / 2) < 1 ? u / 2 * Math.pow(2, 10 * (e - 1)) + t : u / 2 * (-Math.pow(2, -10 * --e) + 2) + t
	},
	easeInCirc: function(n, e, t, u, a) {
		return -u * (Math.sqrt(1 - (e /= a) * e) - 1) + t
	},
	easeOutCirc: function(n, e, t, u, a) {
		return u * Math.sqrt(1 - (e = e / a - 1) * e) + t
	},
	easeInOutCirc: function(n, e, t, u, a) {
		return (e /= a / 2) < 1 ? -u / 2 * (Math.sqrt(1 - e * e) - 1) + t : u / 2 * (Math.sqrt(1 - (e -= 2) * e) + 1) + t
	},
	easeInElastic: function(n, e, t, u, a) {
		var r = 1.70158,
			i = 0,
			s = u;
		if (0 == e) return t;
		if (1 == (e /= a)) return t + u;
		if (i || (i = .3 * a), s < Math.abs(u)) {
			s = u;
			var r = i / 4
		} else var r = i / (2 * Math.PI) * Math.asin(u / s);
		return -(s * Math.pow(2, 10 * (e -= 1)) * Math.sin(2 * (e * a - r) * Math.PI / i)) + t
	},
	easeOutElastic: function(n, e, t, u, a) {
		var r = 1.70158,
			i = 0,
			s = u;
		if (0 == e) return t;
		if (1 == (e /= a)) return t + u;
		if (i || (i = .3 * a), s < Math.abs(u)) {
			s = u;
			var r = i / 4
		} else var r = i / (2 * Math.PI) * Math.asin(u / s);
		return s * Math.pow(2, -10 * e) * Math.sin(2 * (e * a - r) * Math.PI / i) + u + t
	},
	easeInOutElastic: function(n, e, t, u, a) {
		var r = 1.70158,
			i = 0,
			s = u;
		if (0 == e) return t;
		if (2 == (e /= a / 2)) return t + u;
		if (i || (i = .3 * a * 1.5), s < Math.abs(u)) {
			s = u;
			var r = i / 4
		} else var r = i / (2 * Math.PI) * Math.asin(u / s);
		return 1 > e ? -.5 * s * Math.pow(2, 10 * (e -= 1)) * Math.sin(2 * (e * a - r) * Math.PI / i) + t : s * Math.pow(2, -10 * (e -= 1)) * Math.sin(2 * (e * a - r) * Math.PI / i) * .5 + u + t
	},
	easeInBack: function(n, e, t, u, a, r) {
		return void 0 == r && (r = 1.70158), u * (e /= a) * e * ((r + 1) * e - r) + t
	},
	easeOutBack: function(n, e, t, u, a, r) {
		return void 0 == r && (r = 1.70158), u * ((e = e / a - 1) * e * ((r + 1) * e + r) + 1) + t
	},
	easeInOutBack: function(n, e, t, u, a, r) {
		return void 0 == r && (r = 1.70158), (e /= a / 2) < 1 ? u / 2 * e * e * (((r *= 1.525) + 1) * e - r) + t : u / 2 * ((e -= 2) * e * (((r *= 1.525) + 1) * e + r) + 2) + t
	},
	easeInBounce: function(n, e, t, u, a) {
		return u - jQuery.easing.easeOutBounce(n, a - e, 0, u, a) + t
	},
	easeOutBounce: function(n, e, t, u, a) {
		return (e /= a) < 1 / 2.75 ? 7.5625 * u * e * e + t : 2 / 2.75 > e ? u * (7.5625 * (e -= 1.5 / 2.75) * e + .75) + t : 2.5 / 2.75 > e ? u * (7.5625 * (e -= 2.25 / 2.75) * e + .9375) + t : u * (7.5625 * (e -= 2.625 / 2.75) * e + .984375) + t
	},
	easeInOutBounce: function(n, e, t, u, a) {
		return a / 2 > e ? .5 * jQuery.easing.easeInBounce(n, 2 * e, 0, u, a) + t : .5 * jQuery.easing.easeOutBounce(n, 2 * e - a, 0, u, a) + .5 * u + t
	}
});

/*!
 * jQuery Mousewheel 3.1.13
 *
 * Copyright 2015 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */
! function(a) {
	"function" == typeof define && define.amd ? define(["jquery"], a) : "object" == typeof exports ? module.exports = a : a(jQuery)
}(function(a) {
	function b(b) {
		var g = b || window.event,
			h = i.call(arguments, 1),
			j = 0,
			l = 0,
			m = 0,
			n = 0,
			o = 0,
			p = 0;
		if (b = a.event.fix(g), b.type = "mousewheel", "detail" in g && (m = -1 * g.detail), "wheelDelta" in g && (m = g.wheelDelta), "wheelDeltaY" in g && (m = g.wheelDeltaY), "wheelDeltaX" in g && (l = -1 * g.wheelDeltaX), "axis" in g && g.axis === g.HORIZONTAL_AXIS && (l = -1 * m, m = 0), j = 0 === m ? l : m, "deltaY" in g && (m = -1 * g.deltaY, j = m), "deltaX" in g && (l = g.deltaX, 0 === m && (j = -1 * l)), 0 !== m || 0 !== l) {
			if (1 === g.deltaMode) {
				var q = a.data(this, "mousewheel-line-height");
				j *= q, m *= q, l *= q
			} else if (2 === g.deltaMode) {
				var r = a.data(this, "mousewheel-page-height");
				j *= r, m *= r, l *= r
			}
			if (n = Math.max(Math.abs(m), Math.abs(l)), (!f || f > n) && (f = n, d(g, n) && (f /= 40)), d(g, n) && (j /= 40, l /= 40, m /= 40), j = Math[j >= 1 ? "floor" : "ceil"](j / f), l = Math[l >= 1 ? "floor" : "ceil"](l / f), m = Math[m >= 1 ? "floor" : "ceil"](m / f), k.settings.normalizeOffset && this.getBoundingClientRect) {
				var s = this.getBoundingClientRect();
				o = b.clientX - s.left, p = b.clientY - s.top
			}
			return b.deltaX = l, b.deltaY = m, b.deltaFactor = f, b.offsetX = o, b.offsetY = p, b.deltaMode = 0, h.unshift(b, j, l, m), e && clearTimeout(e), e = setTimeout(c, 200), (a.event.dispatch || a.event.handle).apply(this, h)
		}
	}

	function c() {
		f = null
	}

	function d(a, b) {
		return k.settings.adjustOldDeltas && "mousewheel" === a.type && b % 120 === 0
	}
	var e, f, g = ["wheel", "mousewheel", "DOMMouseScroll", "MozMousePixelScroll"],
		h = "onwheel" in document || document.documentMode >= 9 ? ["wheel"] : ["mousewheel", "DomMouseScroll", "MozMousePixelScroll"],
		i = Array.prototype.slice;
	if (a.event.fixHooks)
		for (var j = g.length; j;) a.event.fixHooks[g[--j]] = a.event.mouseHooks;
	var k = a.event.special.mousewheel = {
		version: "3.1.12",
		setup: function() {
			if (this.addEventListener)
				for (var c = h.length; c;) this.addEventListener(h[--c], b, !1);
			else this.onmousewheel = b;
			a.data(this, "mousewheel-line-height", k.getLineHeight(this)), a.data(this, "mousewheel-page-height", k.getPageHeight(this))
		},
		teardown: function() {
			if (this.removeEventListener)
				for (var c = h.length; c;) this.removeEventListener(h[--c], b, !1);
			else this.onmousewheel = null;
			a.removeData(this, "mousewheel-line-height"), a.removeData(this, "mousewheel-page-height")
		},
		getLineHeight: function(b) {
			var c = a(b),
				d = c["offsetParent" in a.fn ? "offsetParent" : "parent"]();
			return d.length || (d = a("body")), parseInt(d.css("fontSize"), 10) || parseInt(c.css("fontSize"), 10) || 16
		},
		getPageHeight: function(b) {
			return a(b).height()
		},
		settings: {
			adjustOldDeltas: !0,
			normalizeOffset: !0
		}
	};
	a.fn.extend({
		mousewheel: function(a) {
			return a ? this.bind("mousewheel", a) : this.trigger("mousewheel")
		},
		unmousewheel: function(a) {
			return this.unbind("mousewheel", a)
		}
	})
});

/*!
 Waypoints - 3.1.1
 Copyright © 2011-2015 Caleb Troughton
 Licensed under the MIT license.
 https://github.com/imakewebthings/waypoints/blog/master/licenses.txt
 */
! function() {
	"use strict";

	function t(o) {
		if (!o) throw new Error("No options passed to Waypoint constructor");
		if (!o.element) throw new Error("No element option passed to Waypoint constructor");
		if (!o.handler) throw new Error("No handler option passed to Waypoint constructor");
		this.key = "waypoint-" + e, this.options = t.Adapter.extend({}, t.defaults, o), this.element = this.options.element, this.adapter = new t.Adapter(this.element), this.callback = o.handler, this.axis = this.options.horizontal ? "horizontal" : "vertical", this.enabled = this.options.enabled, this.triggerPoint = null, this.group = t.Group.findOrCreate({
			name: this.options.group,
			axis: this.axis
		}), this.context = t.Context.findOrCreateByElement(this.options.context), t.offsetAliases[this.options.offset] && (this.options.offset = t.offsetAliases[this.options.offset]), this.group.add(this), this.context.add(this), i[this.key] = this, e += 1
	}
	var e = 0,
		i = {};
	t.prototype.queueTrigger = function(t) {
		this.group.queueTrigger(this, t)
	}, t.prototype.trigger = function(t) {
		this.enabled && this.callback && this.callback.apply(this, t)
	}, t.prototype.destroy = function() {
		this.context.remove(this), this.group.remove(this), delete i[this.key]
	}, t.prototype.disable = function() {
		return this.enabled = !1, this
	}, t.prototype.enable = function() {
		return this.context.refresh(), this.enabled = !0, this
	}, t.prototype.next = function() {
		return this.group.next(this)
	}, t.prototype.previous = function() {
		return this.group.previous(this)
	}, t.invokeAll = function(t) {
		var e = [];
		for (var o in i) e.push(i[o]);
		for (var n = 0, r = e.length; r > n; n++) e[n][t]()
	}, t.destroyAll = function() {
		t.invokeAll("destroy")
	}, t.disableAll = function() {
		t.invokeAll("disable")
	}, t.enableAll = function() {
		t.invokeAll("enable")
	}, t.refreshAll = function() {
		t.Context.refreshAll()
	}, t.viewportHeight = function() {
		return window.innerHeight || document.documentElement.clientHeight
	}, t.viewportWidth = function() {
		return document.documentElement.clientWidth
	}, t.adapters = [], t.defaults = {
		context: window,
		continuous: !0,
		enabled: !0,
		group: "default",
		horizontal: !1,
		offset: 0
	}, t.offsetAliases = {
		"bottom-in-view": function() {
			return this.context.innerHeight() - this.adapter.outerHeight()
		},
		"right-in-view": function() {
			return this.context.innerWidth() - this.adapter.outerWidth()
		}
	}, window.Waypoint = t
}(),
function() {
	"use strict";

	function t(t) {
		window.setTimeout(t, 1e3 / 60)
	}

	function e(t) {
		this.element = t, this.Adapter = n.Adapter, this.adapter = new this.Adapter(t), this.key = "waypoint-context-" + i, this.didScroll = !1, this.didResize = !1, this.oldScroll = {
			x: this.adapter.scrollLeft(),
			y: this.adapter.scrollTop()
		}, this.waypoints = {
			vertical: {},
			horizontal: {}
		}, t.waypointContextKey = this.key, o[t.waypointContextKey] = this, i += 1, this.createThrottledScrollHandler(), this.createThrottledResizeHandler()
	}
	var i = 0,
		o = {},
		n = window.Waypoint,
		r = window.onload;
	e.prototype.add = function(t) {
		var e = t.options.horizontal ? "horizontal" : "vertical";
		this.waypoints[e][t.key] = t, this.refresh()
	}, e.prototype.checkEmpty = function() {
		var t = this.Adapter.isEmptyObject(this.waypoints.horizontal),
			e = this.Adapter.isEmptyObject(this.waypoints.vertical);
		t && e && (this.adapter.off(".waypoints"), delete o[this.key])
	}, e.prototype.createThrottledResizeHandler = function() {
		function t() {
			e.handleResize(), e.didResize = !1
		}
		var e = this;
		this.adapter.on("resize.waypoints", function() {
			e.didResize || (e.didResize = !0, n.requestAnimationFrame(t))
		})
	}, e.prototype.createThrottledScrollHandler = function() {
		function t() {
			e.handleScroll(), e.didScroll = !1
		}
		var e = this;
		this.adapter.on("scroll.waypoints", function() {
			(!e.didScroll || n.isTouch) && (e.didScroll = !0, n.requestAnimationFrame(t))
		})
	}, e.prototype.handleResize = function() {
		n.Context.refreshAll()
	}, e.prototype.handleScroll = function() {
		var t = {},
			e = {
				horizontal: {
					newScroll: this.adapter.scrollLeft(),
					oldScroll: this.oldScroll.x,
					forward: "right",
					backward: "left"
				},
				vertical: {
					newScroll: this.adapter.scrollTop(),
					oldScroll: this.oldScroll.y,
					forward: "down",
					backward: "up"
				}
			};
		for (var i in e) {
			var o = e[i],
				n = o.newScroll > o.oldScroll,
				r = n ? o.forward : o.backward;
			for (var s in this.waypoints[i]) {
				var a = this.waypoints[i][s],
					l = o.oldScroll < a.triggerPoint,
					h = o.newScroll >= a.triggerPoint,
					p = l && h,
					u = !l && !h;
				(p || u) && (a.queueTrigger(r), t[a.group.id] = a.group)
			}
		}
		for (var c in t) t[c].flushTriggers();
		this.oldScroll = {
			x: e.horizontal.newScroll,
			y: e.vertical.newScroll
		}
	}, e.prototype.innerHeight = function() {
		return this.element == this.element.window ? n.viewportHeight() : this.adapter.innerHeight()
	}, e.prototype.remove = function(t) {
		delete this.waypoints[t.axis][t.key], this.checkEmpty()
	}, e.prototype.innerWidth = function() {
		return this.element == this.element.window ? n.viewportWidth() : this.adapter.innerWidth()
	}, e.prototype.destroy = function() {
		var t = [];
		for (var e in this.waypoints)
			for (var i in this.waypoints[e]) t.push(this.waypoints[e][i]);
		for (var o = 0, n = t.length; n > o; o++) t[o].destroy()
	}, e.prototype.refresh = function() {
		var t, e = this.element == this.element.window,
			i = this.adapter.offset(),
			o = {};
		this.handleScroll(), t = {
			horizontal: {
				contextOffset: e ? 0 : i.left,
				contextScroll: e ? 0 : this.oldScroll.x,
				contextDimension: this.innerWidth(),
				oldScroll: this.oldScroll.x,
				forward: "right",
				backward: "left",
				offsetProp: "left"
			},
			vertical: {
				contextOffset: e ? 0 : i.top,
				contextScroll: e ? 0 : this.oldScroll.y,
				contextDimension: this.innerHeight(),
				oldScroll: this.oldScroll.y,
				forward: "down",
				backward: "up",
				offsetProp: "top"
			}
		};
		for (var n in t) {
			var r = t[n];
			for (var s in this.waypoints[n]) {
				var a, l, h, p, u, c = this.waypoints[n][s],
					d = c.options.offset,
					f = c.triggerPoint,
					w = 0,
					y = null == f;
				c.element !== c.element.window && (w = c.adapter.offset()[r.offsetProp]), "function" == typeof d ? d = d.apply(c) : "string" == typeof d && (d = parseFloat(d), c.options.offset.indexOf("%") > -1 && (d = Math.ceil(r.contextDimension * d / 100))), a = r.contextScroll - r.contextOffset, c.triggerPoint = w + a - d, l = f < r.oldScroll, h = c.triggerPoint >= r.oldScroll, p = l && h, u = !l && !h, !y && p ? (c.queueTrigger(r.backward), o[c.group.id] = c.group) : !y && u ? (c.queueTrigger(r.forward), o[c.group.id] = c.group) : y && r.oldScroll >= c.triggerPoint && (c.queueTrigger(r.forward), o[c.group.id] = c.group)
			}
		}
		for (var g in o) o[g].flushTriggers();
		return this
	}, e.findOrCreateByElement = function(t) {
		return e.findByElement(t) || new e(t)
	}, e.refreshAll = function() {
		for (var t in o) o[t].refresh()
	}, e.findByElement = function(t) {
		return o[t.waypointContextKey]
	}, window.onload = function() {
		r && r(), e.refreshAll()
	}, n.requestAnimationFrame = function(e) {
		var i = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || t;
		i.call(window, e)
	}, n.Context = e
}(),
function() {
	"use strict";

	function t(t, e) {
		return t.triggerPoint - e.triggerPoint
	}

	function e(t, e) {
		return e.triggerPoint - t.triggerPoint
	}

	function i(t) {
		this.name = t.name, this.axis = t.axis, this.id = this.name + "-" + this.axis, this.waypoints = [], this.clearTriggerQueues(), o[this.axis][this.name] = this
	}
	var o = {
			vertical: {},
			horizontal: {}
		},
		n = window.Waypoint;
	i.prototype.add = function(t) {
		this.waypoints.push(t)
	}, i.prototype.clearTriggerQueues = function() {
		this.triggerQueues = {
			up: [],
			down: [],
			left: [],
			right: []
		}
	}, i.prototype.flushTriggers = function() {
		for (var i in this.triggerQueues) {
			var o = this.triggerQueues[i],
				n = "up" === i || "left" === i;
			o.sort(n ? e : t);
			for (var r = 0, s = o.length; s > r; r += 1) {
				var a = o[r];
				(a.options.continuous || r === o.length - 1) && a.trigger([i])
			}
		}
		this.clearTriggerQueues()
	}, i.prototype.next = function(e) {
		this.waypoints.sort(t);
		var i = n.Adapter.inArray(e, this.waypoints),
			o = i === this.waypoints.length - 1;
		return o ? null : this.waypoints[i + 1]
	}, i.prototype.previous = function(e) {
		this.waypoints.sort(t);
		var i = n.Adapter.inArray(e, this.waypoints);
		return i ? this.waypoints[i - 1] : null
	}, i.prototype.queueTrigger = function(t, e) {
		this.triggerQueues[e].push(t)
	}, i.prototype.remove = function(t) {
		var e = n.Adapter.inArray(t, this.waypoints);
		e > -1 && this.waypoints.splice(e, 1)
	}, i.prototype.first = function() {
		return this.waypoints[0]
	}, i.prototype.last = function() {
		return this.waypoints[this.waypoints.length - 1]
	}, i.findOrCreate = function(t) {
		return o[t.axis][t.name] || new i(t)
	}, n.Group = i
}(),
function() {
	"use strict";

	function t(t) {
		this.$element = e(t)
	}
	var e = window.jQuery,
		i = window.Waypoint;
	e.each(["innerHeight", "innerWidth", "off", "offset", "on", "outerHeight", "outerWidth", "scrollLeft", "scrollTop"], function(e, i) {
		t.prototype[i] = function() {
			var t = Array.prototype.slice.call(arguments);
			return this.$element[i].apply(this.$element, t)
		}
	}), e.each(["extend", "inArray", "isEmptyObject"], function(i, o) {
		t[o] = e[o]
	}), i.adapters.push({
		name: "jquery",
		Adapter: t
	}), i.Adapter = t
}(),
function() {
	"use strict";

	function t(t) {
		return function() {
			var i = [],
				o = arguments[0];
			return t.isFunction(arguments[0]) && (o = t.extend({}, arguments[1]), o.handler = arguments[0]), this.each(function() {
				var n = t.extend({}, o, {
					element: this
				});
				"string" == typeof n.context && (n.context = t(this).closest(n.context)[0]), i.push(new e(n))
			}), i
		}
	}
	var e = window.Waypoint;
	window.jQuery && (window.jQuery.fn.waypoint = t(window.jQuery)), window.Zepto && (window.Zepto.fn.waypoint = t(window.Zepto))
}();

/**
 * @license MIT or GPL-2.0
 * @fileOverview Favico animations
 * @author Miroslav Magda, http://blog.ejci.net
 * @source: https://github.com/ejci/favico.js
 * @version 0.3.10
 */

/**
 * Create new favico instance
 * @param {Object} Options
 * @return {Object} Favico object
 * @example
 * var favico = new Favico({
 *    bgColor : '#d00',
 *    textColor : '#fff',
 *    fontFamily : 'sans-serif',
 *    fontStyle : 'bold',
 *    type : 'circle',
 *    position : 'down',
 *    animation : 'slide',
 *    elementId: false,
 *    element: null,
 *    dataUrl: function(url){},
 *    win: window
 * });
 */
! function() {
	var t = function(a) {
		"use strict";
		a = a || {};
		var l, s, h, c, f, u, y, n, i, e, d, o, r, w, g, p, x = {
			bgColor: "#d00",
			textColor: "#fff",
			fontFamily: "sans-serif",
			fontStyle: "bold",
			type: "circle",
			position: "down",
			animation: "slide",
			elementId: !1,
			element: null,
			dataUrl: !1,
			win: window
		};
		(r = {}).ff = "undefined" != typeof InstallTrigger, r.chrome = !!window.chrome, r.opera = !!window.opera || 0 <= navigator.userAgent.indexOf("Opera"), r.ie = !1, r.safari = 0 < Object.prototype.toString.call(window.HTMLElement).indexOf("Constructor"), r.supported = r.chrome || r.ff || r.opera;
		var m = [];
		n = o = !(d = function() {});
		var b = {
			ready: function() {
				n = !0, b.reset(), d()
			},
			reset: function() {
				n && (e = i = !(m = []), u.clearRect(0, 0, c, h), u.drawImage(y, 0, 0, c, h), I.setIcon(f), window.clearTimeout(w), window.clearTimeout(g))
			}
		};
		b.start = function() {
			if (n && !e) {
				if (0 < m.length) {
					e = !0;
					var t = function() {
						["type", "animation", "bgColor", "textColor", "fontFamily", "fontStyle"].forEach(function(t) {
							t in m[0].options && (l[t] = m[0].options[t])
						}), T.run(m[0].options, function() {
							i = m[0], e = !1, 0 < m.length && (m.shift(), b.start())
						}, !1)
					};
					i ? T.run(i.options, function() {
						t()
					}, !0) : t()
				}
			}
		};
		var v = {},
			C = function(t) {
				return t.n = "number" == typeof t.n ? Math.abs(0 | t.n) : t.n, t.x = c * t.x, t.y = h * t.y, t.w = c * t.w, t.h = h * t.h, t.len = ("" + t.n).length, t
			};
		v.circle = function(t) {
			var e = !1;
			2 === (t = C(t)).len ? (t.x = t.x - .4 * t.w, t.w = 1.4 * t.w, e = !0) : 3 <= t.len && (t.x = t.x - .65 * t.w, t.w = 1.65 * t.w, e = !0), u.clearRect(0, 0, c, h), u.drawImage(y, 0, 0, c, h), u.beginPath(), u.font = l.fontStyle + " " + Math.floor(t.h * (99 < t.n ? .85 : 1)) + "px " + l.fontFamily, u.textAlign = "center", e ? (u.moveTo(t.x + t.w / 2, t.y), u.lineTo(t.x + t.w - t.h / 2, t.y), u.quadraticCurveTo(t.x + t.w, t.y, t.x + t.w, t.y + t.h / 2), u.lineTo(t.x + t.w, t.y + t.h - t.h / 2), u.quadraticCurveTo(t.x + t.w, t.y + t.h, t.x + t.w - t.h / 2, t.y + t.h), u.lineTo(t.x + t.h / 2, t.y + t.h), u.quadraticCurveTo(t.x, t.y + t.h, t.x, t.y + t.h - t.h / 2), u.lineTo(t.x, t.y + t.h / 2), u.quadraticCurveTo(t.x, t.y, t.x + t.h / 2, t.y)) : u.arc(t.x + t.w / 2, t.y + t.h / 2, t.h / 2, 0, 2 * Math.PI), u.fillStyle = "rgba(" + l.bgColor.r + "," + l.bgColor.g + "," + l.bgColor.b + "," + t.o + ")", u.fill(), u.closePath(), u.beginPath(), u.stroke(), u.fillStyle = "rgba(" + l.textColor.r + "," + l.textColor.g + "," + l.textColor.b + "," + t.o + ")", "number" == typeof t.n && 999 < t.n ? u.fillText((9999 < t.n ? 9 : Math.floor(t.n / 1e3)) + "k+", Math.floor(t.x + t.w / 2), Math.floor(t.y + t.h - .2 * t.h)) : u.fillText(t.n, Math.floor(t.x + t.w / 2), Math.floor(t.y + t.h - .15 * t.h)), u.closePath()
		}, v.rectangle = function(t) {
			2 === (t = C(t)).len ? (t.x = t.x - .4 * t.w, t.w = 1.4 * t.w) : 3 <= t.len && (t.x = t.x - .65 * t.w, t.w = 1.65 * t.w), u.clearRect(0, 0, c, h), u.drawImage(y, 0, 0, c, h), u.beginPath(), u.font = l.fontStyle + " " + Math.floor(t.h * (99 < t.n ? .9 : 1)) + "px " + l.fontFamily, u.textAlign = "center", u.fillStyle = "rgba(" + l.bgColor.r + "," + l.bgColor.g + "," + l.bgColor.b + "," + t.o + ")", u.fillRect(t.x, t.y, t.w, t.h), u.fillStyle = "rgba(" + l.textColor.r + "," + l.textColor.g + "," + l.textColor.b + "," + t.o + ")", "number" == typeof t.n && 999 < t.n ? u.fillText((9999 < t.n ? 9 : Math.floor(t.n / 1e3)) + "k+", Math.floor(t.x + t.w / 2), Math.floor(t.y + t.h - .2 * t.h)) : u.fillText(t.n, Math.floor(t.x + t.w / 2), Math.floor(t.y + t.h - .15 * t.h)), u.closePath()
		};

		function E(t) {
			if (t.paused || t.ended || o) return !1;
			try {
				u.clearRect(0, 0, c, h), u.drawImage(t, 0, 0, c, h)
			} catch (t) {}
			g = setTimeout(function() {
				E(t)
			}, T.duration), I.setIcon(f)
		}
		var I = {};

		function M(t) {
			t = t.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function(t, e, o, n) {
				return e + e + o + o + n + n
			});
			var e = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t);
			return !!e && {
				r: parseInt(e[1], 16),
				g: parseInt(e[2], 16),
				b: parseInt(e[3], 16)
			}
		}

		function A(t, e) {
			var o, n = {};
			for (o in t) n[o] = t[o];
			for (o in e) n[o] = e[o];
			return n
		}
		I.getIcons = function() {
			var t = [];
			return l.element ? t = [l.element] : l.elementId ? (t = [p.getElementById(l.elementId)])[0].setAttribute("href", t[0].getAttribute("src")) : 0 === (t = function() {
				for (var t = [], e = p.getElementsByTagName("head")[0].getElementsByTagName("link"), o = 0; o < e.length; o++) /(^|\s)icon(\s|$)/i.test(e[o].getAttribute("rel")) && t.push(e[o]);
				return t
			}()).length && ((t = [p.createElement("link")])[0].setAttribute("rel", "icon"), p.getElementsByTagName("head")[0].appendChild(t[0])), t.forEach(function(t) {
				t.setAttribute("type", "image/png")
			}), t
		}, I.setIcon = function(t) {
			var e = t.toDataURL("image/png");
			I.setIconSrc(e)
		}, I.setIconSrc = function(e) {
			if (l.dataUrl && l.dataUrl(e), l.element) l.element.setAttribute("href", e), l.element.setAttribute("src", e);
			else if (l.elementId) {
				var t = p.getElementById(l.elementId);
				t.setAttribute("href", e), t.setAttribute("src", e)
			} else if (r.ff || r.opera) {
				var o = s[s.length - 1],
					n = p.createElement("link");
				s = [n], r.opera && n.setAttribute("rel", "icon"), n.setAttribute("rel", "icon"), n.setAttribute("type", "image/png"), p.getElementsByTagName("head")[0].appendChild(n), n.setAttribute("href", e), o.parentNode && o.parentNode.removeChild(o)
			} else s.forEach(function(t) {
				t.setAttribute("href", e)
			})
		};
		var T = {
			duration: 40,
			types: {}
		};
		return T.types.fade = [{
				x: .4,
				y: .4,
				w: .6,
				h: .6,
				o: 0
			}, {
				x: .4,
				y: .4,
				w: .6,
				h: .6,
				o: .1
			}, {
				x: .4,
				y: .4,
				w: .6,
				h: .6,
				o: .2
			}, {
				x: .4,
				y: .4,
				w: .6,
				h: .6,
				o: .3
			}, {
				x: .4,
				y: .4,
				w: .6,
				h: .6,
				o: .4
			}, {
				x: .4,
				y: .4,
				w: .6,
				h: .6,
				o: .5
			}, {
				x: .4,
				y: .4,
				w: .6,
				h: .6,
				o: .6
			}, {
				x: .4,
				y: .4,
				w: .6,
				h: .6,
				o: .7
			}, {
				x: .4,
				y: .4,
				w: .6,
				h: .6,
				o: .8
			}, {
				x: .4,
				y: .4,
				w: .6,
				h: .6,
				o: .9
			}, {
				x: .4,
				y: .4,
				w: .6,
				h: .6,
				o: 1
			}], T.types.none = [{
				x: .4,
				y: .4,
				w: .6,
				h: .6,
				o: 1
			}], T.types.pop = [{
				x: 1,
				y: 1,
				w: 0,
				h: 0,
				o: 1
			}, {
				x: .9,
				y: .9,
				w: .1,
				h: .1,
				o: 1
			}, {
				x: .8,
				y: .8,
				w: .2,
				h: .2,
				o: 1
			}, {
				x: .7,
				y: .7,
				w: .3,
				h: .3,
				o: 1
			}, {
				x: .6,
				y: .6,
				w: .4,
				h: .4,
				o: 1
			}, {
				x: .5,
				y: .5,
				w: .5,
				h: .5,
				o: 1
			}, {
				x: .4,
				y: .4,
				w: .6,
				h: .6,
				o: 1
			}], T.types.popFade = [{
				x: .75,
				y: .75,
				w: 0,
				h: 0,
				o: 0
			}, {
				x: .65,
				y: .65,
				w: .1,
				h: .1,
				o: .2
			}, {
				x: .6,
				y: .6,
				w: .2,
				h: .2,
				o: .4
			}, {
				x: .55,
				y: .55,
				w: .3,
				h: .3,
				o: .6
			}, {
				x: .5,
				y: .5,
				w: .4,
				h: .4,
				o: .8
			}, {
				x: .45,
				y: .45,
				w: .5,
				h: .5,
				o: .9
			}, {
				x: .4,
				y: .4,
				w: .6,
				h: .6,
				o: 1
			}], T.types.slide = [{
				x: .4,
				y: 1,
				w: .6,
				h: .6,
				o: 1
			}, {
				x: .4,
				y: .9,
				w: .6,
				h: .6,
				o: 1
			}, {
				x: .4,
				y: .9,
				w: .6,
				h: .6,
				o: 1
			}, {
				x: .4,
				y: .8,
				w: .6,
				h: .6,
				o: 1
			}, {
				x: .4,
				y: .7,
				w: .6,
				h: .6,
				o: 1
			}, {
				x: .4,
				y: .6,
				w: .6,
				h: .6,
				o: 1
			}, {
				x: .4,
				y: .5,
				w: .6,
				h: .6,
				o: 1
			}, {
				x: .4,
				y: .4,
				w: .6,
				h: .6,
				o: 1
			}], T.run = function(t, e, o, n) {
				var r = T.types[p.hidden || p.msHidden || p.webkitHidden || p.mozHidden ? "none" : l.animation];
				n = !0 === o ? void 0 !== n ? n : r.length - 1 : void 0 !== n ? n : 0, e = e || function() {}, n < r.length && 0 <= n ? (v[l.type](A(t, r[n])), w = setTimeout(function() {
					o ? n -= 1 : n += 1, T.run(t, e, o, n)
				}, T.duration), I.setIcon(f)) : e()
			},
			function() {
				(l = A(x, a)).bgColor = M(l.bgColor), l.textColor = M(l.textColor), l.position = l.position.toLowerCase(), l.animation = T.types["" + l.animation] ? l.animation : x.animation, p = l.win.document;
				var t = -1 < l.position.indexOf("up"),
					e = -1 < l.position.indexOf("left");
				if (t || e)
					for (var o in T.types)
						for (var n = 0; n < T.types[o].length; n++) {
							var r = T.types[o][n];
							t && (r.y < .6 ? r.y = r.y - .4 : r.y = r.y - 2 * r.y + (1 - r.w)), e && (r.x < .6 ? r.x = r.x - .4 : r.x = r.x - 2 * r.x + (1 - r.h)), T.types[o][n] = r
						}
				l.type = v["" + l.type] ? l.type : x.type, s = I.getIcons(), f = document.createElement("canvas"), y = document.createElement("img");
				var i = s[s.length - 1];
				i.hasAttribute("href") ? (y.setAttribute("crossOrigin", "anonymous"), y.onload = function() {
					h = 0 < y.height ? y.height : 32, c = 0 < y.width ? y.width : 32, f.height = h, f.width = c, u = f.getContext("2d"), b.ready()
				}, y.setAttribute("src", i.getAttribute("href"))) : (c = h = 32, y.height = h, y.width = c, f.height = h, f.width = c, u = f.getContext("2d"), b.ready())
			}(), {
				badge: function(t, o) {
					o = ("string" == typeof o ? {
						animation: o
					} : o) || {}, d = function() {
						try {
							if ("number" == typeof t ? 0 < t : "" !== t) {
								var e = {
									type: "badge",
									options: {
										n: t
									}
								};
								if ("animation" in o && T.types["" + o.animation] && (e.options.animation = "" + o.animation), "type" in o && v["" + o.type] && (e.options.type = "" + o.type), ["bgColor", "textColor"].forEach(function(t) {
										t in o && (e.options[t] = M(o[t]))
									}), ["fontStyle", "fontFamily"].forEach(function(t) {
										t in o && (e.options[t] = o[t])
									}), m.push(e), 100 < m.length) throw new Error("Too many badges requests in queue.");
								b.start()
							} else b.reset()
						} catch (t) {
							throw new Error("Error setting badge. Message: " + t.message)
						}
					}, n && d()
				},
				video: function(t) {
					d = function() {
						try {
							if ("stop" === t) return o = !0, b.reset(), void(o = !1);
							t.addEventListener("play", function() {
								E(this)
							}, !1)
						} catch (t) {
							throw new Error("Error setting video. Message: " + t.message)
						}
					}, n && d()
				},
				image: function(r) {
					d = function() {
						try {
							var t = r.width,
								e = r.height,
								o = document.createElement("img"),
								n = t / c < e / h ? t / c : e / h;
							o.setAttribute("crossOrigin", "anonymous"), o.onload = function() {
								u.clearRect(0, 0, c, h), u.drawImage(o, 0, 0, c, h), I.setIcon(f)
							}, o.setAttribute("src", r.getAttribute("src")), o.height = e / n, o.width = t / n
						} catch (t) {
							throw new Error("Error setting image. Message: " + t.message)
						}
					}, n && d()
				},
				rawImageSrc: function(t) {
					d = function() {
						I.setIconSrc(t)
					}, n && d()
				},
				webcam: function(t) {
					if (window.URL && window.URL.createObjectURL || (window.URL = window.URL || {}, window.URL.createObjectURL = function(t) {
							return t
						}), r.supported) {
						var e = !1;
						navigator.getUserMedia = navigator.getUserMedia || navigator.oGetUserMedia || navigator.msGetUserMedia || navigator.mozGetUserMedia || navigator.webkitGetUserMedia, d = function() {
							try {
								if ("stop" === t) return o = !0, b.reset(), void(o = !1);
								(e = document.createElement("video")).width = c, e.height = h, navigator.getUserMedia({
									video: !0,
									audio: !1
								}, function(t) {
									e.src = URL.createObjectURL(t), e.play(), E(e)
								}, function() {})
							} catch (t) {
								throw new Error("Error setting webcam. Message: " + t.message)
							}
						}, n && d()
					}
				},
				setOpt: function(t, e) {
					var o = t;
					null == e && "[object Object]" == Object.prototype.toString.call(t) || ((o = {})[t] = e);
					for (var n = Object.keys(o), r = 0; r < n.length; r++) "bgColor" == n[r] || "textColor" == n[r] ? l[n[r]] = M(o[n[r]]) : l[n[r]] = o[n[r]];
					m.push(i), b.start()
				},
				reset: b.reset,
				browser: {
					supported: r.supported
				}
			}
	};
	"undefined" != typeof define && define.amd ? define([], function() {
		return t
	}) : "undefined" != typeof module && module.exports ? module.exports = t : this.Favico = t
}();

/**
 * Author -> ThemeTidy
 * Email -> support@themetidy.com
 * Version -> 2.5
 * Paira Main Js
 */
! function(T, j, p) {
	T(function() {
		n.initDomReady()
	}), T(j).load(function() {
		n.initWindowReady()
	});
	var n = {
		initDomReady: function() {
			this.initPairaAnimation(), this.initCompareList(), this.initWishList(), this.initAddToCart(), this.initFilter(), this.initWelcomeDialog(), this.initDomLoadClass()
		},
		initWindowReady: function() {
			this.initToolTip(), this.initQuickView(), this.initCartPage(), this.initWindowLoadClass(), this.initStickyElements(), this.initBackToTop(), this.initIE10ViewPortHack()
		},
		showLoading: function() {
			T(".paira-loading").show()
		},
		hideLoading: function() {
			T(".paira-loading").hide()
		},
		showSuccessMessage: function(t) {
			var e = t.image,
				a = t.message,
				i = t.buttonText,
				r = t.buttonLink,
				n = t.productName,
				o = T("#paira-ajax-success-message");
			o.find(".paira-success-message-img").html('<img src="' + e + '" class="img-responsive">'), o.find(".paira-success-message-title").text(n), o.find(".paira-success-message-details").html(a), o.find(".paira-success-message-link").text(i), o.find(".paira-success-message-link").attr("href", r), o.modal("show")
		},
		showCommonMessage: function(t) {
			var e = T("#paira-common-message");
			e.find(".paira-common-message-details").html(t), e.modal("show")
		},
		currencyConvert: function() {
			Currency.convertAll(j.shopCurrency, T("#currencies").val(), "span.money", j.currencyFormat)
		},
		ajaxInstantSearch: function(t) {
			var e = "type=product&view=json&q=*" + t + "*";
			return T.ajax({
				url: "/search",
				type: "get",
				dataType: "json",
				data: e,
				beforeSend: function() {
					T(".search-loading").show(), T(".instant-search-data").show()
				},
				error: function() {
					T(".search-loading").hide(), T(".instant-search-data").hide()
				}
			})
		},
		ajaxAddToCart: function(t, e, props = {}) {
			var a = "quantity=" + e + "&id=" + t;
			if (Object.keys(props).length && typeof props._is_preorder !== 'undefined') {
				a += "&properties[_is_preorder]=" + props._is_preorder + "&properties[Note:]=" + props._is_preorder
			};
			return T.ajax({
				url: "/cart/add.js",
				type: "get",
				data: a,
				dataType: "json",
				beforeSend: function() {
					n.showLoading()
				},
				error: function(t) {
					n.hideLoading();
					var e = '<i class="fa fa-info-circle font-size-16"></i> ' + T.parseJSON(t.responseText).description;
					n.showCommonMessage(e)
				}
			})
		},
		ajaxDropdownCart: function() {
			Shopify.getCart(function(t) {
				n.updateDropdownCart(t)
			})
		},
		cartEmptyOrNot: function() {
			0 < T(".paira-cart-item-list").children().length ? (T(".paira-cartNotEmpty").show(), T(".cart-products").show(), T(".paira-cartEmpty").hide()) : (T(".paira-cartNotEmpty").hide(), T(".cart-products").hide(), T(".paira-cartEmpty").show())
		},
		updateDropdownCart: function(t) {
			var e = Shopify.formatMoney(t.total_price),
				a = "";
			T(".paira-cart-total-price").html('<span class="money">' + e + "</span>"), T(".paira-cart-item-count").html(t.item_count);
			for (var i = 0; i < t.items.length; i++) a += '<li class="cart-menu-line-item padding-left-15 padding-right-15"><a href="' + t.items[i].url + '" class="pull-left cart-images-drop"><img src="' + Shopify.resizeImage(t.items[i].image, "small") + '" alt=""></a><div class="pull-left cart-detail-drop"><a href="' + t.items[i].url + '" class="cart-menu-line-title pull-left margin-left-10 drop-title">' + t.items[i].product_title + '</a><div class="pull-left cart-menu-line-cal text-right"><a href="#" class="cart-menu-item-remove drop-title" data-varient-id="' + t.items[i].variant_id + '"><i class="fa fa-times"></i></a><p class="margin-top-15"><strong class="cart-menu-line-quantity">' + t.items[i].quantity + '</strong> x <strong class="cart-menu-line-price"><span class="money">' + Shopify.formatMoney(t.items[i].price, j.money_format) + '</span></strong></p></div></div></li><li class="divider"></li>';
			T(".paira-cart-item-list").html("").append(a), n.cartEmptyOrNot(), n.currencyConvert()
		},
		faviconCartBadge: function(t) {
			var e = new Favico({
				animation: "popFade",
				bgColor: "#e9000d",
				textColor: "#ff0"
			});
			0 < t && e.badge(t), 0 === t && e.badge("0")
		},
		initAddToCart: function() {
			n.faviconCartBadge(j.cartItem), T(p).on("click", ".paira-add-to-cart", function(t) {
				t.preventDefault();
				var e = {
						image: T(this).parents(".paira-product").find(".paira-product-image").attr("src"),
						message: '<i class="fa fa-check-circle"></i> ' + j.dialogCart,
						buttonText: "" + j.dialogCartBtn,
						buttonLink: "/cart",
						productName: T(this).parents(".paira-product").find(".paira-product-title").text()
					},
					a = parseInt(T(this).attr("data-item-quantity")),
					i = +j.cartItem + +a,
					r = T(this).attr("data-varient-id");
				let properties = {};
				if (T(this).closest('form').find('.gPreorderProperty').length) {
					properties._is_preorder = T(this).closest('form').find('.gPreorderProperty').val()
				};
				console.log(properties);
				n.ajaxAddToCart(r, a, properties).done(function() {
					n.hideLoading(), n.ajaxDropdownCart(), T(".paira-go-to-checkout").show(), n.showSuccessMessage(e)
				}), j.cartItem = i, n.faviconCartBadge(j.cartItem)
			}), T(p).on("click", ".paira-buy-now", function(t) {
				t.preventDefault();
				var e = parseInt(T(this).attr("data-item-quantity")),
					a = T(this).attr("data-varient-id");
				n.ajaxAddToCart(a, e).done(function() {
					j.location.href = "/checkout"
				})
			}), T(p).on("click", ".cart-menu-item-remove", function(t) {
				t.preventDefault();
				var e = T(this).attr("data-varient-id");
				Shopify.removeItem(e, function(t) {
					n.updateDropdownCart(t), j.cartItem = j.cartItem - 1, n.faviconCartBadge(j.cartItem)
				})
			}), n.cartEmptyOrNot()
		},
		compareListCount: function() {
			var t = Shopify.PairaCookie.countItem("paira_cookieName_compare");
			T(".paira-compare-count").text(t)
		},
		compareListDone: function() {
			var t = Shopify.PairaCookie.cookieList("paira_cookieName_compare");
			if (void 0 !== t) {
				t = t.split(" ");
				for (var e = 0; e < t.length; e++) {
					var a = T('.paira-add-to-compare[data-handle="' + t[e] + '"]');
					a.addClass("paira-compare-done"), a.removeClass("paira-add-to-compare")
				}
			}
		},
		compareListRecord: function(t) {
			Shopify.PairaCookie.recordItem(t, {
				cookieName: "paira_cookieName_compare"
			}), n.compareListDone()
		},
		compareListEmpty: function() {
			var t = Shopify.PairaCookie.countItem("paira_cookieName_compare"),
				e = T(".paira-compare-list-empty");
			e.length && 0 == t && (e.fadeIn(), T(".paira-compare-table").hide())
		},
		initBackToTop: function() {
			T(j).scroll(function() {
				500 < T(this).scrollTop() ? T("#back-to-up").fadeIn() : T("#back-to-up").fadeOut()
			}), T(p).on("click", "#back-to-up", function(t) {
				return T("html, body").animate({
					scrollTop: 0
				}, 800), !1
			})
		},
		initCompareList: function() {
			T(p).on("click", ".paira-add-to-compare", function(t) {
				t.preventDefault();
				var e = T(this).attr("data-handle");
				n.compareListRecord(e);
				var a = {
					image: T(this).parents(".paira-product").find(".paira-product-image").attr("src"),
					message: '<i class="fa fa-check-circle"></i> ' + j.dialogCompare,
					buttonText: "" + j.dialogCompareBtn,
					buttonLink: "/pages/" + j.comparePage,
					productName: T(this).parents(".paira-product").find(".paira-product-title").text()
				};
				T(".paira-go-to-checkout").hide(), n.showSuccessMessage(a), n.compareListCount()
			}), T(p).on("click", ".paira-compare-done", function(t) {
				if (t.preventDefault(), "" == j.comparePage) var e = '<i class="fa fa-info-circle font-size-16"></i> This product already in your Compare List. To view compare product please select compare page from <a href="/admin/themes">theme option</a>';
				else e = '<i class="fa fa-info-circle font-size-16"></i> This product already in your Compare List. Please check Compare page <a href="/pages/' + j.comparePage + '">Here</a>';
				n.showCommonMessage(e)
			}), T(p).on("click", ".paira-compare-remove", function(t) {
				t.preventDefault(), Shopify.PairaCookie.removeItem(T(this).attr("data-handle"), {
					cookieName: "paira_cookieName_compare"
				}), T(this).parents(".paira-product").fadeOut(), n.compareListEmpty(), n.compareListCount()
			}), T(p).on("click", ".paira-compare-null", function(t) {
				t.stopPropagation();
				n.showCommonMessage('<i class="fa fa-info-circle font-size-16"></i> Please select Compare Page from <a href="/admin/themes">theme option</a>')
			}), n.compareListCount(), n.compareListEmpty(), n.compareListDone()
		},
		wishListCount: function() {
			var t = Shopify.PairaCookie.countItem("paira_cookieName_wish");
			T(".paira-wish-count").text(t)
		},
		wishListDone: function() {
			var t = Shopify.PairaCookie.cookieList("paira_cookieName_wish");
			if (void 0 !== t) {
				t = t.split(" ");
				for (var e = 0; e < t.length; e++) {
					var a = T('.paira-add-to-wish[data-handle="' + t[e] + '"]');
					a.addClass("paira-wish-done"), a.removeClass("paira-add-to-wish")
				}
			}
		},
		wishListRecord: function(t) {
			Shopify.PairaCookie.recordItem(t, {
				cookieName: "paira_cookieName_wish"
			}), n.wishListDone()
		},
		wishListEmpty: function() {
			var t = Shopify.PairaCookie.countItem("paira_cookieName_wish"),
				e = T(".paira-wish-list-empty");
			e.length && 0 == t && (e.fadeIn(), T(".paira-wish-table").hide())
		},
		initWishList: function() {
			T(p).on("click", ".paira-add-to-wish", function(t) {
				t.preventDefault();
				var e = T(this).attr("data-handle");
				n.wishListRecord(e);
				var a = {
					image: T(this).parents(".paira-product").find(".paira-product-image").attr("src"),
					message: '<i class="fa fa-check-circle"></i> ' + j.dialogWish,
					buttonText: "" + j.dialogWishBtn,
					buttonLink: "/pages/" + j.wishPage,
					productName: T(this).parents(".paira-product").find(".paira-product-title").text()
				};
				T(".paira-go-to-checkout").hide(), n.showSuccessMessage(a), n.wishListCount()
			}), T(p).on("click", ".paira-wish-done", function(t) {
				if (t.preventDefault(), "" == j.wishPage) var e = '<i class="fa fa-info-circle font-size-16"></i> This product already in your WishList. To view Wish list product please select wishlist page from <a href="/admin/themes">theme option</a>';
				else e = '<i class="fa fa-info-circle font-size-16"></i> This product already in your WishList. Please check WishList page <a href="/pages/' + j.wishPage + '">Here</a>';
				n.showCommonMessage(e)
			}), T(p).on("click", ".paira-wish-remove", function(t) {
				t.preventDefault(), Shopify.PairaCookie.removeItem(T(this).attr("data-handle"), {
					cookieName: "paira_cookieName_wish"
				}), T(this).parents(".paira-product").fadeOut(), n.wishListEmpty(), n.wishListCount()
			}), T(p).on("click", ".paira-wish-null", function(t) {
				t.stopPropagation();
				n.showCommonMessage('<i class="fa fa-info-circle font-size-16"></i> Please select WishList Page from <a href="/admin/themes">theme option</a>')
			}), n.wishListCount(), n.wishListEmpty(), n.wishListDone()
		},
		ajaxGetData: function(t, e) {
			var a = void 0 !== e ? e : "html";
			return T.ajax({
				url: t,
				type: "get",
				dataType: a,
				beforeSend: function() {
					n.showLoading()
				},
				error: function() {
					n.hideLoading();
					var t = '<i class="fa fa-info-circle font-size-16"></i> ' + j.dialogMassage;
					n.showCommonMessage(t)
				}
			})
		},
		cartPageUpdate: function(t) {
			var e = T(t).find(".paira-cart-item-count").text();
			(T(".paira-cart-page-list").html(T(t).find(".paira-cart-page-list").html()), T(".paira-cart-menu-body").html(T(t).find(".paira-cart-menu-body").html()), T(".paira-cart-sub-total").html(T(t).find(".paira-cart-sub-total").html()), n.cartEmptyOrNot(), n.currencyConvert(), 0 == e) ? new Favico({
				animation: "popFade",
				bgColor: "#e9000d",
				textColor: "#ff0"
			}).badge("0"): n.faviconCartBadge(e)
		},
		initCartPage: function() {
			T(p).on("click", ".paira-cart-page-update", function(t) {
				t.preventDefault();
				var e = T(this).attr("href") + T(".paira-cart-quantity-" + T(this).attr("data-item-id")).val();
				n.ajaxGetData(e).done(function(t) {
					n.hideLoading(), n.cartPageUpdate(t)
				})
			}), T(p).on("input", ".paira-cart-quantity-ajax", function(t) {
				var e = T(this).attr("data-href") + T(this).val();
				n.ajaxGetData(e).done(function(t) {
					n.hideLoading(), n.cartPageUpdate(t)
				})
			}), T(p).on("click", ".paira-cart-page-delete", function(t) {
				t.preventDefault();
				var e = T(this).attr("href");
				n.ajaxGetData(e).done(function(t) {
					n.hideLoading(), n.cartPageUpdate(t)
				})
			})
		},
		filterDefaultData: function() {
			var t = p.location.href,
				e = t.split("?"),
				a = e[0].substr(e[0].lastIndexOf("/") + 1);
			if (a = a || t.substr(t.lastIndexOf("/") + 1), T(".paira-filter-category option[value='/collections/" + a + "']").attr("selected", "selected"), e[1]) {
				var i = e[1].split("="),
					r = i[1].split("+");
				"constraint" == i[0] && (T(".filter-product-list").slideToggle("slow"), T(".paira-filter-section").show());
				for (var n = 0; n < r.length; n++) T(".paira-filter-checkbox").each(function() {
					r[n] == T(this).val() && (T(this).prop("checked", !0), T(this).parent().addClass("active"), T(this).parents("span").addClass("active"))
				});
				"sort_by" == i[0] ? i[1] && T(".paira-sort-by option[value='" + i[1] + "']").attr("selected", "selected") : "show" == i[0] && ("list" == i[1] ? (T(".paira-list-grid").removeClass("active"), T('.paira-list-grid[data-value="list"]').addClass("active"), T(".paira-grid-view").addClass("paira-list-view").removeClass("paira-grid-view"), T(".paira-list-product-des").show()) : (T(".paira-list-grid").removeClass("active"), T('.paira-list-grid[data-value="grid"]').addClass("active"), T(".paira-list-view").addClass("paira-grid-view").removeClass("paira-list-view"), T(".paira-list-product-des").hide()))
			}
		},
		filterUpdate: function(t) {
			T(".collection-handle").text(T(t).find(".paira-filter-category.active").text()), T(".paira-collection-content").html(T(t).find(".paira-collection-content").html()), T(".paira-filter-product").html(T(t).find(".paira-filter-product").html()), n.filterDefaultData(), n.currencyConvert(), n.pairaAnimation(T(".paira-animation"))
		},
		urlPushState: function(t) {
			t != j.location && (history.pushState ? j.history.pushState({
				path: t
			}, t, t) : j.location.href = t)
		},
		filterCategoryUrl: function(t) {
			var e = p.location.href.split("?"),
				a = t.attr("href");
			return e[1] && (a = a + "?" + e[1]), a
		},
		filterSortByUrl: function(t) {
			var e = p.location.href,
				a = e.split("?"),
				i = t.val();
			return a[1] && (e = a[0]), e = e + "?sort_by=" + i.replace(/\+/g, "%20")
		},
		filterGridListUrl: function(t) {
			var e = p.location.href,
				a = e.split("?"),
				i = t.attr("data-value");
			return a[1] && (e = a[0]), e = e + "?show=" + i.replace(/\+/g, "%20")
		},
		filterCheckBox: function(t) {
			var e = p.location.href,
				a = e.split("?"),
				r = a[0].substr(a[0].lastIndexOf("/") + 1);
			if (e = "/collections/" + r + "?constraint=" + t.val(), a[1]) {
				var n = a[1].split("=");
				if ("constraint" == n[0]) {
					var o = n[1].split("+");
					o.push(t.val());
					var s = o.join("+");
					if (t.is(":checked")) e = "/collections/" + r + "?constraint=" + s;
					else {
						for (Array.prototype.remove = function() {
								for (var t, e, a = arguments, i = a.length; i && this.length;)
									for (t = a[--i]; - 1 !== (e = this.indexOf(t));) this.splice(e, 1);
								return this
							}, i = 0; i < o.length; i++) o[i] == t.val() && o.remove(t.val());
						e = 0 == o.length ? "/collections/" + r : "/collections/" + r + "?constraint=" + (s = o.join("+"))
					}
				}
			}
			return e
		},
		initFilter: function() {
			T(p).on("click", ".paira-filter-category", function(t) {
				t.preventDefault();
				var e = T(this),
					a = n.filterCategoryUrl(e);
				n.ajaxGetData(a).done(function(t) {
					n.hideLoading(), n.urlPushState(a), n.filterUpdate(t)
				})
			}), T(p).on("change", ".paira-sort-by", function() {
				var t = T(this),
					e = n.filterSortByUrl(t);
				n.ajaxGetData(e).done(function(t) {
					n.hideLoading(), n.urlPushState(e), n.filterUpdate(t)
				})
			}), T(p).on("click", ".paira-list-grid:not(.active)", function() {
				var t = T(this),
					e = n.filterGridListUrl(t);
				n.ajaxGetData(e).done(function(t) {
					n.hideLoading(), n.urlPushState(e), n.filterUpdate(t)
				})
			}), T(p).on("click", ".paira-filter-checkbox", function() {
				var t = T(this),
					e = n.filterCheckBox(t);
				n.ajaxGetData(e).done(function(t) {
					n.hideLoading(), n.urlPushState(e), n.filterUpdate(t)
				})
			}), T(p).on("click", ".filter-show", function(t) {
				t.preventDefault(), T(".filters").slideToggle("slow")
			}), n.filterDefaultData()
		},
		quickView: function(t, e) {
			var a = '<a href="' + t.url + '">' + t.title + "</a>",
				i = t.price,
				r = t.compare_at_price,
				n = t.featured_image,
				o = t.vendor,
				s = t.type,
				p = t.available,
				c = t.images,
				l = t.variants,
				d = "",
				m = "",
				h = t.options,
				u = "",
				f = "",
				g = T("#paira-quickView-slider"),
				v = 1 == p ? "Yes" : "No",
				y = e.parents(".paira-product").find(".paira-rating-con").html(),
				w = e.parents(".paira-product").find(".paira-list-product-des").text(),
				x = e.parents(".paira-product").find(".paira-countdown"),
				k = '<a href="#" class="btn btn-default paira-add-to-cart" data-item-quantity="1" data-varient-id="' + l[0].id + '">' + j.dialogAddBtn + "</a>" + e.parents(".paira-product").find(".paira-wish-compare-con").html(),
				_ = i < r ? '<del class="margin-right-10"><span class="money">' + Shopify.formatMoney(r) + '</span></del> <span class="paira-quickView-default-price"><span class="money">' + Shopify.formatMoney(i) + "</span></span>" : '<span class="paira-quickView-default-price"><span class="money">' + Shopify.formatMoney(i) + "</span></span>";
			if (null != n && (n = Shopify.resizeImage(n, "grande"), T("#paira-quickView-image").attr("src", n)), T("#paira-quickView-title").html(a), T(".paira-quickView-switch").removeClass("hide"), T("#paira-quickView-details").text(w.substr(0, 130) + "..."), T("#paira-quickView-vendor").text(o), T("#paira-quickView-type").text(s), T("#paira-quickView-available").text(v), T("#paira-quickView-price").html(_), T("#paira-quickView-buttons").html(k), T(".paira-quickView-rating-con").html(y), T(".paira-quick-page").attr("href", t.url), x.length) {
				var b = "q-" + x.attr("id"),
					C = x.attr("data-day") ? x.attr("data-day") : 0,
					L = x.attr("data-month") ? x.attr("data-month") : 0,
					q = x.attr("data-year") ? x.attr("data-year") : 0,
					S = x.attr("data-hour") ? x.attr("data-hour") : 0,
					D = x.attr("data-min") ? x.attr("data-min") : 0;
				T("#paira-quickView-count .digit").text("0"), T("#" + b).length && (b += "1"), T("#paira-quickView-count ul").attr("id", b), T(".paira-progressbar").show(), T("#" + b).countDown({
					targetDate: {
						day: parseInt(C),
						month: parseInt(L),
						year: parseInt(q),
						hour: parseInt(S),
						min: parseInt(D),
						sec: 0
					},
					onComplete: function() {
						T("#paira-quick-view-dialog .paira-progressbar").hide()
					}
				})
			} else T(".paira-progressbar").hide();
			for (var P = 0; P < l.length; P++)
				if ("Default Title" == l[P].title && T(".paira-quickView-switch").addClass("hide"), f += '<option value="' + l[P].id + '">' + l[P].title + " - " + l[P].price + "</option>", l[P].featured_image)
					for (P = 0; P < l.length; P++) l[P].featured_image.src != m && (d += '<li class="paira-variant-image-' + l[P].option1.toLowerCase() + '" data-variant-image="' + l[P].featured_image.src + '"></li>', m = l[P].featured_image.src);
			T(".paira-quickView-variant-image").html(d), T(".paira-quickView-switch").html('<div class="paira-quickView-options" style="display: none;"><div class="select clearfix"><select id="paira-quickView-select" name="id"></select></div></div>'), T("#paira-quickView-select").html(f), new Shopify.OptionSelectors("paira-quickView-select", {
				product: t,
				onVariantSelected: quickViewCallBack
			});
			for (var V = 0; V < h.length; V++) T('.paira-quickView-options label[for="paira-quickView-select-option-' + V + '"]').text(h[V].name);
			T(".paira-quickView-options .selector-wrapper").each(function() {
				var p = T(this).find(".single-option-selector").attr("id"),
					c = T(this).find("label").text();
				T(".paira-quickView-switch").append('<div class="varient-box-style ' + p + ' margin-bottom-20" style="display: none;"><strong class="label-name-' + c.toLowerCase() + '">' + c + ':</strong><ul class="list-inline margin-top-0 top-name-' + c.toLowerCase() + '"></ul></div>'), T(this).find(".single-option-selector option").each(function(t, e) {
					var a = "",
						i = "white",
						r = "",
						n = T(this).val(),
						o = "";
					if (0 == t && (r = "active"), "Color" == c) {
						i = T(this).val(), o = "color-option-class";
						var s = T(".paira-variant-image-" + i.toLowerCase()).attr("data-variant-image");
						T("." + p + " ul").append('<li data-toggle="tooltip" data-placement="top" title="' + i + '" class="margin-top-5 ' + o + '"><button type="button" id="' + p + '" data-value="' + n + '" style="background-color: ' + i.toLowerCase() + ';" class="select_options ' + r + '"><span style="background: url(' + s + ')"></span></button></li>')
					} else "Default Title" == (a = T(this).text()) && T("#paira-quick-view-dialog .varient-box-style").addClass("hide"), T("." + p + " ul").append('<li class="margin-top-0 ' + o + '"><button type="button" id="' + p + '" data-value="' + n + '" style="background-color: ' + i.toLowerCase() + ';" class="select_options ' + r + '"><span>' + a + "</span></button></li>")
				}), 1 == h.length && ("Color" == h[0].name ? (T("#paira-quick-view-dialog .varient-box-style strong").text("Color:"), T(".paira-quickView-select-option-0 ul li").addClass("color-option-class"), T(".paira-quickView-select-option-0 button span").text("")) : T("#paira-quick-view-dialog .varient-box-style strong").hide())
			});
			for (var I = 0; I < c.length; I++) u += '<li class="swiper-slide"><a href="#" class="paira-quickView-sliderZoom" data-zoom-image="' + Shopify.resizeImage(c[I], "grande") + '"><img src="' + Shopify.resizeImage(c[I], "compact") + '" alt="" /></a></li>';
			g.html(u), T("#paira-quickView-slider").attr("style", " ");
			new Swiper(".swiper-container.paira-quickview-swiper", {
				navigation: {
					nextEl: ".swiper-button-next-quickview-swiper",
					prevEl: ".swiper-button-prev-quickview-swiper"
				},
				slidesPerView: 4,
				spaceBetween: 15,
				breakpoints: {
					1024: {
						slidesPerView: 4,
						spaceBetween: 15
					},
					768: {
						slidesPerView: 3,
						spaceBetween: 15
					},
					767: {
						slidesPerView: 2,
						spaceBetween: 15
					},
					480: {
						slidesPerView: 2,
						spaceBetween: 15
					}
				}
			})
		},
		initQuickView: function() {
			T(p).on("click", ".paira-quick-view", function(t) {
				t.preventDefault();
				var e = T(this),
					a = "/products/" + e.attr("data-handle") + ".js";
				n.ajaxGetData(a, "json").done(function(t) {
					n.quickView(t, e), "2" == j.optionSwitchDropdown ? T(".paira-quickView-options").show() : T(".varient-box-style").show(), n.hideLoading(), T("#paira-quick-view-dialog").modal("show")
				})
			}), T(p).on("click", ".paira-quickView-quantity-group .input-group-addon", function() {
				var t = T(this).attr("data-direction"),
					e = T(this).parent().children('input[type="text"]'),
					a = e.val();
				if ("up" == t) a++, e.val(a);
				else if ("down" == t) {
					if (1 == a) return;
					a--, e.val(a)
				}
				T("#paira-quickView-buttons .paira-add-to-cart").attr("data-item-quantity", e.val()), subTotal(T(".paira-quickView-single-quantity").val(), T(".paira-quickView-default-price .money").text(), T(".paira-quickView-subtotal .money"))
			}), T(p).on("click", ".paira-quickView-switch .select_options", function() {
				T(this).parents("ul").find(".select_options").removeClass("active"), T(this).addClass("active"), T(".selector-wrapper #" + T(this).attr("id")).val(T(this).attr("data-value")).trigger("change")
			}), T("#paira-quickView-sliderLoad").css("background", "url(" + j.animationLoading + ") 50% 50% no-repeat"), T(p).on("click", ".paira-quickView-sliderZoom", function(t) {
				t.preventDefault(), T("#paira-quickView-sliderLoad").show();
				var e = T(this).attr("data-zoom-image");
				n.ajaxGetData(e).done(function() {
					n.hideLoading(), T("#paira-quickView-image").attr("src", e), T("#paira-quickView-sliderLoad").hide()
				})
			})
		},
		initWelcomeDialog: function() {
			null == T.cookie("welcome_newsletter") && T("#paira-welcome-newsletter").modal("show"), T(p).on("click", "#paira-welcome-newsletter .close", function(t) {
				t.preventDefault(), T.cookie("welcome_newsletter", "no")
			}), null == T.cookie("coupon_dailog") && T("#paira-coupon-dailog").modal("show"), T(p).on("click", "#paira-coupon-dailog .close", function(t) {
				t.preventDefault(), T.cookie("coupon_dailog", "no")
			}), null == T.cookie("welcome_notification") && T(".notification-message").show(), T(p).on("click", ".notification-message-close", function(t) {
				t.preventDefault(), T.cookie("welcome_notification", "no"), T(".notification-message").fadeOut()
			})
		},
		pairaAnimation: function(t, i) {
			t.each(function() {
				var t = T(this),
					e = t.attr("data-paira-animation"),
					a = t.attr("data-paira-animation-delay");
				t.css({
					"-webkit-animation-delay": a,
					"-moz-animation-delay": a,
					"animation-delay": a
				}), (i || t).waypoint(function() {
					t.addClass("animated").addClass(e)
				}, {
					triggerOnce: !0,
					offset: "90%"
				})
			})
		},
		initPairaAnimation: function() {
			n.pairaAnimation(T(".paira-animation"))
		},
		initToolTip: function() {
			T('[data-toggle="tooltip"]').length && T('[data-toggle="tooltip"]').tooltip()
		},
		initIE10ViewPortHack: function() {
			"use strict";
			if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
				var t = p.createElement("style");
				t.appendChild(p.createTextNode("@-ms-viewport{width:auto!important}")), p.querySelector("head").appendChild(t)
			}
		},
		initStickyElements: function() {
			T(".paira-sticky-root").waypoint({
				handler: function(t) {
					T(".header-middle").toggleClass("paira-sticky", "down" == t), T(".header-top").toggleClass("paira-sticky", "down" == t)
				}
			})
		},
		initWindowLoadClass: function() {
			T(".paira-win-ready").show();
			var t = T(".main-slide .carousel-inner .item").height();
			T(".main-slide .carousel-inner iframe").height(t), T.getJSON("//ipapi.co/json/", function(t) {
				T(".paira-geo-country").html(t.country_name), T(".paira-country-flag").addClass("flag-" + t.country.toLowerCase()).show()
			});
			var e = T(".ins-img").height();
			T(".back").height(e)
		},
		initDomLoadClass: function() {
			T(".paira-dom-ready").show(), T(".product-page-templates-4 #paira-product-zoom").length && (T(".product-page-templates-4 #paira-product-zoom").elevateZoom({
				gallery: "paira-single-product-gallery",
				zoomType: "inner",
				easing: !0,
				cursor: "crosshair",
				loadingIcon: j.animationLoading,
				zoomWindowFadeIn: 500,
				zoomWindowFadeOut: 500
			}), T(".product-page-templates-4 #paira-product-zoom").bind("click", function(t) {
				var e = T(".product-page-templates-4 #paira-product-zoom").data("elevateZoom");
				return T.fancybox(e.getGalleryList()), !1
			})), T(p).on("input", "#instant-search", function(t) {
				t.preventDefault();
				var e = T(this).val();
				T(".search-loading").hide(), T(".instant-search-data ul").html(""), n.ajaxInstantSearch(e).done(function(t) {
					for (var e = "", a = 0; a < t.length; a++) e += '<li><a href="/products/' + t[a].handle + '"><div class="pull-left search-im"><img src="' + Shopify.resizeImage(t[a].featured_image, "240x240") + '" alt=""></div><div class="pull-left search-desc"><p class="product-title">' + t[a].title + '</p><p class="margin-bottom-0"><span class="money">' + Shopify.formatMoney(t[a].price, j.money_format) + "</span></p></div></a></li>";
					T(".search-loading").hide(), T(".instant-search-data").show(), T(".instant-search-data ul").html(e), n.currencyConvert()
				})
			}), T("body").bind("click", function() {
				T(".instant-search-data").hide(), T(".search-loading").hide()
			}), T(p).on("click", ".bars", function(t) {
				t.stopPropagation(), T(".sidebar").show("slow"), T(".fa-plus-circle").hide(), T(".fa-minus-circle").show(), T(this).addClass("barclose").removeClass("bars")
			}), T(p).on("click", ".barclose", function(t) {
				return t.stopPropagation(), T(".fa-minus-circle").hide(), T(".fa-plus-circle").show(), T(this).addClass("bars").removeClass("barclose"), T(".sidebar").hide("slow"), T("html, body").animate({
					scrollTop: 0
				}, 800), !1
			}), T(p).on("click", ".close-notify", function(t) {
				t.stopPropagation(), T(".paira-notify-container").fadeOut()
			}), T(p).on("click", ".close-notify-top", function(t) {
				t.stopPropagation(), T(".geo-container").fadeOut()
			}), T(p).on("click", ".paira-product-variant-img-small", function(t) {
				t.preventDefault();
				var e = T(this).attr("data-image-url");
				T(this).closest(".paira-collection-product-images").find(".paira-product-variant-img-small img").removeClass("active"), T(this).closest(".paira-product").find(".paira-product-image").attr("src", e).attr("srcset", ""), T(this).find("img").addClass("active")
			}), T(p).on("click", ".paira-variant-image-change", function(t) {
				t.preventDefault();
				var e = T(this).attr("data-variant-image");
				T(this).closest(".paira-product").find(".paira-product-image").attr("src", e).attr("srcset", ""), T(this).closest("ul").find("li").removeClass("active"), T(this).addClass("active")
			}), j.prettyPrint && prettyPrint(), T(p).on("click", ".paira-mega-menu .paira-dropdown-menu", function(t) {
				t.stopPropagation()
			}), T(".paira-mega-menu .paira-dropdown-menu").parent().hover(function() {
				var t = T(this).find("ul");
				if (T(t).offset().left + t.width() > T(j).width()) {
					var e = -T(t).width();
					t.css({
						left: e
					})
				}
			}), T(p).on("click", ".paira-mega-menu .paira-angle-down", function(t) {
				t.preventDefault(), T(this).parents(".paira-dropdown").find(".paira-dropdown-menu").toggleClass("active")
			}), T(p).on("click", ".paira-dropdown-menu .dropdown-submenu .fa-angle-down", function(t) {
				t.preventDefault(), T(this).parents("a").next().toggleClass("active-on")
			});
			var t = T("[data-toggle=collapse-side]"),
				e = t.attr("data-target"),
				a = t.attr("data-target-2");
			t.click(function() {
				T("body").toggleClass("hidden-sm-xs"), T("header").toggleClass("zindex-sm-xs"), T(e).toggleClass("in"), T(a).toggleClass("out")
			}), T(p).on("click", ".advanced-filter", function(t) {
				t.preventDefault(), T(".show-advanced-filter").toggleClass("filter-in-out")
			});
			var i = T(j).height() - 35;
			T(".show-advanced-filter .filter-product").css({
				"max-height": i + "px"
			}), T(".theme-editor__container #setting-header_style-0", j.parent.document).parents("label").find("img").remove(), T(".theme-editor__container #setting-header_style-1", j.parent.document).parents("label").find("img").remove(), T(".theme-editor__container #setting-header_style-2", j.parent.document).parents("label").find("img").remove(), T(".theme-editor__container #setting-header_style-3", j.parent.document).parents("label").find("img").remove(), T(".theme-editor__container #setting-header_style-4", j.parent.document).parents("label").find("img").remove(), T(".theme-editor__container #setting-header_style-5", j.parent.document).parents("label").find("img").remove(), T(".theme-editor__container #setting-header_style-6", j.parent.document).parents("label").find("img").remove(), T(".theme-editor__container #setting-header_style-0", j.parent.document).parents("label").append("<img style='margin: 5px 0 10px 0' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/header-1.png?v=1577006256'>"), T(".theme-editor__container #setting-header_style-1", j.parent.document).parents("label").append("<img style='margin: 5px 0 10px 0' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/header-2.png?v=1577006256'>"), T(".theme-editor__container #setting-header_style-2", j.parent.document).parents("label").append("<img style='margin: 5px 0 10px 0' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/header-3.png?v=1577006256'>"), T(".theme-editor__container #setting-header_style-3", j.parent.document).parents("label").append("<img style='margin: 5px 0 10px 0' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/header-4.png?v=1577006256'>"), T(".theme-editor__container #setting-header_style-4", j.parent.document).parents("label").append("<img style='margin: 5px 0 10px 0' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/header-5.png?v=1577006256'>"), T(".theme-editor__container #setting-header_style-5", j.parent.document).parents("label").append("<img style='margin: 5px 0 10px 0' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/header-6.png?v=1577006256'>"), T(".theme-editor__container #setting-header_style-6", j.parent.document).parents("label").append("<img style='margin: 5px 0 10px 0' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/header-7.png?v=1577006256'>"), T(".theme-editor__container #setting-product_page_style-0", j.parent.document).parents("label").find("img").remove(), T(".theme-editor__container #setting-product_page_style-1", j.parent.document).parents("label").find("img").remove(), T(".theme-editor__container #setting-product_page_style-2", j.parent.document).parents("label").find("img").remove(), T(".theme-editor__container #setting-product_page_style-3", j.parent.document).parents("label").find("img").remove(), T(".theme-editor__container #setting-product_page_style-4", j.parent.document).parents("label").find("img").remove(), T(".theme-editor__container #setting-product_page_style-5", j.parent.document).parents("label").find("img").remove(), T(".theme-editor__container #setting-product_page_style-0", j.parent.document).parents("label").append("<img style='margin: 5px 0 10px 0;border: 1px solid #ededed' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/product-page-1.png?v=1577006256'>"), T(".theme-editor__container #setting-product_page_style-1", j.parent.document).parents("label").append("<img style='margin: 5px 0 10px 0;border: 1px solid #ededed' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/product-page-2.png?v=1577006256'>"), T(".theme-editor__container #setting-product_page_style-2", j.parent.document).parents("label").append("<img style='margin: 5px 0 10px 0;border: 1px solid #ededed' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/product-page-3.png?v=1577006256'>"), T(".theme-editor__container #setting-product_page_style-3", j.parent.document).parents("label").append("<img style='margin: 5px 0 10px 0;border: 1px solid #ededed' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/product-page-4.png?v=1577006256'>"), T(".theme-editor__container #setting-product_page_style-4", j.parent.document).parents("label").append("<img style='margin: 5px 0 10px 0;border: 1px solid #ededed' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/product-page-5.png?v=1577006256'>"), T(".theme-editor__container #setting-product_page_style-5", j.parent.document).parents("label").append("<img style='margin: 5px 0 10px 0;border: 1px solid #ededed' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/product-page-6.png?v=1577006256'>"), T(".theme-editor__container .theme-editor__add-section .theme-editor__add-section-item", j.parent.document).each(function() {
				T(this).parent("li").find("img").remove(), "Banner With Text" == T(this).text() && T(this).parent("li").append("<img style='margin: 0 0 15px 0;' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/banner-with-text.png?v=1577006256'>"), "Grid Banner(Image,Video)" == T(this).text() && T(this).parent("li").append("<img style='margin: 0 0 15px 0;' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/grid-banner-image-video.png?v=1577006256'>"), "Icon Banner" == T(this).text() && T(this).parent("li").append("<img style='margin: 0 0 15px 0;' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/icon-banner.png?v=1577006256'>"), "Image & Text Banner" == T(this).text() && T(this).parent("li").append("<img style='margin: 0 0 15px 0;' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/image-text-banner.png?v=1577006256'>"), "Image & Text Slider" == T(this).text() && T(this).parent("li").append("<img style='margin: 0 0 15px 0;' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/image-text-slider.png?v=1577006256'>"), "Image Banner" == T(this).text() && T(this).parent("li").append("<img style='margin: 0 0 15px 0;' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/image-banner.png?v=1577006256'>"), "Image Hotspot Banner" == T(this).text() && T(this).parent("li").append("<img style='margin: 0 0 15px 0;' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/image-hotspot-banner.png?v=1577006256'>"), "Text Banner" == T(this).text() && T(this).parent("li").append("<img style='margin: 0 0 15px 0;' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/text-banner.png?v=1577006257'>"), "Blog Post Style 1" == T(this).text() && T(this).parent("li").append("<img style='margin: 0 0 15px 0;' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/blog-post-style-1.png?v=1577006256'>"), "Blog Post Style 2" == T(this).text() && T(this).parent("li").append("<img style='margin: 0 0 15px 0;' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/blog-post-style-2.png?v=1577006256'>"), "Collection List 1" == T(this).text() && T(this).parent("li").append("<img style='margin: 0 0 15px 0;' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/collection-list-1.png?v=1577006256'>"), "Collection List 2" == T(this).text() && T(this).parent("li").append("<img style='margin: 0 0 15px 0;' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/collection-list-2.png?v=1577006256'>"), "Custom Html" == T(this).text() && T(this).parent("li").append("<img style='margin: 0 0 15px 0;' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/custom-html.png?v=1577006256'>"), "Custom Page" == T(this).text() && T(this).parent("li").append("<img style='margin: 0 0 15px 0;' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/custom-page.png?v=1577006256'>"), "Custom Image Gallery" == T(this).text() && T(this).parent("li").append("<img style='margin: 0 0 15px 0;' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/custom-image-gallery.png?v=1577006256'>"), "Instagram" == T(this).text() && T(this).parent("li").append("<img style='margin: 0 0 15px 0;' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/instagram.png?v=1577006257'>"), "Custom Products List" == T(this).text() && T(this).parent("li").append("<img style='margin: 0 0 15px 0;' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/custom-products-list.png?v=1577006256'>"), "Products Grid" == T(this).text() && T(this).parent("li").append("<img style='margin: 0 0 15px 0;' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/products-grid.png?v=1577006257'>"), "Products Slider" == T(this).text() && T(this).parent("li").append("<img style='margin: 0 0 15px 0;' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/products-slider.png?v=1577006257'>"), "Products Tab" == T(this).text() && T(this).parent("li").append("<img style='margin: 0 0 15px 0;' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/products-tab.png?v=1577006257'>"), "Products With Banner" == T(this).text() && T(this).parent("li").append("<img style='margin: 0 0 15px 0;' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/products-with-banner.png?v=1577006257'>"), "Products With Sidebar" == T(this).text() && T(this).parent("li").append("<img style='margin: 0 0 15px 0;' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/products-with-sidebar.png?v=1577006257'>"), "Single Product" == T(this).text() && T(this).parent("li").append("<img style='margin: 0 0 15px 0;' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/single-product.png?v=1577006257'>"), "Small Products" == T(this).text() && T(this).parent("li").append("<img style='margin: 0 0 15px 0;' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/small-products.png?v=1577006257'>"), "Full Width Slider" == T(this).text() && T(this).parent("li").append("<img style='margin: 0 0 15px 0;' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/full-width-slider.png?v=1577006256'>"), "Grid Slider" == T(this).text() && T(this).parent("li").append("<img style='margin: 0 0 15px 0;' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/grid-slider.png?v=1577006256'>"), "Image Slider" == T(this).text() && T(this).parent("li").append("<img style='margin: 0 0 15px 0;' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/image-slider.png?v=1577006256'>"), "Slider With Banner" == T(this).text() && T(this).parent("li").append("<img style='margin: 0 0 15px 0;' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/slider-with-banner.png?v=1577006257'>"), "Slider With Menu" == T(this).text() && T(this).parent("li").append("<img style='margin: 0 0 15px 0;' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/slider-with-menu.png?v=1577006257'>"), "Testimonial Slider" == T(this).text() && T(this).parent("li").append("<img style='margin: 0 0 15px 0;' src='https://cdn.shopify.com/s/files/1/0266/0948/3811/files/testimonial-slider.png?v=1577006257'>")
			})
		}
	}
}(window.jQuery, window, document);